import i18n from 'i18next';
import { title } from 'process';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  lng: 'ko',
  fallbackLng: 'ko',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: {
        languageDetector: 'en',
        requestFailed: 'Request Failed. Please try again',
        pageLoadFailed: 'Page failed to load. Please refresh the page',
        signIn: 'Sign in',
        defaultModels: ['Sample Voice A (Male)'],
        yes: 'Yes',
        no: 'No',
        trainingCountText: 'Training Credits',
        genCountText: 'Gen Credits',
        appBar: {
          create: 'Create',
          account: 'Account',
          music: 'AI Music',
          speech: 'AI Speech',
          image: 'AI Image',
          video: 'AI Video',
          community: 'Community',
          history: 'History',
        },
        trainingTab: {
          title: 'AI Cover Training',
          tabs: ['Train', 'External'],
          stepOne: {
            title: 'Upload Audio Files',
            tooltip: {
              titleOne: 'Help',
              contentsOne: [
                'Quality over quantity. 15 minutes of high quality files is better than 30 minutes of low quality files',
                'Avoid soundtrack with excessive autotune',
                'Official soundtrack is recommended over live performance',
                'Avoid duet songs',
                'Use singing voice rather than conversational voice',
                'Training rap voice helps cover rap songs',
              ],
              titleTwo: 'When Recording Voice',
              contentsTwo: [
                'You may use any voice recording app on your mobile device',
                'You may upload multiple files. No need to record all at once',
                'Recording without background music recommended',
                'Songs recorded in karaoke are not recommended',
                'Please review your recorded voice before uploading',
              ],
            },
            trainingSubTitles: ['Please upload audio files for training'],
            externalSubTitles: ['Please upload external model files'],
            dragAndDropText: 'Drag and drop audio files',
            dragAndDropDuration: '({{minDuration}}-{{maxDuration}}min in total)',
            dragAndDropButton: 'Select Files',
            durationText: 'Total Duration',
            durationUnit: 'min',
            tabs: {
              fileUpload: {
                vocalExtractionText: 'Are these all vocal extracted?',
                vocalExtractionYes: 'Yes',
                vocalExtractionNo: 'No',
                vocalExtractionTooltip: {
                  title: 'What does this mean?',
                  contents: [
                    "Click 'Yes' only if vocals have already been extracted from all provided soundtracks.",
                    'Not applicable in most cases',
                  ],
                },
              },
            },
          },
          stepTwo: {
            title: 'Label Your Model',
            subTitles: ['Please label your AI voice model and start training'],
            placeholder: 'Give a label to your model',
          },
          submit: {
            upload: 'Upload',
            free: 'Please subscribe to train a voice model',
            inProgress: 'Training in progress',
            noRemaining: 'No remaining credit left',
            start: 'Start Training',
            uploading: 'Uploading. Please Wait',
            remainingCountText: 'Training Credits left',
            tooltip: {
              contents: [
                'Voice training takes about 0.5-1 hours.',
                'Training duration may differ by plans',
                "You can check the status in the 'History' tab",
              ],
            },
          },
          modal: {
            exceedModelCount:
              'The number of AI voices that can be retained has reached its limit. To proceed, please upgrade to more advanced plans or go to the history tab and remove your existing voice models',
            exceedMaxDuration: 'The total duration of audio files cannot exceed {{maxDuration}} minutes',
            minDuration: 'The total duration of audio files must be at least {{minDuration}} minutes',
            notSupportedFileType: 'This file format is not supported',
            imgModalConfirm: 'Start',
            imgModalCancel: 'Go Back',
            noLabel: 'Please add a label',
            missingFile: 'Please submit all files',
            noFile: 'Please upload files',
            longLabel: 'Label cannot exceed 25 characters',
          },
        },
        communityUploadTab: {
          title: 'Community Upload',
          tabs: [' share ', 'external'],
          stepOne: {
            tabs: {
              fileUpload: {
                dragAndDropText: 'Drag and drop file',
              },
            },
            title: 'Step 1: Upload Image',
            subTitles: ['Please upload an Image for your profile picture'],
          },
          stepTwo: {
            title: 'Step 2: Choose a Voice Model',
            trainingSubTitles: ['Please select a model you want to share'],
            externalSubTitles: ['Please upload a model you want to share'],
            dragAndDropText: ['Upload a Path file', 'Upload a Index file'],
            dragAndDropButton: 'Select File',
            voice: 'voice',
          },
          stepThree: {
            title: 'Step 3: Label the model',
            subTitle: 'Give a label to the model',
            genderLabel: 'Please choose a gender for the voice you want to share',
            gender: ['Male', 'Female'],
            anonymousText: 'Hide my username',
          },
          stepFour: {
            title: 'Step 4: Tag your model',
            subTitle: 'Please select appropriate tags for you model',
            tags: ['Genre', 'Country'],
          },
          submit: {
            upload: 'Share',
            start: 'Share',
            uploading: 'Uploading. Please Wait',
          },
          modal: {
            noImage: 'Please upload an image',
            noModel: 'Please select a voice model to share',
            noTag: 'Please select at least one tag for each field',
            noLabel: 'Please give a label',
            longLabel: 'Label cannot exceed 25 characters',
          },
        },
        inferenceTab: {
          title: 'AI Cover',
          stepOne: {
            tooltip: {
              title: 'Help',
              contents: [
                'The sound quality of the audio file is VERY important',
                'Recommend using offical soundtrack',
                'Do NOT recommend soundtracks with exccessive autotune',
                'Do NOT recommend duet songs',
              ],
            },
            title: 'Upload Your Target Music',
            subTitles: ['Please upload the song you want to cover'],
            tabs: {
              fileUpload: {
                title: 'File Upload',
                dragAndDropText: 'Drag and drop file',
                dragAndDropButton: 'Select File',
                dragAndDropDuration: '(Max 75 MB)',
                vocalExtractionText: 'Is this vocal extracted file?',
                vocalExtractionYes: 'Yes',
                vocalExtractionNo: 'No',
                vocalExtractionTooltip: {
                  title: 'What does this mean?',
                  contents: [
                    'Click “Yes” only if vocal has already been extracted from the soundtrack.',
                    'Not applicable in most cases',
                  ],
                },
              },
              youtube: {
                title: 'Youtube',
                linkPlaceholder: 'Max 10 minutes',
                linkbutton: 'Search',
                durationUnit: ['min', 'sec'],
              },
              recording: {
                title: 'Record',
                startButton: 'Start',
                saveButton: 'Save',
                recordingButton: 'Recording',
                userRecording: 'User Recording',
              },
              ttm: {
                title: 'AI Music',
                button: 'Select / Create AI Song',
              },
            },
          },
          stepTwo: {
            title: 'Select AI Voice Model',
            modelInput: {
              placeHolder: 'Select AI voice model',
              myModel: 'My Voices',
              defaultModel: 'Default Voices',
            },
            dragAndDropText: 'Click to find and select a model',
          },
          stepThree: {
            title: 'Configuration',
            subTitles: 'Choose mixer settings, output format, and label your cover.',
            labelInput: {
              placeHolder: 'Give a label to your cover',
            },
            ouputFormatLabel: 'Please select the output file format',
            tooltip: {
              outputFormatMessage: 'WAV format is for PRO/PREMIUM users only',
              upgradePrompt: 'Click here to upgrade',
              subscribePrompt: 'Click here to subscribe',
              title: 'What does this mean?',
              contents: ["If not set, it will be 'Voice - Source'", 'Can be changed later in History'],
            },
          },
          submit: {
            completedAndLoadingPlayer:
              "Inference completed. Loading audio player, but you may also download the song in the 'History' tab",
            alreadyInProgress: 'In Progress',
            noRemaining: 'No remaining credit for covers',
            start: 'Start',
            uploading: 'Uploading - Please wait a moment',
            tryAgain: 'Please try again.',
            tryAgainYoutubeDown: 'Please try again. If YouTube upload keeps failing, please use file upload instead.',
            inProgress: 'Converting - You may wait or leave the page and download the song in the "History" tab',
            remainingCountText: 'Gen Credits left',
            tooltip: {
              contents: [
                'AI cover takes approximately 1-4 minutes',
                'You may wait to play the music',
                "You can check the status in the 'History' tab",
              ],
            },
          },
          modal: {
            watermark:
              'Free version includes audio watermark. Watermark will disappear once you become paid subscriber',
            exceedModelCount:
              'The basic plan only allows you to have up to total 3 voice models. To proceed, please upgrade your plan or delete the existing model.',
            exceedMaxSize: 'You can only upload files up to 75MB',
            tooManyFiles: 'Only 1 file can be uploaded',
            notSupportedFileType: 'This file format is not supported',
            inProgress: 'Conversion in progress',
            noRemaining: 'No remaining cover credits left for this month',
            emptyYoutubeLink: 'Please upload the song you want to cover',
            noModalSelected: 'Please select a voice model',
            noLabel: 'Please add a label',
            invalidYoutubeLink: 'This is an incorrect YouTube link',
            youtubeLinkTooLong: 'The YouTube video may not exceed 10 minutes',
            longLabel: 'Label cannot exceed 100 characters',
          },
        },
        ttsInferenceTab: {
          title: 'Text To Speech',
          stepOne: {
            title: 'Select AI Voice Model',
            modelInput: {
              placeHolder: 'Select AI voice model',
              myModel: 'My Voices',
            },
            ttsTextAreaPlaceholder: "Type any text you'd like to convert into speech",

            dragAndDropText: 'Click to find and select a model',
          },
          stepTwo: {
            title: 'Enter text to convert',
          },
          submit: {
            completedAndLoadingPlayer:
              "TTS Inference completed. Loading audio player, but you may also download the speech in the 'AI Speech'-'History' tab",
            alreadyInProgress: 'In Progress',
            noRemaining: 'No remaining quota left for this month',
            start: 'Start',
            uploading: 'Uploading - Please wait a moment',
            tryAgain: 'Please Try Again',
            inProgress:
              'Converting - You may wait or leave the page and download the speech in the "AI Speech"-"History" tab',
            requiredCredits: 'Required credits',
            remainingCredits: 'Remaining credits',
            setting: 'Config',
          },
          modal: {
            selectModalTitle: 'AI Voices',
            addNewModelText: 'Click to make a new model',
            exceedTextSize: 'Can not convert more than {{characterLimitPerInference}} characters at a time',
            inProgress: 'Conversion in progress',
            noRemaining: 'No remaining quota left for this month',
            noModalSelected: 'Please select a voice model',
            noText: 'Please add text',
            variability: 'variability',
            stable: 'stable',
            variable: 'variable',
            similarity: 'similiarity',
            low: 'low',
            high: 'high',
            longLabel: 'Label cannot exceed 50 characters',
          },
        },
        ttiInferenceTab: {
          title: 'Text To Image',
          stepOne: {
            title: 'Select an image model and set its similarity (optional)',
            modelTag: ['People', 'Style'],
            plusButton: 'Click to find an image model',
            modelStrength: 'Similarity',
            duplicateModels: 'Duplicate models exist',
          },
          stepTwo: {
            title: 'Write a description for the image',
            subTitles: ['Describe the image that the AI will generate'],
            ttiTextAreaPlaceholder: 'Type your desired text and the AI will generate an image for you',
          },
          stepThree: {
            title: 'Generate Result Image',
            subtitle: '(Required generation credits: 2)',
          },
          ttiCommunityTab: {
            title: 'AI Image Models',
            categoryTab: ['My Models'],
            createNewModel: 'Create Image Model',
          },
          submit: {
            alreadyInProgress: 'In Progress',
            noRemaining: 'No remaining credits left for this month',
            start: 'Start',
            tryAgain: 'Please Try Again',
            requiredCredits: 'Credits Required',
            remainingCredits: 'Remaining Credits',
            setting: 'Setting',
            nsfwWarning: ['NSFW text detected', 'Three violations will block upload for 1 minute'],
            nsfwBlock: ['Repeated NSFW text detected', 'Upload blocked for 1 minute'],
            uploading: ['Uploading', 'Please wait a moment'],
            complete: ['TTI Inference completed', 'Loading images...'],
            inProgress: [
              'Converting',
              'You may wait or leave the page and download the image in the "History" tab',
              'Creation may take 1-5 minutes depending on the settings',
            ],
            inProgressNoTick: ['Converting', 'You may download the image in the "History" tab'],
          },
          modal: {
            exceedTextSize: 'Can not convert more than {{characterLimitPerInference}} characters at a time',
            inProgress: 'Conversion in progress',
            lackRemaining: 'Lack remaining credits',
            noText: 'Please add text',
            setting: 'Setting',
            ratio: 'Aspect Ratio',
            size: 'Size',
            quality: 'Quality',
            guidance: 'CFG Scale',
            watermark: 'Watermark',
            quantity: 'Quantity',
            horizontal: '16:9',
            vertical: '9:16',
            square: '1:1',
            small: 'Small',
            medium: 'Medium',
            large: 'Large',
            low: 'Low',
            moderate: 'Moderate',
            high: 'High',
            creative: 'Creative',
            balanced: 'Balanced',
            strict: 'Strict',
            on: 'On',
            off: 'Off',
            longLabel: 'Label cannot exceed 25 characters',
          },
          tooltip: {
            watermarkContents: [
              'Turning on the watermark adds the SoriSori logo to your image',
              'Only Pro or Premium users can disable the watermark',
            ],
            ratioContents: [
              'Choose the desired aspect ratio for your image',
              '16:9 (Horizontal): Ideal for widescreen displays, presentations, and landscape-oriented content',
              '9:16 (Vertical): Best for mobile content, stories, and portrait-oriented designs',
              '1:1 (Square): Perfect for social media posts, providing a balanced and versatile format',
            ],
            sizeContents: [
              'Choose the image size, based on the aspect ratio',
              '16:9 (Horizontal):',
              'Small: 640x360px - Suitable for lightweight contents',
              'Medium: 960x544px - Great for standard quality needs',
              'Large: 1280x720px - Perfect for high-quality displays',
              '9:16 (Vertical):',
              'Small: 360x640px - Ideal for mobile-friendly stories',
              'Medium: 544x960px - A good balance with enhanced clarity',
              'Large: 720x1280px - Best for full-screen mobile designs',
              '1:1 (Square):',
              'Small: 480x480px - Suitable for quick previews',
              'Medium: 720x720px - Excellent for social media posts with good resolution',
              'Large: 1080x1080px - Best for high-quality social media contents',
            ],
            guidanceContents: [
              'CFG (Classifier-Free Guidance) Scale determines the balance between creativity and adherence to the input prompt',
              'Creative (2.0): Prioritizes imaginative and diverse outputs, potentially deviating from the prompt',
              'Balanced (3.5): Strikes a harmony between creativity and prompt accuracy (Recommended)',
              'Strict (5.0): Ensures precise adherence to the prompt, with less creative flexibility',
            ],
            stepsConetents: [
              'The quality of the generated image depends on the time spent refining it',
              'Low (20 steps): Produces images quickly with basic details',
              'Medium (30 steps): Creates images with more detail and a good balance of quality',
              'High (40 steps): Generates the most detailed and refined images but takes more time',
            ],
            batchSizeContents: [
              'Quantity refers to the number of images to process at the same time',
              'The number of images you want to process simultaneously',
              '1: Processes one image at a time',
              '2: Processes two images at a time.',
              '3: Processes three images at a time',
              '4: Processes four images at once',
            ],
            coinContents: [
              '2 credits per image',
              'Requires extra credits based on the setting',
              'Max size costs 1 additional credit',
              'Max quality costs 1 additional credit',
              'Max cfg scale costs 1 additional credit',
            ],
          },
          dialog: {
            title: "Sorry, this feature isn't available for you",
            text: 'Upgrade to PRO or PREMIUM tier to get access to the setting feature!',
          },
        },
        ttsTrainingTab: {
          title: 'TTS Training',
          stepOne: {
            tooltip: {
              contentsOne: [
                'Quality over quantity. 5 minutes of high quality files is better than 10 minutes of low quality files',
                'Keep your training data clean and free from background noise.',
                'Use conversational voice rather than singing voice',
                'Each file should be smaller than 10mb',
                'A maximum of 10 files can be uploaded',
              ],
            },
            sizeLimitText: '(Each file should be smaller than 10mb)',
            numberLimitText: '(Up to 10 Files)',
            dragAndDropDuration: '({{minDuration}}sec-{{maxDuration}}min in total)',
            second: 'sec',
          },
          modal: {
            sizeTooLarge: 'Each file should be smaller than 10mb',
            tooManyFiles: 'A maximum of 10 files can be uploaded',
            duplicateFiles: "duplicate files can't be uploaded",
            exceedMaxDuration: 'The total duration of audio files cannot exceed {{maxDuration}} minutes',
            minDuration: 'The total duration of audio files must be at least {{minDuration}} seconds',
          },
          submit: {
            tooltip: {
              contents: [
                'Voice training takes about 0.5-10 minutes.',
                'Training duration may differ by plans',
                "You can check the status in the 'AI Speech'-'History' tab",
              ],
            },
          },
        },
        ttiTrainingTab: {
          title: 'Text To Image Training',
          stepOne: {
            title: 'Upload Image Files and Select Cover Image',
            dragAndDropText: 'Drag and drop image files',
            sizeLimitText: '(Max 10 MB each)',
            numberLimitText: ['(Min 5 Files ~ Up to ', ' Files)'],
            thumbnailTag: 'Thumbnail',
            nsfwBlockMessage:
              'Some of the uploaded images were detected as inappropriate and will not be used for training',
            tooltip: {
              contents: [
                'The more images you upload, the better the model quality',
                'Images containing inappropriate content will not be used for training',
              ],
            },
          },
          stepTwo: {
            title: 'Select Model Type',
            usage: ['Person', 'Style'],
            tooltip: {
              contents: [
                '"Person" models learn to generate images of people, animals, or objects (e.g., humans, cats, cars).',
                '"Style" models learn specific artistic styles or details to generate images (e.g., cartoon, watercolor, Studio Ghibli).',
              ],
            },
          },
          stepThree: {
            title: 'Set Training Quality',
            subTitles: 'Quality increases with larger numbers',
            sliderLabel: 'Training Quality',
            tooltip: {
              contents: [
                'A higher training quality value improves the overall model performance.',
                'Level-1 learning quality requires 500 training iterations, and each higher level adds another 500 iterations.',
                'Increasing training quality enhances the detail and fidelity of generated images.',
              ],
            },
          },
          stepFour: {
            title: 'Label Your Model',
            placeholder: 'Use a name that clearly describes the model',
            tooltipEx:
              '(e.g. Donald Trump, the 45th and 47th President of the United States, Hollywood actress Emma Watson)',
          },
          modal: {
            fileUpgrade: ['With your current plan, you can only upload up to ', ' files.'],
            stepUpgrade: 'With your current plan, you can only train up to 1 step.',
            upgradeButton: 'Upgrade Subscription',
            nsfwChecking: 'Uploading image files. Please wait a moment.',
            uploadSuccess: 'The model was successfully uploaded. You can view the created model in the "History" tab.',
            longLabel: 'The name cannot exceed 25 characters.',
          },
          submit: {
            tooltip: {
              contents: [
                'Training quality level 1 is free.',
                'Levels 2 and above are available only for Pro/Premium users.',
                'From level 2 onward, each increase in quality consumes 1 credit.',
                'AI image training takes 10~60 minutes, depending on file count and quality.',
              ],
            },
          },
        },
        ttsHistoryTab: {
          title: 'TTS History',
          tabs: {
            inference: {
              title: 'AI Speech',
            },
            training: {
              title: 'AI Voice',
            },
          },
          infoIcon: {
            voice: 'Voice',
            variability: 'variability',
            similarity: 'similarity',
          },
        },
        ttmInference: {
          title: 'Text To Music',
          stepOne: {
            title: 'Describe Your Style & Lyrics',
            promptMethod: {
              prompt: 'Prompt',
              tags: 'Tags',
              tooltip: {
                title: 'Style',
                contents: [
                  'Prompt: Enter a prompt to describe the style of music you want, generates more unique results',
                  'Tags: Select tags to describe the style of music you want, generates more accurate and consistent results',
                  'If left empty, style will be generated based on the lyrics',
                ],
              },
            },
            lyricMethod: {
              generate: 'Generate Lyrics',
              custom: 'Custom',
              tooltip: {
                title: 'Lyrics',
                contents: [
                  'Generate lyrics: Enter a prompt to describe the subject and style of lyrics you want',
                  'Custom: Enter your own lyrics, make sure to structure your lyrics with the provided labels',
                  'If left empty, lyrics will be generated based on the style',
                ],
              },
            },
            instrumental: 'Instrumental',
            noOptions: 'No options',
            placeholder: {
              prompt: 'Describe your style',
              tags: 'Search for tags',
              generateLyrics: 'Describe your lyrics',
              customLyrics: 'Enter your lyrics',
            },
            tooltip: {
              contents: [
                'Recommended to provide inputs for style and lyrics for a more accurate sound',
                'You can also skip style or lyrics and let AI generate them for you, based on your input',
                'If instrumental mode is on, you must provide a prompt or tags',
              ],
            },
          },
          stepTwo: {
            title: 'Create an AI Cover (optional)',
            selectVoice: 'Select AI Voice',
            tooltip: {
              contents: ['Costs 1 extra Gen Credit'],
            },
          },
          stepThree: {
            title: 'Output Settings',
            placeholder: 'Enter a label for your song',
            tooltip: {
              outputFormatMessage: 'WAV format is for PRO/PREMIUM users only',
              upgradePrompt: 'Click here to upgrade',
              subscribePrompt: 'Click here to subscribe',
            },
          },
          submit: {
            creditUsage: 'Gen Credits',
            info: ['Song generation takes 30-40 seconds', 'AI Cover will take an additional 1-4 minutes'],
            start: 'Start',
            alreadyInProgress: 'In Progress',
            uploading: 'Uploading - Please wait a moment',
            inProgress: 'Generating - You may wait or leave the page and download the song in the "History" tab',
            completedAndLoadingPlayer:
              'Song generation completed. Loading audio player, but you may also download the song in the "History" tab',
            completedCoverAndLoadingPlayer:
              'AI cover generation completed. Loading audio player, but you may also download the song in the "History" tab',
            tryAgain: 'Please try again',
            lackRemaining: 'Not enough remaining gen credits',
          },
          modal: {
            inProgress: 'Generation in progress',
            coverInProgress: 'AI cover generation in progress',
            lackRemaining: 'Not enough remaining gen credits',
            emptyParams: 'Please enter a prompt, tags, or lyrics',
            noLabel: 'Please add a label',
            longLabel: 'Label cannot exceed 100 characters',
          },
          selectModal: {
            generate: {
              title: 'Generate AI Song',
              button: 'Create',
            },
            history: {
              title: 'History',
              button: 'History',
              searchbar: 'Search',
            },
          },
        },
        videoEditorTab: {
          title: 'Video Editor',
          addSource: 'Source',
          tooltip: {
            hide: 'Hide source',
            mute: 'Mute source',
            move: 'Move source',
            scale: 'Resize source',
            resetScale: 'Reset source size',
            snap: 'Enable timeline snapping',
            addText: 'Add a text source',
            editText: 'Edit selected text',
            zoom: 'Zoom in/out timeline',
          },
          modal: {
            longLabel: 'Label cannot exceed 50 characters',
          },
        },
        addSourceModal: {
          title: 'Add a source',
          sourceOptions: ['AI Cover', 'TTS', 'Youtube', 'Upload'],
          searchbar: 'Search',
          pagination: {
            loader: 'Loading...',
          },
          voice: 'AI Voice',
          youtube: {
            placeholder: 'Max 10 minutes',
            button: 'Search',
            invalidYoutubeLink: 'This is an incorrect YouTube link',
            youtubeLinkTooLong: 'The YouTube video may not exceed 10 minutes',
          },
          upload: {
            dragAndDropText: 'Drag and drop a video/audio/image file',
            sizeLimitText: '(Max 75 MB)',
            acceptedAudio: '.mp3, .wav, .flac, and .ogg',
            acceptedVideo: '.mp4 and .mkv',
            acceptedImage: '.jpeg, .png, and .webp',
            button: 'Select file',
            notSupportedFileType: 'This file format is not supported',
            tooManyFiles: 'Please upload one file at a time',
            exceedMaxSize: 'You can only upload files up to 75MB',
          },
          loading: ['Uploading file', '(may take up to a minute for larger files)'],
        },
        textEditorModal: {
          title: ['Add text', 'Edit text'],
          placeholder: 'Type your text here...',
          add: 'Add',
          save: 'Save',
        },
        videoExportModal: {
          title: 'Export video',
          placeholder: 'Give your exported video a label',
          watermark: 'Show watermark',
          start: 'Start',
          rendering: [
            'You may wait or leave the page and download the video in the "History" tab',
            'Exporting your video (may take up to a minute)',
          ],
          success: ['Video is ready', 'Your download will start automatically. If not, click the button below.'],
          tooltip: {
            contents: [
              'Export time will depend on the length of your video',
              'You will be taken to the History tab where you can check the progress',
            ],
          },
          videoRenderError: 'Could not render the video. Please try again',
        },
        // faceSwapTab
        faceSwapTab: {
          title: 'Face Swap',
          stepOne: {
            title: 'Step 1: Upload and Trim Your Video',
            subTitles:
              'Please upload the video you want to perform face swapping on, and edit it to the desired segment',
            tags: {
              sourceFile: 'Source File',
            },
            dragAndDropText: 'Drag and drop file',
            dragAndDropButton: 'Select File',
            dragAndDropDuration: '(Max 75 MB)',
            dragAndDropFormat: '(Supported Formats: mp4, mov)',
            youtubeLinkText: 'Please enter the YouTube link you want',
            youtubeLinkInput: 'Enter the YouTube link here (Max 15 mins)',
            trimVideo: ['You do not have enough credits', 'Please trim the video to less than ', ' seconds'],
          },
          stepTwo: {
            title: 'Step 2: Select Faces You Want To Change',
            subTitles:
              'Please select faces you want to change from your video, and replace the selected face from the previous step with your desired face',
            tags: {
              preview: 'Preview',
              detectedFaces: 'Recognized Faces',
            },
            settings: {
              title: 'Settings',
              sharpness: 'Sharpness of the Swapped Face',
              blendRatio: 'Original-Swapped Image Blend Ratio',
              watermark: 'Watermark',
              leftCoin: ['You have ', ' credits left'],
              poorCoin: [
                'You are short of ',
                ' credits ',
                'Please reduce the number of faces',
                'or trim the video length',
              ],
              requiredCoin: ' credits required',
              blednRatioMarks: ['Very Low', 'Low', 'High', 'Very High'],
              originalVideo: 'Quality Enhancement Not Set',
              compareQuality: 'Blend Ratio Settings Comparison',
            },
          },
          stepThree: {
            title: 'Step 3: Face Swap Completed',
            subTitles: 'Check out the resulting image or video created by swapping faces',
            tags: {
              sourceFile: 'Final Video',
            },
          },
          button: {
            settings: 'Settings',
            start: 'Start',
            selectImage: 'Select Image',
            apply: 'Apply',
            createNew: 'Create New',
            preview: 'Preview',
            inProgress: 'In Progress',
            goToHistory: ['History', 'Check'],
            prev: 'Prev',
            next: 'Next',
            buyCredit: 'Buy Credits',
          },
          dialog: {
            upgradeText: 'Upgrade to PRO or PREMIUM tier to get access to remove the watermark!',
            faceSelectionModal: 'Choose A Face',
            renderingError: [
              'An error occurred while loading the result video',
              'The credits you used were not deducted',
            ],
            reload: 'Try Again',
            videoLabelPlaceholder: 'Enter video title',
            sharpnessOn: 'Upgrade to PRO or PREMIUM tier to get access to use Sharpness of the Swapped Face!',
          },
          loading: {
            1: 'Detecting faces ...',
            2: 'Finding faces ...',
            3: 'preparing the result video',
            4: 'preparing preview image',
            5: 'ready for the result video',
            youtubeLinkUpload: {
              1: 'We are processing your video.',
              2: 'Depending on its length, it may take between 1 to 4 minutes.',
            },
            finalVideoGenerating: [
              'Your video is currently being processed',
              "Depending on the video's length and the number of faces being transformed, this may take approximately 2-5 minutes",
              'Please wait until the process is complete to play the video immediately',
              "If you leave the screen before it's finished, you can still monitor the production status and download the video later from the 'History' tab",
            ],
          },
          error: {
            facesInImage: 'Error while processing the face images',
            invalidFileType: 'Please upload .png or .jpeg file',
            fileTooLarge: 'Please upload under 10MB',
            noFacesSelected: 'Please select at least one face you want to change',
            noFacesDetected: 'Please try again with a different image that clearly shows a face',
            noFacesFound: 'No face detected. Please upload a video containing a face and try again.',
            faceDetectApiError: 'Please check your internet connection and try again',
            showPreview: 'Error while showing preview',
            uploadFailed: 'Failed to upload the result video',
            renderingFailed: 'Failed to render the result video',
            pollingError: 'Error while polling',
            pollingTimeout: [
              'We apologize for the inconvenience.',
              'The server response is currently delayed.',
              'You can check and download the status of your ongoing creations in the "History" tab.',
              'If the creation fails, no credits will be deducted.',
            ],
            youtubeLinkTooLong: 'The YouTube video may not exceed 15 minutes',
            downloadFailed: 'Failed to download the result video',
            nsfwVideo: 'NSFW content detected',
          },
          submit: {
            tryAgain: 'Please try again',
          },
          modal: {
            inProgress: 'Conversion in progress',
            noRemaining: [
              'No remaining Faceswap credits left for this month',
              'Upgrade to PRO or PREMIUM tier, or purchase individual products to replenish your credits',
            ],
            longLabel: 'Label cannot exceed 50 characters',
          },
          tooltip: {
            sharpness: {
              1: 'It is a technology that enhances resolution by inserting new pixels between existing pixels in an image.',
              2: 'It can improve the sharpness of the face image you upload (upscaling).',
              3: 'As the upscaling value increases, the quality and clarity of the face image improve; however, if the background video quality is low, the face may appear unnatural.',
            },
            coinLogic: [
              'Credit Calculation Formula = (credits based on video length) x (Number of faces to change)',
              'Add 15 credits for every 15-second interval based on video length (e.g., 1~15 seconds -> 15 credits, 16~30 seconds -> 30 credits)',
              'Multiply by the number of faces to change (e.g., 14-second video, 2 faces to change -> 15 credits x 2 = 30 credits)',
            ],
            coinCal: [
              'Required number of credits = (Video length: ',
              'Required number of credits = (Video length: ',
              ' sec -> ',
              ' credit ) x ( Number of faces: ',
              ' credit ) x ( Number of faces: ',
              ' ) = ',
              ' credits',
            ],
            coin: 'credits',
            videoLength: 'Trimmed Length:',
            creditUsed: 'Required Credits:',
          },
        },
        // vocalExtractorTab
        vocalExtractorTab: {
          title: 'Vocal Extractor',
          stepOne: {
            title: 'Upload Audio Files',
            tabs: {
              fileUpload: {
                title: 'File Upload',
                dragAndDropText: 'Drag and drop file',
                dragAndDropButton: 'Select File',
                dragAndDropDuration: '(Max 75 MB each)',
              },
              youtube: {
                title: 'Youtube',
                linkPlaceholder: 'Max 10 minutes',
                linkbutton: 'Search',
                durationUnit: ['min', 'sec'],
              },
            },
            vocalExtractorSubTitles: ['Please upload audio file for the vocal extraction'],
            tooltip: {
              contents: [
                'Premium users can upload up to 10 files at a time',
                'Pro users can upload up to 5 files at a time',
                'Basic/Free users can upload 1 file at a time',
                'The total duration of audio files must not exceed 60 minutes',
              ],
            },
            maxUploadNumText: {
              premiumCustomAdmin: 'Upload up to 10 files',
              pro: 'Upload up to 5 files',
              basicFree: 'Upload up to 1 file',
            },
          },
          stepTwo: {
            title: 'Label Vocal Extract',
            labelInput: {
              placeHolder: 'Give a label to your vocal extract',
            },
          },
          stepThree: {
            subTitles: 'Choose output format and label your vocal extract',
            title: 'Select output file format',
            tooltip: {
              outputFormatMessage: 'WAV format is for PRO/PREMIUM users only',
              upgradePrompt: 'Click here to upgrade',
              subscribePrompt: 'Click here to subscribe',
            },
          },
          submit: {
            alreadyInProgress: 'In Progress',
            upload: 'Upload',
            inProgress: 'Converting - You may wait or leave the page and download the song in the "History" tab',
            noRemaining: 'Please subscribe for additional vocal extraction',
            start: 'Start',
            uploading: 'Uploading. Please Wait',
            tryAgain: 'Please Try Again',
            remainingCountText: 'Gen Credits left',
          },
          modal: {
            notSupportedFileType: 'This file format is not supported',
            invalidYoutubeLink: 'This is an incorrect YouTube link',
            youtubeLinkTooLong: 'The YouTube video may not exceed 10 minutes',
            noRemaining: 'Please subscribe to train additional voice model',
            emptyYoutubeLink: 'Please upload the song you want to remove the VocalExtract',
            inProgress: 'Removing in progress',
            exceedMaxSize: 'You can only upload files up to 75MB each',
            exceedMaxDuration: 'The total duration of audio files cannot exceed 60 minutes',
            premiumCustomManyFiles: 'Premium/Custom users can upload',
            proManyFiles: 'Pro users can upload',
            manyFiles: 'files at a time',
            noFiles: 'Please add a file for vocal extraction',
            lackRemaining: 'Please subscribe for additional vocal extraction',
            uploadStatusNotValid: 'Remaining credits lack or pending request',
            tryAgain: 'Please Try Again:',
            noLabel: 'Please give a label to your vocal extract',
            longLabel: 'Label cannot exceed 50 characters',
          },
        },
        historyTab: {
          title: 'History',
          inProgress: 'In Progress',
          failed: 'Failed',
          freeVersionTag: 'Free Trial',
          freePrefix: 'Free version includes SorisoriAI ads',
          tooltip: {
            contents: [
              'Generating an AI cover takes on average 1-4 minutes',
              'Voice training takes about 0.5-1 hours on average',
              'When failed, please reach out to support',
            ],
          },
          tabs: {
            inference: {
              title: 'AI Cover',
            },
            training: {
              title: 'AI Voice',
            },
            vocalExtract: {
              title: 'Vocal Extract',
            },
            community: {
              title: 'Community',
            },
            videoEditor: {
              title: 'Video Editor',
            },
            faceSwap: {
              title: 'Face Swap',
            },
            image: {
              title: 'AI Image',
              makeNewAIImage: 'Create New AI Image',
            },
            ttiTraining: {
              title: 'AI Image Model',
              makeNewTraining: 'Create New Image Model',
              style: 'Style',
              object: 'Object',
            },
            ttm: {
              title: 'AI Music',
            },
          },
          changeButton: 'Edit',
          cancelButton: 'Cancel',
          confirmModelDelete:
            'Are you sure you want to delete this model? Deleting a model will not restore available monthly training credit',
          confirmDelete: 'Are you sure you want to delete?',
          searchbar: 'Search',
          infoIcon: {
            source: 'Source',
            voice: 'Voice',
            pitch: 'Pitch',
            mixing: {
              title: 'Mixer settings',
              vocalLevel: 'Vocal Level',
              reverbLevel: 'Reverb Level',
              reverbLength: 'Reverb Length',
            },
            tts: {
              voice: 'Voice',
              variability: 'Variability',
              similarity: 'Similarity',
            },
            errorMessage: 'Error',
          },
          pagination: {
            loader: 'Loading...',
          },
          modal: {
            error: 'Please refresh the webpage',
            label: 'Label',
            username: 'Username',
            image: 'Image',
            filterError: 'Voice filter was not found',
          },
          trainingInfo: {
            files: 'Files used',
            extracted: 'Vocal extracted',
            shared: 'Shared to Community',
            yes: 'Yes',
            no: 'No',
            status: 'Status',
            errorFile: 'File with error',
          },
          voice: 'AI Voice',
          ttmInfo: {
            tags: 'Tags',
            prompt: 'Prompt',
            lyricPrompt: 'Lyric Prompt',
            lyrics: 'Lyrics',
            failed:
              "Text to Music has failed, please try again. If the issue persists, please contact SORISORI's support team.",
          },
          noOptions: 'No options',
          creations: {
            title: 'My Creations',
            tabs: [
              { title: 'AI Cover', tab: 'music' },
              { title: 'Text To Music', tab: 'ttm' },
              { title: 'Text To Speech', tab: 'speech' },
              { title: 'Text To Image', tab: 'image' },
              { title: 'Face Swap', tab: 'faceSwap' },
              { title: 'Vocal Extract', tab: 'vocalExtract' },
              { title: 'Video Editor', tab: 'videoEditor' },
            ],
          },
          models: {
            title: 'My Models',
            tabs: [
              { title: 'AI Cover Training', tab: 'music' },
              { title: 'TTS Training', tab: 'speech' },
              { title: 'TTI Training', tab: 'image' },
              { title: 'Community', tab: 'community' },
            ],
          },
        },
        subscriptionTab: {
          title: 'Subscription',
          pageTitleOne: 'Sorisori AI',
          popular: 'Most popular',
          cancel: {
            message: 'Are you sure you want to cancel subscription?',
            success: 'Subscription canceled successfully!',
            fail: 'Subscription cancel failed. Please try again.',
          },
          cancelChange: {
            message: 'Are you sure you want to undo subscription change?',
            success: 'Subscription change reverted successfully!',
            fail: 'Subscription change undo failed. Please try again.',
          },
          onetime: {
            message: 'Are you sure you want to purchase?',
            success: 'Purchased successfully!',
            fail: 'Purchase failed. Please try again.',
          },
          downgrade: {
            message: 'Are you sure you want to downgrade?',
            success: 'Subscription downgraded successfully!',
            fail: 'Subscription downgrade failed. Please try again.',
          },
          upgrade: {
            message:
              "Are you sure you want to upgrade? Once you click 'Pay', payment will be made with the existing payment method.",
            success: 'Subscription upgraded successfully!',
            fail: 'Subscription upgrade failed. Please try again.',
            paymentFailed: 'Payment failed. Please update the payment method from My Profile or try again.',
          },
          annualize: {
            message:
              "Are you sure you want to change to a lower tier yearly plan? Once you click 'Pay', payment will be made with the existing payment method.",
            success: 'Subscription changed successfully!',
            fail: 'Subscription change failed. Please try again.',
            paymentFailed: 'Payment failed. Please update the payment method from My Profile or try again.',
          },
          disabled: {
            tooltip: {
              contents: ['Yearly to monthly subscription transition is not available'],
            },
          },
          mobilePaymentRequired:
            'Since your subscription was set up in a mobile app, please manage subscription from a mobile app.',
          tabs: {
            subscription: {
              title: 'Subscription',
              pastDue: 'Payment Failed',
              month: 'month',
              monthly: 'Monthly',
              yearly: 'Yearly',
              upfront: 'Billed yearly',
              yearlyTag: '2 Months Free',
              subscribe: 'Subscribe',
              change: 'Change',
              currentTier: 'Current Tier',
              popular: 'Most Popular',
              value: 'Best Value',
              moreCredits: 'Need more credits?',
              discount: '80% discount on additional credits',
            },
            creditInfo: {
              title: 'How do credits work?',
              contents: [
                'Get new credits every month to use our AI generation and training services',
                'Credit usage will vary across services (see below)',
                'Credits reset every month and unused credits do not roll over to the next month (Additional credits purchased do not expire)',
              ],
            },
            creditUsage: {
              title: 'Cost per service',
              generation: 'Generation service',
              training: 'Training service',
              cost: 'Cost',
            },
          },
          paymentModal: {
            usePromoCode: 'Use promo code',
            promoCodePlaceholder: 'promo code',
            applyButton: 'apply',
            submit: 'Continue',
            promoCodeApplied: 'Promo code applied',
            invalidPromoCode: 'Invalid promo code',
            genericError: 'Could not complete the request. Please try again.',
            promoCodeError: {
              doesNotExist: 'Invalid promo code. Please check the code',
              invalidSubscriptionType: 'This promo code is only valid for PRO and PREMIUM plans',
              onlyFirstTime: 'This promo code is valid for first-time users only',
            },
          },
        },
        communityTab: {
          title: 'Community',
          subTitle: 'Select a voice to cover a song!',
          subtitleOne: '🔥Popular Models',
          subtitleTwo: 'Full List',
          inProgress: 'In Progress',
          tags: 'tags',
          failed: 'Failed',
          sortOptions: ['recent', 'likes', 'creations', 'label'],
          freeVersionTag: 'Free Trial',
          freePrefix: 'Free version includes SorisoriAI ads',
          voiceOptions: ['Community', 'My Voices', 'Favorites'],
          tooltip: {
            contents: [
              'Generating an AI cover takes on average 1-4 minutes',
              'Voice training takes about 0.5-1 hours on average',
              'When failed, please reach out to support',
            ],
          },
          tabs: {
            inference: {
              title: 'AI Cover',
            },
            training: {
              title: 'AI Voice',
            },
            vocalExtract: {
              title: 'Vocal Extract',
            },
          },
          changeButton: 'Edit',
          cancelButton: 'Cancel',
          confirmModelDelete:
            'Are you sure you want to delete this model? Deleting a model will not restore available monthly training credit',
          confirmInferenceDelete: 'Are you sure you want to delete?',
          confirmVocalExtractDelete: 'Are you sure you want to delete?',
          searchbar: 'Search',
          infoIcon: {
            source: 'Source',
            voice: 'Voice',
            pitch: 'Pitch',
          },
          pagination: {
            loader: 'Loading...',
          },
          modal: {
            error: 'Please refresh the webpage.',
            aihubError: 'This model has expired, please select another model.',
          },
          button: {
            share: 'share',
          },
        },
        supportTab: {
          title: 'Discord',
          link: 'https://discord.gg/AVREYrRZv4',
        },
        pipeline: {
          inferenceStatusMessage: {
            formatError: "The file format and extension don't match, or the file could be corrupted or unsafe",
            volumeError:
              "The vocal volume in the file is too low, or there's no voice in the file. Please check the recording settings or use audio editing software to increase the volume.",
            invalidFileError: "The file can't be opened. Please check the file.",
            invalidAihubModel: 'This model has expired, please select another model.',
            progress10: 'In progress 10%',
            progress20: 'In progress 20%',
            progress40: 'In progress 40%',
            progress50: 'In progress 50%',
            progress60: 'In progress 60%',
            progress80: 'In progress 80%',
            progress100: 'In progress 100%',
            complete: 'Complete',
            generalMessage:
              "AI Cover has failed. Please try again. If the issue persists, please contact SORISORI's support team",
            starting: 'Starting',
          },
          trainingStatusMessage: {
            formatError: "The file format and extension don't match, or the file could be corrupted or unsafe",
            volumeError:
              "The vocal volume in the file is too low, or there's no voice in the file. Please check the recording settings or use audio editing software to increase the volume.",
            invalidFileError: "The file can't be opened. Please check the file.",
            progress10: 'In progress 10%',
            progress20: 'In progress 20%',
            progress40: 'In progress 40%',
            progress50: 'In progress 50%',
            progress60: 'In progress 60%',
            progress80: 'In progress 80%',
            progress100: 'In progress 100%',
            complete: 'Complete',
            generalMessage:
              "Training has failed. Please try again. If the issue persists, please contact SORISORI's support team",
            starting: 'Starting',
          },
        },
        modal: {
          confirmationPay: 'Pay',
          confirmationCancel: 'Cancel',
          confirmationYes: 'Yes',
          confirmationNo: 'No',
          combined: 'Combined',
          backVocal: 'Back Vocal',
          vocal: 'Vocal',
          instrument: 'Instrumental',
          song: 'Song',
          cover: 'AI Cover',
          fileUploadFail: 'Could not upload the files. Please check the files and try again',
          trainingInProgressError: 'Training already in progress',
          noRemainingError: 'No remaining credit left',
          genericError: 'Could not complete the request. Please try again',
          pageLoadFail: 'Could not load the page, plase refresh the page',
          pageLoadFailOnSubmit:
            "Successfully uploaded files, but could not reload the page. Please refresh the page. You can still check the status in the 'History' tab",
          gotoProfile: 'Go to My Profile',
          youtubeDownloadLink: 'Youtube Download Link',
          youtubeCountryBlocked:
            'This video is not available in your current country due to copyright or regional restrictions.',
          youtubeCountryBlockedCopyright:
            'This video is not available in your current country due to copyright or regional restrictions.',
        },
        mixingModal: {
          label: 'Mix',
          title: 'Mixing',
          sliders: {
            contents: ['Vocal Pitch', 'Vocal Level', 'Reverb Level', 'Reverb Length'],
          },
          tooltip: {
            contents: [
              '-4 to -6 recommended when covering a female song with a male voice',
              '+4 to +6 recommended when covering a male song with a female voice',
              'Excessive pitch adjustment may lower the sound quality',
              'Loudness of the vocals',
              '0db is the loudness of the original vocals',
              'Strength of the reverb effect',
              '0 removes reverb effect, 6 creates strong reverb effect',
              'Length of the reverb effect in seconds',
              '2s recommended for ballads, shorter length recommended for faster songs',
            ],
          },
          demo: {
            toggle: 'Mix',
            status: ['Unmixed', 'Mixed'],
            description: 'Hear the difference between unmixed and mixed vocals',
          },
          dialog: {
            title: "Sorry, this feature isn't available for you",
            text: 'Upgrade to PRO or PREMIUM tier to get access to the mixing feature!',
          },
          upgradeButton: ['Upgrade to ', 'PRO'],
          alert: 'You must set a value for each mixer',
        },
        freeInferenceMessageModal: {
          messeageOne: ['Free version contains ads', 'and is limited to 45 seconds'],
          messeageTwo: ['Use paid products to generate', 'a full length ad free song'],
          button: 'Subscribe',
        },
        youtubeReenabledModal: {
          title: 'YouTube feature is back!',
          description: 'You can now create AI covers using YouTube links again.',
          confirm: 'OK',
          hideFor3Days: "Don't show again for 1 day",
        },
        freeTrainingMessageModal: {
          messages: ['AI training will be available', 'once you subscribe or buy', 'onetime product'],
          button: 'Subscribe',
        },
        freeVocalExtractorMessageModal: {
          free: {
            message: ['Free users', 'can upload 1 file at a time', 'Upgrade to upload more'],
          },
          basic: {
            message: ['Basic users', 'can upload 1 file at a time', 'Upgrade to upload more'],
          },
          button: 'Subscribe',
        },
        onetimeItems: [
          {
            type: 'GEN_CREDIT_5',
            name: '5 Gen Credits',
            discount: {
              strikethrough: '5',
              name: '25 Gen Credits',
              type: 'GEN_CREDIT_25_PRO',
            },
            price: {
              usd: '$5',
              thb: '฿130',
              krw: '₩5,000',
              jpy: '¥590',
            },
          },
          {
            type: 'GEN_CREDIT_25',
            name: '25 Gen Credits',
            discount: {
              strikethrough: '25',
              name: '150 Gen Credits',
              type: 'GEN_CREDIT_150',
            },
            price: {
              usd: '$25',
              thb: '฿650',
              krw: '₩25,000',
              jpy: '¥2950',
            },
          },
          {
            type: 'TRAINING_CREDIT_1',
            name: '1 Training Credit',
            price: {
              usd: '$7',
              thb: '฿250',
              krw: '₩8,500',
              jpy: '¥990',
            },
          },
          {
            type: 'TRAINING_CREDIT_5',
            name: '5 Training Credits',
            discount: {
              strikethrough: '5',
              name: '7 Training Credits',
              type: 'TRAINING_CREDIT_7',
            },
            price: {
              usd: '$35',
              thb: '฿1250',
              krw: '₩42,500',
              jpy: '¥4950',
            },
          },
        ],
        subscriptionItems: [
          {
            name: 'FREE',
            model: 'FREE',
            monthlyRate: {
              usd: '$0',
              thb: '฿0',
              krw: '₩0',
              jpy: '¥0',
            },
            features: [
              {
                name: '2 AI Covers',
              },
              {
                name: '2 Vocal Extracts',
              },
              {
                name: '25 TTS characters',
              },
              {
                name: 'One 15 sec Face Swap video',
              },
              {
                name: '5 TTI generations',
              },
            ],
          },
          {
            name: 'BASIC',
            model: 'BASIC',
            monthlyRate: {
              usd: '$9.99',
              thb: '฿279',
              krw: '₩14,800',
              jpy: '¥1,699',
            },
            yearly: {
              model: 'BASIC_YEARLY',
              monthlyRate: {
                usd: '$8.30',
                thb: '฿233',
                krw: '₩12,333',
                jpy: '¥1,417',
              },
            },
            features: [
              {
                name: '150 Gen Credits',
                usage: [
                  'Up to 150 AI Covers',
                  'Up to 150 Vocal Extracts',
                  'Up to 1500 TTS characters',
                  'Up to 150 sec of Face Swap',
                  'Up to 75 TTI generations',
                ],
              },
              {
                name: '2 Training credits',
                usage: ['Up to 2 AI voices', 'Up to 2 TTS voices'],
              },
              {
                name: 'Speed: Slow',
              },
              {
                name: 'Train Quality: Medium',
              },
              {
                name: 'Sound Quality: Normal (MP3)',
              },
            ],
          },
          {
            name: 'PRO',
            model: 'PRO',
            monthlyRate: {
              usd: '$24.80',
              thb: '฿619',
              krw: '₩28,800',
              jpy: '¥3,490',
            },
            yearly: {
              model: 'PRO_YEARLY',
              monthlyRate: {
                usd: '$20.70',
                thb: '฿516',
                krw: '₩24,000',
                jpy: '¥2,908',
              },
            },
            features: [
              {
                name: '1000 Gen credits',
                usage: [
                  'Up to 1000 AI Covers',
                  'Up to 1000 Vocal Extracts',
                  'Up to 10000 TTS characters',
                  'Up to 1000 sec of Face Swap',
                  'Up to 500 TTI generations',
                ],
              },
              {
                name: '5 Training credits',
                usage: ['Up to 5 AI cover voices', 'Up to 5 TTS voices'],
              },
              {
                name: 'Speed: Fast',
              },
              {
                name: 'Train Quality: High',
              },
              {
                name: 'Sound Quality: High (WAV)',
              },
              {
                name: 'Discount on additional products',
              },
            ],
          },
          {
            name: 'PREMIUM',
            model: 'PREMIUM',
            monthlyRate: {
              usd: '$68.80',
              thb: '฿1680',
              krw: '₩88,800',
              jpy: '¥8,990',
            },
            yearly: {
              model: 'PREMIUM_YEARLY',
              monthlyRate: {
                usd: '$57.30',
                thb: '฿1400',
                krw: '₩73,333',
                jpy: '¥7,490',
              },
            },
            features: [
              {
                name: '5000 Gen credits',
                usage: [
                  'Up to 5000 AI Covers',
                  'Up to 5000 Vocal Extracts',
                  'Up to 50000 TTS Characters',
                  'Up to 5000 sec of Face Swap',
                  'Up to 2500 TTI generations',
                ],
              },
              {
                name: '20 Training credits',
                usage: ['Up to 20 AI voices', 'Up to 20 TTS voices'],
              },
              {
                name: 'Speed: Very Fast',
              },
              {
                name: 'Train Quality: Best',
              },
              {
                name: 'Sound Quality: High (WAV)',
              },
              {
                name: 'Discount on additional products',
              },
            ],
          },
        ],
        costPerService: {
          generation: [
            {
              name: 'AI Cover',
              cost: '1 Gen Credit',
            },
            {
              name: 'Vocal Extract',
              cost: '1 Gen Credit',
            },
            {
              name: 'Text to Speech',
              cost: '10 characters per Gen Credit',
            },
            {
              name: 'Face Swap',
              cost: '15 Gen Credits per face, per 15s',
            },
            {
              name: 'Text to Image',
              cost: '2+ Gen Credits',
            },
          ],
          training: [
            {
              name: 'TTS Voice Model',
              cost: '1 Training Credit',
            },
            {
              name: 'AI Voice Model',
              cost: '1 Training Credit',
            },
          ],
        },
        subscriptionComparison: {
          // title: 'Compare Subscriptions',
          title: 'Subscription Comparison',
          headers: {
            feature: 'Feature',
            inference: 'AI Cover',
            faceSwap: 'Face Swap',
            tti: 'Text to Image',
            row: ['FREE', 'BASIC', 'PRO', 'PREMIUM'],
          },
          subscription: [
            {
              feature: 'Gen Credit Value',
              row: [
                '-', // FREE
                '$0.1 per credit', // BASIC
                '$0.025 per credit', // PRO
                '$0.013 per credit', // PREMIUM
              ],
            },
            {
              feature: 'Training Credit Value',
              row: ['-', '$5 per credit', '$3.6 per credit', '$2.75 per credit'],
            },
            {
              feature: 'Speed',
              row: ['Slow', 'Medium', 'Fast', 'Very Fast'],
            },
            {
              feature: 'Training Quality',
              row: ['Low', 'Good', 'Very Good', 'Best'],
            },
            {
              feature: 'Discount on additional credits',
              row: ['-', '-', '-80%', '-80%'],
            },
          ],
          inference: [
            {
              feature: 'Pitch Change',
              row: ['Y', 'Y', 'Y', 'Y'],
            },
            {
              feature: 'AI Mixing',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'MP3',
              row: ['Y', 'Y', 'Y', 'Y'],
            },
            {
              feature: 'WAV (HQ)',
              row: ['N', 'N', 'Y', 'Y'],
            },
          ],
          faceSwap: [
            {
              feature: 'Video Enhancement',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'Watermark Removal',
              row: ['N', 'N', 'Y', 'Y'],
            },
          ],
          tti: [
            {
              feature: 'Maximum Quality',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'Maximum Size Setting',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'CFG Scale Setting',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'Watermark Removal',
              row: ['N', 'N', 'Y', 'Y'],
            },
          ],
        },
        faqTab: {
          title: 'FAQ',
          placeholder: 'Type to Search...',
          faqs: [
            {
              title: 'AI Training Questions',
              qnas: [
                {
                  question: 'What kind of file types are supported?',
                  answers: [
                    'Six file types are supported: mp3, wav, m4a, mkv, mp4, flac, ogg. It is crucial to obtain high-quality original audio sources. Converting files may result in loss of audio quality. The m4a extension corresponds to the format used by mobile phone recorders.',
                  ],
                },
                {
                  question: 'Is Vocal Extraction Necessary?',
                  answers: [
                    'The training process of Sorisori AI includes an excellent automatic vocal extraction feature. There is no need to extract the vocal separately; however, this process helps you to evaluate the quality of the extracted vocals before training.',
                  ],
                },
                {
                  question: 'Can I upload multiple songs?',
                  answers: [
                    'Yes, you can upload multiple files. Similarly, if you record manually, uploading multiple divided recordings is acceptable.',
                  ],
                },
                {
                  question: 'Recommended Microphone for Recording',
                  answers: [
                    'The voice recorder on your phone is sufficient. However, it is recommended to record in a quiet environment without accompaniment.',
                  ],
                },
                {
                  question: 'Uploading Songs Recorded in Karaoke Rooms',
                  answers: [
                    'It is not recommended due to the typically low audio quality and strong sound effects in karaoke recordings.',
                  ],
                },
                {
                  question: 'Voice Quality',
                  answers: [
                    'After recording, always check if your voice is recorded well. Sometimes, issues may arise if the microphone is too close or too far.',
                    '',
                  ],
                },
                {
                  question: 'If I delete a model, can I train again?',
                  answers: ['Deleting does not restore training opportunities'],
                },
              ],
            },
            {
              title: 'AI Cover Related Questions',
              qnas: [
                {
                  question: 'Cancellation During Training',
                  answers: [
                    'Check the file type of the audio file. Ensure that file extensions are appropriately converted during the process.',
                  ],
                },
                {
                  question: 'What kind of file types are supported?',
                  answers: [
                    'Six file types are supported: mp3, wav, m4a, mkv, mp4, flac, ogg. It is crucial to obtain high-quality original audio sources. Converting files may result in loss of audio quality. The m4a extension corresponds to the format used by mobile phone recorders.',
                  ],
                },
                {
                  question: 'Is Vocal Extraction Necessary?',
                  answers: [
                    'The training process of Sorisori AI includes an excellent automatic vocal extraction feature. There is no need to extract the vocal separately; however, this process helps you to evaluate the quality of the extracted vocals beforehand.',
                  ],
                },
                {
                  question: 'Narration Cover',
                  answers: ['Yes, narration can be covered.'],
                },
                {
                  question: 'Download Issue in Production Records Tab',
                  answers: [
                    'Try using standard browsers, including Chrome, Safari, Firefox, etc., as some apps might cause download issues.',
                  ],
                },
              ],
            },
            {
              title: 'AI Cover Production Tips',
              qnas: [
                {
                  question: 'Audio Quality Importance',
                  answers: [
                    'AI cover quality heavily depends on audio quality. We recommend purchasing official audio file for the best results.',
                  ],
                },
                {
                  question: 'Avoid Effects and Strong Choruses',
                  answers: [
                    'Avoid heavily processed audio with effects or strong choruses, as they may complicate clean vocal separation.',
                  ],
                },
                {
                  question: 'Harmonies',
                  answers: ['Avoid songs with multiple singers or heavy harmonies.'],
                },
              ],
            },
            {
              title: 'Payment Related Questions',
              qnas: [
                {
                  question: 'Upgrade Fee Calculation',
                  answers: ['The upgrade fee is the difference between the two subscription plans.'],
                },
                {
                  question: 'Canceling Subscription',
                  answers: [
                    '- Subscriptions can be cancelled from the profile page',
                    '- Profile page can be reached by clicking "Change" button on the free plan card on subscription page or by clicking username on the naviagtion bar',
                  ],
                },
                {
                  question: 'Only use it for current month?',
                  answers: [
                    'If you cancel your subscription using the method above, you can continue to use it for the rest of current month.',
                  ],
                },
                {
                  question: 'Carrying Over Unused Models and Covers',
                  answers: [
                    'Unused models/covers do not carry over to the next month. It resets to the allocated count each month',
                  ],
                },
                {
                  question: 'Card Payment Issues',
                  answers: [
                    'As of December 20th 2024, internationally approved cards, Korean domestic cards and KakaoPay is supported. If you continue to have issues with payment, you need to contact your bank or card issuer',
                  ],
                },
                {
                  question: 'Refund Policy',
                  answers: [
                    'The conditions for a refund are as follows:',
                    '- Individual products are non-refundable.',
                    '- You must not have any usage records for that month.',
                    '- Refund requests must be made within three weeks (21 days) from the date of payment.',
                    '- A refund fee of $3 is incurred regardless of the plan.',
                    '- You must cancel the subscription yourself. Subscriptions can be cancelled from the profile page.',
                    '- The profile page can be accessed by clicking the "Change" button on the free plan card on the subscription page or by clicking the username on the navigation bar.',
                  ],
                },
                {
                  question: 'How long does it take to process a refund?',
                  answers: [
                    'Based on the day of inquiry, it typically takes 5-8 business days for credit cards, and it may be slightly shorter for KakaoPay.',
                  ],
                },
              ],
            },
            {
              title: 'Other Questions',
              qnas: [
                {
                  question: 'Deleting Account',
                  answers: [
                    'Contact via Discord for guidance or wait for the upcoming feature allowing users to withdraw directly.',
                  ],
                },
                {
                  question: 'What is Discord?',
                  answers: [
                    'Discord is a community where SoundSound AI users can exchange information, share work, and receive evaluations.',
                  ],
                },
              ],
            },
          ],
        },
        contactTab: {
          title: 'Contact Us',
          placeholder: {
            type: 'Contact Type',
            email: 'Email',
            text: 'Message',
            refund:
              "Refund Policy.\n\n1. Individual products are non-refundable.\n2. You must not have any usage records for that month.\n3. Refund requests must be made within three weeks (21 days) from the date of payment.\n4. A refund fee of $3 is incurred regardless of the plan.\n5. You must cancel the subscription yourself. Subscriptions can be cancelled from the profile page.\n6. The profile page can be accessed by clicking the 'Change' button on the free plan card on the subscription page or by clicking the username on the navigation bar.",
          },
          message: {
            deleteAccount:
              'Deleting your account is permanent. Active web subscriptions will be canceled automatically, but mobile subscriptions must be canceled via your app store.',
            confirmDeleteAccount: "Type 'DELETE' to confirm.",
            deleteConfirm: 'Delete Account',
            accountDeletedMessage: 'Your account has been deleted successfully. You will now be logged out.',
            type: 'Please select a contact type',
            email: 'Please enter a valid email',
            content: 'Please enter a message',
            loading: 'Submitting request. Please wait.',
            success: 'Inquiry submitted successfully',
            refundSuccess: 'Refund request submitted successfully. Please check your email for the status.',
            fail: 'Could not submit the inquiry. Please try again.',
            useDiscord:
              'Please refer to the FAQ or use Discord community for questions regarding training/cover functionality',
          },
          contactType: [
            'Training/Cover Functionality',
            'API Inquiry',
            'Refund',
            'Delete Account',
            'Other Business Inquiry',
          ],
          submit: 'Submit',
        },
        emailPreferenceTab: {
          title: 'Email Preference',
          header: 'Stay connected for exclusive offers, new features, and special announcements. Never miss a beat!',
          choiceLabels: {
            announcement: 'Announcement',
            notification: 'Notification',
            newsletter: 'Newsletter',
            promotion: 'Promotion',
          },
          submit: {
            save: 'Save',
          },
          modal: {
            success: 'Saved successfully',
            error: 'Something went wrong. Please Try Again',
          },
        },
        profileTab: {
          title: 'My Profile',
          sections: {
            login: {
              title: 'Account',
              logout: 'Log out',
            },
            payment: {
              title: 'Payment',
              changePayment: 'Change payment',
              updateSubscription: 'Update subscription',
              cancelSubscriptionChange: 'Undo subscription change',
              history: 'View payment history',
              cancel: 'Cancel subscription',
              currentSubscription: 'Current subscription',
              nextPaymentDate: 'Next billing date',
              currentCycle: 'Current cycle',
              nextCreditResetDate: 'Next credit reset date',
              nextSubscriptionType: 'Next cycle subscription',
            },
            question: {
              title: 'Questions',
              contentPre: 'Please use the ',
              contentLink: 'Contact Us',
              contentPost: ' tab for questions regarding payment/refund',
            },
          },
          subscriptionType: {
            FREE: 'FREE',
            BASIC: 'BASIC',
            PRO: 'PRO',
            PREMIUM: 'PREMIUM',
            BASIC_YEARLY: 'BASIC (YEARLY)',
            PRO_YEARLY: 'PRO (YEARLY)',
            PREMIUM_YEARLY: 'PREMIUM (YEARLY)',
          },
        },
        paymentModal: {
          title: 'Payment History',
          date: 'date',
          info: 'info',
          amount: 'amount',
        },
      },
    },
    ko: {
      translation: {
        languageDetector: 'ko',
        requestFailed: '다시 시도해 주시기 바랍니다',
        pageLoadFailed: '페이지 로딩에 실패하였습니다. 새로고침을 해주세요',
        signIn: '로그인',
        defaultModels: ['샘플 음성 A(남)'],
        yes: '예',
        no: '아니오',
        trainingCountText: '학습 크레딧',
        genCountText: '생성 크레딧',
        appBar: {
          create: '제작',
          account: '내 계정',
          music: 'AI 음악',
          speech: 'AI 문자음성 변환',
          image: 'AI 이미지',
          video: 'AI 영상',
          community: '커뮤니티',
          history: '제작기록',
        },
        trainingTab: {
          title: 'AI 음성 학습',
          tabs: ['직접 학습', '외부 모델'],
          stepOne: {
            title: '음성 업로드',
            tooltip: {
              titleOne: '업로드 도움말',
              contentsOne: [
                '양보단 질. 저품질 30분 보단 고품질 15분 음원',
                '오토튠 같은 과도한 음향 효과가 들어간 곡은 X',
                '라이브 음원보단 정식음원 추천',
                '꼭! 솔로곡 만을 사용',
                '대화음성보다는 가창음성을 사용',
                '랩 커버를 원하는 경우 랩 음원 추천',
              ],
              titleTwo: '직접 녹음을 하는 경우',
              contentsTwo: [
                '휴대폰 녹음기도 사용 가능',
                '한번에 모두 녹음할 필요 X',
                '무반주 녹음을 추천',
                '코인노래방 녹음은 X',
                '업로드전 녹음이 잘 되었는지 확인필수!',
              ],
            },
            trainingSubTitles: ['학습시킬 음성 파일들을 업로드해주세요'],
            externalSubTitles: ['외부 모델 파일들을 업로드해주세요'],
            dragAndDropText: '파일을 끌어서 놓기',
            dragAndDropDuration: '(총합 {{minDuration}}~{{maxDuration}}분)',
            dragAndDropButton: '파일 선택',
            durationText: '음원 길이 총합',
            durationUnit: '분',
            tabs: {
              fileUpload: {
                vocalExtractionText: '보컬만 추출한 파일들인가요?',
                vocalExtractionYes: '예',
                vocalExtractionNo: '아니요',
                vocalExtractionTooltip: {
                  title: '보컬 추출 관련 도움말',
                  contents: ['보컬 추출된 음원들인 경우에만 "예" 클릭', '일반적인 음원들인 경우 해당사항 없음'],
                },
              },
            },
          },
          stepTwo: {
            title: '이름 정하기',
            subTitles: ['AI음성의 이름을 정하시고 학습을 시작 해주세요'],
            placeholder: 'AI음성의 이름을 정해주세요',
          },
          submit: {
            upload: '업로드',
            free: '구독서비스를 이용해주세요',
            inProgress: '학습중',
            noRemaining: '사용 가능한 학습 크레딧이 없습니다',
            start: '학습 시작',
            uploading: '업로드 중입니다',
            remainingCountText: '남은 학습 크레딧',
            tooltip: {
              contents: [
                '음성학습은 0.5-1시간 소요됩니다',
                '사용자가 몰리는경우 길어질 수 있습니다',
                '"제작 기록"탭에서 상태를 확인하실 수 있습니다',
              ],
            },
          },
          modal: {
            exceedModelCount:
              '무료/기본 요금제에서는 최대 3개의 음성 모델만 보유 가능합니다. 요금제를 업그레이드 하시거나 기존 모델중 하나를 삭제해주세요.',
            exceedMaxDuration: '{{maxDuration}}분 이상 음악 파일을 업로드 할수 없습니다.',
            minDuration: '최소 {{minDuration}}분 이상 음악 파일을 업로드 해주세요',
            notSupportedFileType: '지원되지 않은 파일 형식 입니다',
            imgModalConfirm: '시작하기',
            imgModalCancel: '돌아가기',
            noLabel: '이름을 넣어 주세요',
            missingFile: '모든 파일을 넣어주세요',
            noFile: '파일을 업로드 해주세요',
            longLabel: '이름은 25자를 넘을 수 없습니다',
          },
        },
        communityUploadTab: {
          title: '모델 공유',
          tabs: [' 내 모델 ', '외부 모델'],
          stepOne: {
            title: '1단계:이미지 업로드',
            subTitles: ['모델에 어울리는 사진을 올려주세요'],
            tabs: {
              fileUpload: {
                dragAndDropText: '파일을 끌어서 놓기',
              },
            },
          },
          stepTwo: {
            title: '2단계: 목소리 모델 고르기',
            trainingSubTitles: ['목소리를 골라 주세요'],
            externalSubTitles: ['목소리 모델 파일을 업로드 해 주세요 '],
            dragAndDropText: ['Path 파일 업로드', 'Index 파일 업로드'],
            dragAndDropButton: '파일 선택',
            voice: '목소리',
          },
          stepThree: {
            title: '3단계: 이름 정하기',
            subTitle: '모델의 이름을 정해주세요',
            genderLabel: '모델의 성별을 선택해 주세요',
            gender: ['남자', '여자'],
            anonymousText: '닉네임 숨기기',
          },
          stepFour: {
            title: '4단계: 모델에 태그 달기',
            subTitle: '모델에 어울리는 태그들을 달아주세요',
            tags: ['장르', '나라'],
          },
          submit: {
            upload: '업로드',
            start: '모델 공유',
            uploading: 'Uploading. Please Wait',
          },
          modal: {
            noImage: '이미지를 업로드 해주세요',
            noModel: '목소리를 골라주세요',
            noTag: '모델에 어울리는 태그들을 달아주세요',
            noLabel: '모델의 이름을 정해주세요',
            longLabel: '이름은 25자를 넘을 수 없습니다',
          },
        },
        inferenceTab: {
          title: 'AI 커버 제작',
          stepOne: {
            tooltip: {
              title: 'AI커버 제작 도움말',
              contents: [
                '음원의 음질은 결과물에 매우 중요',
                '음원 사이트에서 정식구매한 음원을 추천',
                '오토튠같은 음향효과가 많은 곡은 X',
                '화음이 많은 곡은 비추천',
              ],
            },
            title: '노래 업로드',
            subTitles: ['커버 하려는 곡을 업로드 해주세요'],
            tabs: {
              fileUpload: {
                title: '파일업로드',
                dragAndDropText: '파일을 끌어서 놓기',
                dragAndDropButton: '파일 선택',
                dragAndDropDuration: '(최대 75 MB)',
                vocalExtractionText: '보컬만 추출한 파일인가요?',
                vocalExtractionYes: '예',
                vocalExtractionNo: '아니요',
                vocalExtractionTooltip: {
                  title: '보컬 추출 관련 도움말',
                  contents: ['이미 보컬 추출된 음원인 경우에만 “예" 클릭', '일반적인 음원의 경우 해당사항 없음'],
                },
              },
              youtube: {
                title: '유튜브 링크',
                linkPlaceholder: '10분 미만만 가능',
                linkbutton: '사용하기',
                durationUnit: ['분', '초'],
              },
              recording: {
                title: '음성녹음',
                startButton: '녹음 시작',
                saveButton: '저장',
                recordingButton: '녹음중',
                userRecording: '유저 음성녹음',
              },
              ttm: {
                title: 'AI 작곡',
                button: 'AI음악을 선택/제작 해보세요',
              },
            },
          },
          stepTwo: {
            title: 'AI음성을 선택해주세요',
            modelInput: {
              placeHolder: 'AI음성을 선택',
              myModel: '내 모델',
            },
            dragAndDropText: '목소리 모델을 찾기위해 클릭',
          },
          stepThree: {
            title: '설정',
            subTitles: '믹싱값, 파일확장자, 파일이름을 설정해주세요',
            labelInput: {
              placeHolder: '이름을 정해 주세요',
            },
            tooltip: {
              outputFormatMessage: 'WAV 파일은 프로/프리미엄 사용자에게만 해당됩니다',
              upgradePrompt: '여기를 클릭하여 업그레이드하세요',
              subscribePrompt: '여기를 클릭하여 구독하세요',
              title: 'AI 커버 이름 설정 관련 도움말',
              contents: ['직접 정하지 않을 경우 "음성 - 출처" 설정', '이후 제작기록에서 변경 가능'],
            },
          },
          submit: {
            completedAndLoadingPlayer:
              '제작 완료. 오디오 플레이어 로딩중 입니다. 대기하지 않으셔도 "제작기록"탭에서 다운로드 가능합니다',
            alreadyInProgress: '커버 제작중',
            noRemaining: '사용 가능한 횟수를 모두 사용하였습니다',
            start: '변환 시작',
            uploading: '업로드 중입니다 잠시만 기다려 주세요',
            tryAgain: '다시 시도해 주세요.',
            tryAgainYoutubeDown: '다시 시도해 주세요. 유튜브 업로드가 계속 실패하면 파일 업로드를 이용해 주세요',
            inProgress:
              '변환중입니다. 제작이 완료될때까지 대기하시면 음원을 바로 재생 할 수 있으며 대기하지 않으셔도 "제작기록"탭에서 제작 상태 확인 및 다운로드가 가능합니다',
            remainingCountText: '남은 생성 크레딧',
            tooltip: {
              contents: [
                'AI커버 제작은 약 1-4분 소요 됩니다',
                '사용자가 몰리는경우 약간 길어질 수 있습니다',
                '"제작 기록"탭에서 상태를 확인하실 수 있습니다',
              ],
            },
          },
          modal: {
            watermark: '무료버전에는 음성 워터마크가 포함되어있습니다. 유료전환시 워터마크는 사라지게됩니다',
            exceedModelCount:
              '기본 요금제에서는 최대 3개의 음성 모델만 보유 가능합니다. 진행하시려면 기존 모델을 삭제해주세요.',
            exceedMaxSize: '최대 75MB 파일만 업로드 가능합니다',
            tooManyFiles: '파일 1개만 업로드 가능합니다',
            notSupportedFileType: '지원되지 않은 파일 형식 입니다',
            inProgress: '이미 학습중입니다.',
            noRemaining: '학습 가능 횟수를 모두 사용 하였습니다',
            emptyYoutubeLink: '커버하실 곡을 업로드 해주세요',
            noModalSelected: '음성모델을 선택 해주세요',
            noLabel: '이름을 넣어 주세요',
            invalidYoutubeLink: '올바르지 않은 유튜브 링크입니다.',
            youtubeLinkTooLong: '10분 이상 유튜브 음악을 업로드 할수 없습니다.',
            longLabel: '이름은 100자를 넘을 수 없습니다',
          },
        },
        ttsInferenceTab: {
          title: 'AI 문자음성 변환',
          stepOne: {
            title: 'AI음성을 선택해주세요',
            modelInput: {
              placeHolder: 'AI음성을 선택',
              myModel: '내 모델',
            },
            ttsTextAreaPlaceholder: '원하는 글을 작성 하시면 음성으로 변환해 드립니다',

            dragAndDropText: '목소리 모델을 찾기위해 클릭',
          },
          stepTwo: {
            title: '변환할 텍스트 입력',
          },
          submit: {
            completedAndLoadingPlayer:
              '제작 완료. 오디오 플레이어 로딩중 입니다. 대기하지 않으셔도 "AI 문자음성변환"-"제작기록"탭에서 다운로드 가능합니다',
            alreadyInProgress: '변환중',
            noRemaining: '사용 가능한 글자수를 모두 사용하였습니다',
            start: '변환 시작',
            uploading: '업로드 중입니다 잠시만 기다려 주세요',
            tryAgain: '다시 시도 해주세요.',
            inProgress:
              '변환중입니다. 제작이 완료될때까지 대기하시면 음원을 바로 재생 할 수 있으며 대기하지 않으셔도 "AI 문자음성변환"-"제작기록"탭에서 제작 상태 확인 및 다운로드가 가능합니다',
            requiredCredits: '필요한 생성 크레딧',
            remainingCredits: '남은 생성 크레딧',
            setting: '설정',
          },
          modal: {
            selectModalTitle: 'AI 음성',
            addNewModelText: '새 음성 만들기',
            exceedTextSize: '한번에 변환 가능한 글자 수를 초과했습니다. 글자수 : {{characterLimitPerInference}}',
            inProgress: '이미 학습중입니다',
            noRemaining: '이번 달에 사용가능한 한도를 초과하였습니다',
            noModalSelected: '음성모델을 선택 해주세요',
            noText: '문자를 입력해 주세요',
            variability: '변동성',
            stable: '단조로움',
            variable: '변동적',
            similarity: '유사도',
            low: '낮음',
            high: '높음',
            longLabel: '이름은 50자를 넘을 수 없습니다',
          },
        },
        ttiInferenceTab: {
          title: 'AI 이미지 생성',
          stepOne: {
            title: '이미지 모델을 선택하고, 모델의 유사도을 설정해주세요 (선택)',
            modelTag: ['인물', '스타일'],
            plusButton: '이미지 모델을 찾기 위해 클릭',
            modelStrength: '유사도',
            duplicateModels: '중복된 모델이 있습니다',
          },
          stepTwo: {
            title: '이미지에 대한 설명을 작성해주세요',
            subTitles: ['AI가 생성할 이미지를 설명해주세요'],
            ttiTextAreaPlaceholder: '원하는 글을 작성 하시면 AI가 이미지를 생성해 드립니다',
          },
          stepThree: {
            title: '결과 이미지 생성',
            subtitle: '(필요한 생성 크레딧: 2)',
          },
          ttiCommunityTab: {
            title: 'AI 이미지 모델',
            categoryTab: ['내 모델'],
            createNewModel: '이미지 모델 만들기',
          },
          submit: {
            alreadyInProgress: '진행중',
            noRemaining: '이번 달에 남은 생성 크레딧이 없습니다',
            start: '변환 시작',
            tryAgain: '다시 시도 해주세요',
            requiredCredits: '필요한 크레딧',
            remainingCredits: '남은 생성 크레딧',
            setting: '설정',
            nsfwWarning: ['부적절한 내용이 감지되었습니다', '세번 연속으로 감지될 경우 1분간 차단이 됩니다'],
            nsfwBlock: ['부적절한 내용을 연속적으로 입력하셨습니다', '1분간 이용이 차단됩니다'],
            uploading: ['업로드 중입니다', '잠시만 기다려 주세요'],
            complete: ['제작 완료', '이미지 로딩중...'],
            inProgress: [
              '변환중입니다',
              '현재 페이지에서 대기하시거나 "제작기록"탭에서 제작상태 확인 및 다운로드가 가능합니다',
              '제작은 세팅에 따라 1-5분까지 걸릴 수 있습니다',
            ],
            inProgressNoTick: ['변환중입니다', '"제작기록"탭에서 제작 상태 확인 및 다운로드가 가능합니다'],
          },
          modal: {
            exceedTextSize: '한 번에 {{characterLimitPerInference}}자 이상 변환할 수 없습니다',
            inProgress: '변환중입니다',
            lackRemaining: '남은 크레딧이 부족합니다',
            noText: '텍스트를 입력해 주세요',
            setting: '설정',
            ratio: '비율',
            size: '크기',
            quality: '품질',
            guidance: 'CFG 스케일',
            watermark: '워터마크',
            quantity: '수량',
            horizontal: '16:9',
            vertical: '9:16',
            square: '1:1',
            small: '소',
            medium: '중',
            large: '대',
            low: '하',
            moderate: '중',
            high: '상',
            creative: '창의적',
            balanced: '균형',
            strict: '엄격',
            on: 'On',
            off: 'Off',
            longLabel: '이름은 25자를 넘을 수 없습니다',
          },
          tooltip: {
            watermarkContents: [
              '워터마크를 켜면 이미지에 SoriSori 로고가 추가됩니다',
              '프로 또는 프리미엄 사용자만 워터마크를 비활성화할 수 있습니다',
            ],
            ratioContents: [
              '원하시는 이미지 비율을 선택해주세요',
              '16:9 (가로): 와이드스크린 디스플레이, 프레젠테이션 및 가로 방향 콘텐츠에 이상적입니다',
              '9:16 (세로): 모바일 콘텐츠, 스토리 및 세로 방향 디자인에 적합합니다',
              '1:1 (정사각형): 소셜 미디어 게시물에 완벽하며, 균형 잡힌 다목적 이미지를 제공합니다',
            ],
            sizeContents: [
              '이미지 비율에 따른 이미지 크기를 선택해주세요',
              '16:9 (가로):',
              '소: 640x360px - 간단한 콘텐츠 제작에 최적화되어 있습니다',
              '중: 960x544px - 표준 크기에 적절합니다',
              '대: 1280x720px - 고품질 디스플레이에 적합합니다',
              '9:16 (세로):',
              '소: 360x640px - 모바일 친화적인 스토에 이상적입니다',
              '중: 544x960px - 향상된 선명도로 좋은 균형을 제공합니다',
              '대: 720x1280px - 전체 화면 모바일 디자인에 최적화되어 있습니다',
              '1:1 (정사각형):',
              '소: 480x480px - 빠른 미리보기에 적합합니다',
              '중: 720x720px - 좋은 해상도로 소셜 미디어 게시물에 탁월합니다',
              '대: 1080x1080px - 고품질 소셜 미디어 콘텐츠에 최적화되어 있습니다',
            ],
            guidanceContents: [
              'CFG(Classifier-Free Guidance) 스케일은 AI 창의성과 입력 텍스트 준수 사이의 균형을 결정합니다',
              '창의적 (2.0): 상상력이 풍부하고 다양한 출력을 우선시하며, 텍스트에서 벗어날 수 있습니다',
              '균형 (3.5): 창의성과 텍스트 정확성 사이의 조화를 이룹니다 (추천)',
              '엄격 (5.0): 텍스트를 정확히 준수하며, 창의적 유연성은 줄어듭니다',
            ],
            stepsConetents: [
              '생성된 이미지의 품질은 정제하는 데 소요된 시간에 따라 달라집니다',
              '낮음 (20 steps): 기본적인 품질으로 빠르게 이미지를 생성합니다',
              '중간 (30 steps): 더 많은 세부 사항과 좋은 품질으로 이미지를 생성합니다',
              '높음 (40 steps): 가장 상세하고 정제된 이미지를 생성하지만 시간이 더 걸립니다',
            ],
            batchSizeContents: [
              '수량은 동시에 처리할 이미지의 수를 나타냅니다',
              '생성하시고 싶은 이미지의 수를 선택해주세요',
              '1: 한 번에 한 개의 이미지를 생성합니다',
              '2: 한 번에 두 개의 이미지를 생성합니다',
              '3: 한 번에 세 개의 이미지를 생성합니다',
              '4: 한 번에 네 개의 이미지를 생성합니다',
            ],
            coinContents: [
              '이미지 한개 당 2 생성 크레딧이 필요합니다',
              '설정에 따라 추가 생성 크레딧이 필요할수 있습니다',
              '최대 크기는 1 생성 크레딧을 추가합니다',
              '최대 품질은 1 생성 크레딧을 추가합니다',
              '최대 CFG 스케일은 1 생성 크레딧을 추가합니다',
            ],
          },
          dialog: {
            title: '이 기능은 사용하실 수 없습니다',
            text: '설정 기능을 추가하시려면 프로 또는 프리미엄 등급으로 업그레이드해주세요!',
          },
        },
        ttsTrainingTab: {
          title: 'AI 문자음성 학습',
          stepOne: {
            tooltip: {
              contentsOne: [
                '양보단 질. 저품질 10분 보단 고품질 5분 음원',
                '배경 소음이 없는 깨끗한 음성 데이터를 사용',
                '가창음성보다는 대화음성을 사용',
                '10mb 보다 작은 파일만 업로드 가능',
                '최대 10개의 파일을 업로드 가능',
              ],
            },
            sizeLimitText: '(각 파일은 10MB보다 작아야 합니다)',
            numberLimitText: '(최대 10개의 파일)',
            dragAndDropDuration: '(총합 {{minDuration}}초 이상 {{maxDuration}}분 미만)',
            second: '초',
          },
          modal: {
            sizeTooLarge: '각 파일은 10MB보다 작아야 합니다.',
            tooManyFiles: '최대 10개의 파일까지만 업로드할 수 있습니다.',
            duplicateFiles: '중복된 파일을 업로드할 수 없습니다.',
            exceedMaxDuration: '{{maxDuration}}분 이상 음악 파일을 업로드 할수 없습니다.',
            minDuration: '최소 {{minDuration}}초 이상 음악 파일을 업로드 해주세요',
          },
          submit: {
            tooltip: {
              contents: [
                '음성학습은 0.5-10분 소요됩니다',
                '사용자가 몰리는경우 길어질 수 있습니다',
                "'AI 문자음성변환'-'제작 기록'탭에서 상태를 확인하실 수 있습니다",
              ],
            },
          },
        },
        ttiTrainingTab: {
          title: 'AI 이미지 학습',
          stepOne: {
            title: '이미지 업로드 및 대표이미지 선택',
            dragAndDropText: '파일을 끌어서 놓기',
            sizeLimitText: '(각 파일은 10MB보다 작아야 합니다)',
            numberLimitText: ['(최소 5개 ~ 최대 ', '개의 파일)'],
            thumbnailTag: '대표이미지',
            nsfwBlockMessage:
              '업로드한 파일 중 일부에서 부적절한 이미지가 감지되어 해당 이미지는 학습에 사용되지 않습니다.',
            tooltip: {
              contents: [
                '이미지를 많이 업로드할수록 모델의 퀄리티가 향상됩니다',
                '업로드한 이미지 중 부적절한 내용이 포함된 이미지는 학습에 사용되지 않습니다',
              ],
            },
          },
          stepTwo: {
            title: '모델 종류 정하기',
            usage: ['인물', '스타일'],
            tooltip: {
              contents: [
                '"인물" 모델은 사람/동물/사물 등의 이미지를 학습하여 생성합니다 (예: 사람, 고양이, 자동차 등)',
                '"스타일" 모델은 화풍, 디테일 등 이미지의 특정 스타일을 학습하여 생성합니다 (예: 만화, 수채화, 지브리 등)',
              ],
            },
          },
          stepThree: {
            title: '학습 퀄리티 설정',
            subTitles: '숫자가 클수록 학습 퀄리티가 향상됨',
            sliderLabel: '학습 퀄리티',
            tooltip: {
              contents: [
                '학습 퀄리티의 숫자가 커질수록 학습 퀄리티가 향상됩니다',
                '학습 퀄리티 1단계는 500회의 학습을 거치며, 단계가 하나 올라갈 때마다 학습 횟수가 500회씩 증가합니다.',
                '학습 퀄리티가 향상되면 이미지 모델로 생성한 이미지의 디테일과 품질이 높아집니다',
              ],
            },
          },
          stepFour: {
            title: '모델 이름 정하기',
            placeholder: '모델을 충분히 설명할 수 있는 이름이 좋습니다',
            tooltipEx: 'ex) 미국 45, 47대 대통령 도널드 트럼프, 할리우드 배우 엠마 왓슨 등',
          },
          modal: {
            fileUpgrade: ['현재 요금제로는 최대 ', '개의 파일까지만 업로드 할 수 있습니다'],
            stepUpgrade: '현재 요금제로는 최대 1단계까지만 학습할 수 있습니다',
            upgradeButton: '요금제 변경',
            nsfwChecking: '이미지 파일을 업로드 중입니다. 잠시만 기다려주세요.',
            uploadSuccess: '모델이 성공적으로 업로드 되었습니다. 제작된 모델은 "제작기록" 탭에서 확인하실 수 있습니다.',
            longLabel: '이름은 25자를 넘을 수 없습니다',
          },
          submit: {
            tooltip: {
              contents: [
                '학습 퀄리티 1단계는 무료로 제공됩니다',
                '학습 퀄리티 2단계부터는 프로/프리미엄 사용자만 이용 가능합니다',
                '학습 퀄리티 2단계부터, 학습 퀄리티가 1단계 향상할 때마다 1 크레딧이 추가됩니다',
                'AI 이미지 학습은 이미지 파일 갯수와 학습 퀄리티에 따라 10-60분 소요됩니다',
              ],
            },
          },
        },
        ttmInference: {
          title: 'AI 작곡',
          stepOne: {
            title: '음악의 스타일과 가사를 설명해주세요',
            promptMethod: {
              prompt: '프롬프트',
              tags: '태그',
              tooltip: {
                title: '스타일',
                contents: [
                  '프롬프트: 원하는 음악 스타일을 설명하는 문장을 입력하세요. 보다 독창적인 결과를 얻을 수 있습니다',
                  '태그: 원하는 음악 스타일을 설명하는 태그를 선택하세요. 보다 정확하고 일관된 결과를 얻을 수 있습니다',
                  '입력하지 않을 경우, 스타일은 가사를 기반으로 자동 생성됩니다',
                ],
              },
            },
            lyricMethod: {
              generate: 'AI가사 생성',
              custom: '직접 작성',
              tooltip: {
                title: '가사',
                contents: [
                  '가사 생성: 원하는 가사의 주제와 스타일을 설명하는 프롬프트를 입력하세요',
                  '직접 작성: 직접 가사를 입력할 수 있으며, 제공된 라벨에 맞춰 구조를 잘 잡아주세요',
                  '입력하지 않을 경우, 스타일을 기반으로 가사가 자동 생성됩니다',
                ],
              },
            },
            instrumental: '반주 버전',
            noOptions: '옵션 없음',
            placeholder: {
              prompt: '곡의 스타일을 설명해주세요',
              tags: '검색',
              generateLyrics: '가사의 주제를 정해주세요',
              customLyrics: '직접 쓴 가사를 넣어주세요',
            },
            tooltip: {
              contents: [
                '더 정확한 사운드를 원하신다면 스타일과 가사에 대한 정보를 입력하는 것을 추천드립니다',
                '스타일이나 가사를 입력하지 않아도 되며, 입력한 내용을 바탕으로 AI가 자동으로 생성할 수도 있습니다',
                '반주 모드가 켜져 있을 경우, 반드시 프롬프트나 태그를 입력해야 합니다',
              ],
            },
          },
          stepTwo: {
            title: 'AI커버를 제작해보세요 (옵션)',
            selectVoice: 'AI음성을 선택',
            tooltip: {
              contents: ['생성 크레딧이 추가로 한개 차감됩니다'],
            },
          },
          stepThree: {
            title: '세팅',
            placeholder: '이름을 정해 주세요',
            tooltip: {
              outputFormatMessage: 'WAV 파일은 프로/프리미엄 사용자에게만 해당됩니다',
              upgradePrompt: '여기를 클릭하여 업그레이드하세요',
              subscribePrompt: '여기를 클릭하여 구독하세요',
            },
          },
          submit: {
            creditUsage: '생성 크레딧이 소모됩니다',
            info: ['AI작곡은 약 30-40초 정도 소요됩니다', 'AI커버가 포함된다면 1-4분이 추가 소요됩니다'],
            start: '변환 시작',
            alreadyInProgress: '진행중',
            uploading: '업로드 중입니다 잠시만 기다려 주세요',
            inProgress:
              '변환중입니다. 제작이 완료될때까지 대기하시면 음원을 바로 재생 할 수 있으며 대기하지 않으셔도 "제작기록"탭에서 제작 상태 확인 및 다운로드가 가능합니다',
            completedAndLoadingPlayer:
              '곡 생성이 완료되었습니다. AI 커버를 생성 중입니다. 기다리시거나 페이지를 나가신 후 "히스토리" 탭에서 커버를 다운로드하실 수 있습니다',
            completedCoverAndLoadingPlayer:
              'AI 커버 생성이 완료되었습니다. 오디오 플레이어를 불러오는 중입니다. 또는 "히스토리" 탭에서 곡을 다운로드하실 수도 있습니다',
            tryAgain: '다시 시도해 주세요',
            lackRemaining: '남은 크레딧이 부족합니다',
          },
          modal: {
            inProgress: '변환중입니다',
            coverInProgress: 'AI커버 생성이 진행 중 입니다',
            lackRemaining: '생성 크레딧이 부족합니다',
            emptyParams: '프롬프트, 태그, 가사등을 입력해주세요',
            noLabel: '이름을 넣어 주세요',
            longLabel: '이름은 100자를 넘을 수 없습니다',
          },
          selectModal: {
            generate: {
              title: 'AI음악 생성',
              button: '제작',
            },
            history: {
              title: '제작기록',
              button: '제작기록',
              searchbar: '검색',
            },
          },
        },
        videoEditorTab: {
          title: '영상 편집',
          addSource: 'Source',
          tooltip: {
            hide: 'Hide source',
            mute: 'Mute source',
            move: 'Move source',
            scale: 'Resize source',
            resetScale: 'Reset source size',
            snap: 'Enable timeline snapping',
            addText: 'Add a text source',
            editText: 'Edit selected text',
            zoom: 'Zoom in/out timeline',
          },
          modal: {
            longLabel: '이름은 50자를 넘을 수 없습니다',
          },
        },
        addSourceModal: {
          title: '자료 추가',
          sourceOptions: ['AI커버', 'TTS', '유튜브', '파일 업로드'],
          searchbar: '검색',
          pagination: {
            loader: '로딩중...',
          },
          voice: 'AI음성',
          youtube: {
            placeholder: '10분 미만만 가능',
            button: '검색',
            invalidYoutubeLink: '올바르지 않은 유튜브 링크입니다.',
            youtubeLinkTooLong: '10분 이상 유튜브 음악을 업로드 할수 없습니다.',
          },
          upload: {
            dragAndDropText: '파일을 끌어서 놓기',
            sizeLimitText: '(Max 75 MB)',
            acceptedAudio: '.mp3, .wav, .flac, and .ogg',
            acceptedVideo: '.mp4 and .mkv',
            acceptedImage: '.jpeg, .png, and .webp',
            button: 'Select file',
            notSupportedFileType: 'This file format is not supported',
            tooManyFiles: 'Please upload one file at a time',
            exceedMaxSize: 'You can only upload files up to 75MB',
          },
          loading: ['업로드중', '(용량이 큰 경우 시간이 걸릴 수 있습니다)'],
        },
        textEditorModal: {
          title: ['텍스트 추가', '텍스트 편집'],
          placeholder: '문자를 입력해 주세요',
          add: '추가',
          save: '저장',
        },
        videoExportModal: {
          title: '영상 다운로드',
          placeholder: '영상 제목을 넣어주세요',
          watermark: '워터마크 표기',
          start: '시작',
          rendering: [
            'You may wait or leave the page and download the video in the "History" tab',
            '약 1분정도 걸립니다',
          ],
          success: ['영상이 준비되었습니다', '다운로드가 자동으로 시작되지 않는다면 아래 버튼을 클릭해주세요'],
          tooltip: {
            contents: ['영상이 길수록 렌더링에 시간이 더 소요될 수 있습니다'],
          },
          videoRenderError: 'Could not render the video. Please try again',
        },
        // faceSwapTab
        faceSwapTab: {
          title: '페이스 스왑',
          stepOne: {
            title: '1단계: 비디오 자르기',
            subTitles: '얼굴을 합성하고 싶은 비디오를 업로드하고, 원하는 구간만큼 편집하세요',
            tags: {
              sourceFile: '원본 영상',
            },
            dragAndDropText: '파일을 끌어서 놓기',
            dragAndDropButton: '파일 선택',
            dragAndDropDuration: '(최대 150 MB)',
            dragAndDropFormat: '(파일 형식: mp4, mov)',
            youtubeLinkText: '원하시는 유튜브 링크를 넣어주세요',
            youtubeLinkInput: '원하시는 유튜브 링크를 넣어주세요 (최대 15분)',
            trimVideo: ['크레딧이 부족합니다', '영상을 ', ' 초 미만으로 편집해주세요'],
          },
          stepTwo: {
            title: '2단계: 교체할 얼굴 선택',
            subTitles: '영상 속에서 바꾸고 싶은 얼굴을 선택하고, 선택한 얼굴을 원하는 얼굴로 바꿔 보세요',
            tags: {
              preview: '미리보기',
              detectedFaces: '인식확인된 얼굴들',
            },
            settings: {
              title: '설정',
              sharpness: '얼굴 화질 향상',
              blendRatio: '얼굴 선명도',
              watermark: '워터마크',
              leftCoin: ['남은 생성 크레딧:', ''],
              poorCoin: ['', ' 크레딧이 부족합니다', '얼굴 갯수를 줄이시거나', '영상 길이를 잘라주세요'],
              requiredCoin: ' 크레딧이 소요됩니다',
              blednRatioMarks: ['매우 낮음', '낮음', '높음', '매우 높음'],
              originalVideo: '화질개선 미설정',
              compareQuality: '화질개선 설정 비교',
            },
          },
          stepThree: {
            title: '3단계: 결과 영상',
            subTitles: '얼굴이 교체된 결과 영상을 확인해 보세요',
            tags: {
              sourceFile: '결과 영상',
            },
          },
          button: {
            settings: '설정',
            start: '변환 시작',
            selectImage: '이미지 선택하기',
            apply: '적용하기',
            createNew: '새로 만들기',
            preview: '미리보기',
            inProgress: '변환중',
            goToHistory: ['', '제작기록 확인'],
            prev: '이전',
            next: '다음',
            buyCredit: '크레딧 사러가기',
          },
          dialog: {
            upgradeText: '프로나 프리미엄으로 업그레이드 하시면 워터마크를 제거하실 수 있습니다',
            faceSelectionModal: '얼굴 선택하기',
            renderingError: ['결과 영상을 불러오는 중 오류가 발생했습니다', '사용하신 크레딧은 차감되지 않습니다'],
            reload: '다시 만들기',
            videoLabelPlaceholder: '영상의 제목을 지어주세요',
            sharpnessOn: '프로나 프리미엄으로 업그레이드 하시면 얼굴 화질 향상 기능을 사용하실 수 있습니다',
          },
          loading: {
            1: '얼굴을 로딩중입니다 ...',
            2: '얼굴을 인식 중입니다 ...',
            3: '결과 영상을 만드는 중입니다',
            4: '미리보기 이미지를 준비중입니다',
            5: '결과 영상을 불러오는 중입니다',
            youtubeLinkUpload: {
              1: '영상을 처리중입니다',
              2: '영상의 길이에따라 1-4분까지 걸릴수 있습니다',
            },
            finalVideoGenerating: [
              '영상이 제작되고 있습니다',
              '영상 길이나 변환하는 얼굴의 숫자에 따라 2-5분가량 소요 됩니다',
              '완성이 될때까지 대기하시면 영상을 바로 재생 할 수 있으며,',
              '중간에 화면에서 나가셔도 "제작기록"탭에서 제작 상태 확인 및 다운로드가 가능합니다',
            ],
          },
          error: {
            facesInImage: '얼굴 이미지를 처리하는 중 오류가 발생했습니다',
            invalidFileType: '.png 또는 .jpeg 파일을 업로드해주세요',
            fileTooLarge: '10MB 이하의 파일을 업로드해주세요',
            noFacesSelected: '바꿀 얼굴을 선택해주세요',
            noFacesDetected: '얼굴이 있는 다른 이미지로 다시 업로드해주세요',
            noFacesFound: '인식된 얼굴이 없습니다. 얼굴이 있는 영상으로 다시 업로드해주세요',
            faceDetectApiError: '인터넷 연결을 확인하고 다시 시도해주세요',
            showPreview: '프리뷰를 보여주는 도중 오류가 발생했습니다',
            uploadFailed: '업로드를 실패했습니다',
            renderingFailed: '렌더링을 실패했습니다',
            pollingError: '폴링을 실패했습니다',
            pollingTimeout: [
              '죄송합니다.',
              '현재 서버 응답이 지연되고 있습니다.',
              '제작중인 내역은 "제작기록"탭에서 제작 상태 확인 및 다운로드가 가능하며,',
              '제작이 실패했을 경우, 크레딧은 차감되지 않습니다.',
            ],
            youtubeLinkTooLong: '15분 이내의 유튜브 영상을 업로드 해주세요',
            downloadFailed: '다운로드에 실패했습니다',
            nsfwVideo: '부적절한 내용이 감지되었습니다',
          },
          submit: {
            tryAgain: '다시 시도해주세요',
          },
          modal: {
            inProgress: '변환 중인 페이스 스왑이 있습니다',
            noRemaining: [
              '이번 달에 남은 페이스 스왑 크레딧이 없습니다',
              '프로나 프리미엄으로 업그레이드 하시거나 개별상품 구매를 통해서 크레딧을 채울 수 있습니다',
            ],
            longLabel: '이름은 50자를 넘을 수 없습니다',
          },
          tooltip: {
            sharpness: {
              1: '이미지의 픽셀과 픽셀 사이에 새로운 픽셀을 끼워 넣어 해상도를 높여주는 기술입니다.',
              2: '업로드하신 얼굴 이미지의 선명도를 향상시킬 수 있습니다.(업스케일링)',
              3: '값이 올라갈수록 얼굴 이미지의 화질이 올라가고 선명해지게 되지만, 반대로 배경 영상의 화질이 낮을 경우 얼굴이 어색하게 보일 수 있습니다.',
            },
            coinLogic: [
              '크레딧 계산 공식 = (영상 길이에 따른 크레딧) x (바꿀 얼굴 갯수)',
              '영상 길이에 따라 15초 단위로 15크레딧씩 추가 (ex. 1~15초 -> 15크레딧, 16~30초 -> 30크레딧, 31~45초 -> 45크레딧)',
              '얼굴 갯수 만큼 x N배 (ex. 14초 영상, 얼굴 2개 변경 -> 15크레딧 x 2 = 30크레딧)',
              '크레딧 계산 공식 = (영상 길이에 따른 크레딧) x (바꿀 얼굴 갯수)',
              '영상 길이에 따라 15초 단위로 15크레딧씩 추가 (ex. 1~15초 -> 15크레딧, 16~30초 -> 30크레딧, 31~45초 -> 45크레딧)',
              '얼굴 갯수 만큼 x N배 (ex. 14초 영상, 얼굴 2개 변경 -> 15크레딧 x 2 = 30크레딧)',
            ],
            coinCal: ['필요한 크레딧 갯수 = ( 영상길이: ', '초 -> ', '크레딧 ) x ( 얼굴갯수: ', '개 ) = ', '크레딧'],
            coin: '크레딧',
            videoLength: '자른 영상 길이:',
            creditUsed: '예상 소모 크레딧:',
          },
        },
        // MR제거 페이지
        vocalExtractorTab: {
          title: 'MR 제거',
          stepOne: {
            title: '음성 업로드',
            tabs: {
              fileUpload: {
                title: '파일업로드',
                dragAndDropText: '파일을 끌어서 놓기',
                dragAndDropButton: '파일 선택',
                dragAndDropDuration: '(파일당 최대 75 MB)',
              },
              youtube: {
                title: '유튜브 링크',
                linkPlaceholder: '10분 미만만 가능',
                linkbutton: '사용하기',
                durationUnit: ['분', '초'],
              },
            },
            vocalExtractorSubTitles: ['MR 제거할 음성 파일을 업로드해주세요'],
            tooltip: {
              contents: [
                '프리미엄 유저는 한 번에 최대 10개의 파일을 업로드할 수 있습니다',
                '프로 유저는 한 번에 최대 5개의 파일을 업로드할 수 있습니다',
                '기본/무료 유저는 한 번에 1개의 파일을 업로드할 수 있습니다',
                '오디오 파일의 총 길이는 60분을 초과할 수 없습니다',
              ],
            },
            maxUploadNumText: {
              premiumCustomAdmin: '최대 10개 파일 업로드 가능',
              pro: '최대 5개 파일 업로드 가능',
              basicFree: '최대 1개 파일 업로드 가능',
            },
          },
          stepTwo: {
            title: '이름 정하기',
            labelInput: {
              placeHolder: '파일이름을 정해 주세요',
            },
          },
          stepThree: {
            title: '파일확장자 정하기',
            subTitles: '파일확장자와 파일이름을 설정해주세요',
            tooltip: {
              outputFormatMessage: 'WAV 파일은 프로/프리미엄 사용자에게만 해당됩니다',
              upgradePrompt: '여기를 클릭하여 업그레이드하세요',
              subscribePrompt: '여기를 클릭하여 구독하세요',
            },
          },
          submit: {
            alreadyInProgress: '제작중',
            upload: '업로드',
            inProgress: '변환중입니다."제작기록"탭에서 제작 상태 확인 및 다운로드가 가능합니다',
            noRemaining: '사용 가능한 횟수를 모두 사용하였습니다',
            start: '시작',
            uploading: '업로드 중입니다 잠시만 기다려 주세요',
            tryAgain: '다시 시도 해주세요',
            remainingCountText: '남은 생성 크레딧',
          },
          modal: {
            notSupportedFileType: '지원되지 않은 파일 형식 입니다',
            invalidYoutubeLink: '올바르지 않은 유튜브 링크입니다.',
            youtubeLinkTooLong: '10분 이상 유튜브 음악을 업로드 할수 없습니다.',
            noRemaining: '사용 가능 횟수를 모두 사용 하였습니다',
            emptyYoutubeLink: 'MR제거할 음성파일을 업로드 해주세요',
            inProgress: '이미 학습중입니다',
            exceedMaxSize: '파일당 최대 75MB 파일만 업로드 가능합니다',
            exceedMaxDuration: '총 재생 시간은 60분을 초과할 수 없습니다',
            premiumCustomManyFiles: '프리미엄/커스텀 유저는 최대 파일',
            proManyFiles: '프로 유저는 최대 파일',
            manyFiles: '개를 업로드할 수 있습니다',
            noFiles: 'MR제거할 음성파일을 추가해주세요',
            lackRemaining: '사용 가능 횟수를 초과합니다',
            uploadStatusNotValid: 'MR 제거 남은 횟수 부족 혹은 이미 진행중 입니다',
            tryAgain: '업로드 실패한 파일들:',
            noLabel: '파일이름을 정해 주세요',
            longLabel: '이름은 50자를 넘을 수 없습니다',
          },
        },
        historyTab: {
          title: '제작기록',
          inProgress: '제작중',
          failed: '취소됨',
          freeVersionTag: '무료버전',
          freePrefix: '무료버전 소리소리AI 광고포함',
          tooltip: {
            contents: [
              'AI커버 제작은 평균 2-4분 소요됩니다',
              '음성학습은 평균 0.5-1시간 소요됩니다',
              "작업이 취소가 된 경우, '문의사항' 탭을 이용해주세요",
            ],
          },
          tabs: {
            inference: {
              title: 'AI 커버',
            },
            training: {
              title: 'AI 음성',
            },
            vocalExtract: {
              title: 'MR 제거',
            },
            community: {
              title: '커뮤니티',
            },
            videoEditor: {
              title: '영상 편집',
            },
            faceSwap: {
              title: '페이스 스왑',
            },
            image: {
              title: 'AI 이미지',
              makeNewAIImage: '새로운 AI이미지 만들기',
            },
            ttiTraining: {
              title: 'AI 이미지모델',
              makeNewTraining: '새로운 모델 만들기',
              style: '스타일',
              object: '인물',
            },
            ttm: {
              title: 'AI 음악',
            },
          },
          changeButton: '변경',
          cancelButton: '취소',
          confirmModelDelete: '현재 모델을 삭제하셔도 재학습은 불가능합니다. 삭제하시겠습니까?',
          confirmDelete: '정말 삭제하시겠습니까?',
          searchbar: '검색',
          infoIcon: {
            source: '출처',
            voice: '음성',
            pitch: '키조절',
            mixing: {
              title: '믹싱',
              vocalLevel: '음성 볼륨',
              reverbLevel: '리버브 볼륨',
              reverbLength: '리버브 길이',
            },
            tts: {
              voice: '음성',
              variability: '변동성',
              similarity: '유사도',
            },
            errorMessage: '오류',
          },
          pagination: {
            loader: '로딩중...',
          },
          modal: {
            error: '웹페이지를 새로고침 해주세요',
            label: '이름',
            username: '닉네임',
            image: '이미지',
            filterError: '음성 필터를 찾을수 없습니다',
          },
          trainingInfo: {
            files: '사용한 음원',
            extracted: '보컬 추출기능 사용됨',
            shared: '커뮤니티에 공유됨',
            yes: '예',
            no: '아니오',
            status: '상태',
            errorFile: '오류가 있는 파일',
          },
          voice: 'AI음성',
          ttmInfo: {
            tags: '태그',
            prompt: '프롬프트',
            lyricPrompt: '가사 프롬프트',
            lyrics: '가사',
            failed: 'AI 작곡에 실패했습니다. 다시 시도해 주세요. 문제가 지속되면 SORISORI 지원 팀에 문의해 주세요.',
          },
          noOptions: '옵션 없음',
          creations: {
            title: '제작 기록',
            tabs: [
              { title: 'AI 커버', tab: 'music' },
              { title: 'AI 작곡', tab: 'ttm' },
              { title: 'AI 문자음성 변환', tab: 'speech' },
              { title: 'AI 이미지', tab: 'image' },
              { title: '페이스 스왑', tab: 'faceSwap' },
              { title: 'MR 제거', tab: 'vocalExtract' },
              { title: '영상 편집', tab: 'videoEditor' },
            ],
          },
          models: {
            title: '학습 기록',
            tabs: [
              { title: 'AI 음성 학습', tab: 'music' },
              { title: 'AI 문자음성 학습', tab: 'speech' },
              { title: 'AI 이미지 학습', tab: 'image' },
              { title: '커뮤니티', tab: 'community' },
            ],
          },
        },
        subscriptionTab: {
          title: '요금제',
          pageTitleOne: '소리소리AI',
          popular: '인기 요금제',
          cancel: {
            message: '구독 취소 하시겠습니까?',
            success: '구독 취소 완료!',
            fail: '구독 취소 실패. 다시 시도해 주세요.',
          },
          cancelChange: {
            message: '구독 변경 취소 하시겠습니까?',
            success: '구독 변경 취소 완료!',
            fail: '구독 변경 취소 실패. 다시 시도해 주세요.',
          },
          onetime: {
            message: '구매 하시겠습니까?',
            success: '구매 완료!',
            fail: '결제 실패 하였습니다. 다시 시도해 주시길 바랍니다.',
          },
          downgrade: {
            message: '요금제 변경을 진행하시겠습니까?',
            success: '요금제 변경이 완료되었습니다!',
            fail: '요금제 변경을 실패 하였습니다. 다시 시도해 주시기 바랍니다',
          },
          upgrade: {
            message: '요금제 변경을 진행하시겠습니까? 기존에 있던 결제방식으로 결제가 시도 됩니다.',
            success: '요금제 변경이 완료되었습니다!',
            fail: '요금제 변경을 실패 하였습니다. 다시 시도해 주시기 바랍니다',
            paymentFailed: '결제 실패 하였습니다. 내 프로필에서 결제 수단 변경 하시거나 다시 시도해 주시기 바랍니다.',
          },
          annualize: {
            message:
              "Are you sure you want to change to a lower tier yearly plan? Once you click 'Pay', payment will be made with the existing payment method.",
            success: '요금제 변경이 완료되었습니다!!',
            fail: '요금제 변경을 실패 하였습니다. 다시 시도해 주시기 바랍니다.',
            paymentFailed: '결제 실패 하였습니다. 내 프로필에서 결제 수단 변경 하시거나 다시 시도해 주시기 바랍니다.',
          },
          disabled: {
            tooltip: {
              contents: ['연간구독에서 월간구독으로의 전환은 불가능합니다'],
            },
          },
          mobilePaymentRequired: '모바일 앱에서 구독을 설정하셨기 때문에 구독 관리는 모바일 앱에서 해주시기 바랍니다.',
          tabs: {
            subscription: {
              title: '구독 요금제',
              pastDue: '결제 미완료',
              month: '월',
              monthly: 'Monthly',
              yearly: 'Yearly',
              upfront: 'Billed yearly',
              yearlyTag: '2 Months Free',
              subscribe: '구독하기',
              change: '변경하기',
              currentTier: '현재 사용중',
              popular: '인기 요금제',
              value: '최고의 가치',
              moreCredits: '크레딧이 더 필요하신가요?',
              discount: '추가 크레딧 80% 할인',
            },
            creditInfo: {
              title: '크레딧이 뭔가요?',
              contents: [
                '크레딧이란 AI 생성과 학습을 진행 하실수 있는 "화폐"입니다',
                '크레딧으로 소리소리AI에서 모든 서비스를 사용하실수있습니다',
                '크레딧은 매달 리셋이 되며, 사용되지 않은 크레딧은 다음달로 이월되지 않습니다 (추가 상품으로 구매하신 크레딧은 이월됩니다)',
              ],
            },
            creditUsage: {
              title: '크레딧 사용 방법',
              generation: '생성 서비스',
              training: '학습 서비스',
              cost: '비용',
            },
          },
          paymentModal: {
            usePromoCode: '프로모션 코드 사용',
            promoCodePlaceholder: '프로모션 코드',
            applyButton: '사용',
            submit: '계속하기',
            promoCodeApplied: '프로모션 코드 적용',
            invalidPromoCode: '올바르지 않은 프로모션 코드입니다',
            genericError: '다시 시도해 주세요',
            promoCodeError: {
              doesNotExist: '유효하지 않은 할인 코드입니다. 할인 코드를 확인해주세요',
              invalidSubscriptionType: '이 할인 코드는 프로와 프리미엄에만 적용됩니다',
              onlyFirstTime: '이 할인 코드는 신규 사용자에게만 유효합니다',
            },
          },
        },
        communityTab: {
          title: '커뮤니티',
          subTitle: '원하는 음성을 선택해서 AI 커버를 만들어보세요!',
          subtitleOne: '🔥이 달의 인기 모델',
          subtitleTwo: '전체 목록',
          inProgress: '제작중',
          tags: '태그',
          failed: '취소됨',
          freeVersionTag: '무료버전',
          freePrefix: '무료버전 소리소리AI 광고포함',
          voiceOptions: ['커뮤니티', '내 음성', '좋아요'],
          sortOptions: ['최신순', '좋아요수', '제작횟수', '모델이름'],
          tooltip: {
            contents: [
              'AI커버 제작은 평균 2-4분 소요됩니다',
              '음성학습은 평균 2-4시간 소요됩니다',
              "작업이 취소가 된 경우, '문의사항' 탭을 이용해주세요",
            ],
          },
          tabs: {
            inference: {
              title: 'AI 커버',
            },
            training: {
              title: 'AI 음성',
            },
            vocalExtract: {
              title: 'MR 제거',
            },
          },
          changeButton: '변경',
          cancelButton: '취소',
          confirmModelDelete: '현재 모델을 삭제하셔도 재학습은 불가능합니다. 삭제하시겠습니까?',
          confirmInferenceDelete: '정말 삭제하시겠습니까?',
          confirmVocalExtractDelete: '정말 삭제하시겠습니까?',
          searchbar: '검색',
          infoIcon: {
            source: '출처',
            voice: '음성',
            pitch: '키조절',
          },
          pagination: {
            loader: '로딩중...',
          },
          modal: {
            error: '웹페이지를 새로고침 해주세요.',
            aihubError: 'This model has expired, please select another model.',
          },
          button: {
            share: '모델 공유',
          },
        },
        supportTab: {
          title: '디스코드',
          link: 'https://discord.gg/AVREYrRZv4',
        },
        pipeline: {
          inferenceStatusMessage: {
            formatError:
              '파일 형식과 확장자가 일치하지 않거나, 파일이 손상되었거나 안전하지 않습니다. 파일을 확인해주세요',
            volumeError:
              '파일의 목소리 음량이 너무 낮거나, 파일에 목소리가 없습니다. 녹음 설정을 확인하거나 오디오 편집 소프트웨어를 사용하여 음량을 높여주세요.',
            invalidFileError: '파일을 열 수 없습니다. 파일을 확인해주세요.',
            invalidAihubModel: 'This model has expired, please select another model.',
            progress10: '진행 중 10%',
            progress20: '진행 중 20%',
            progress40: '진행 중 40%',
            progress50: '진행 중 50%',
            progress60: '진행 중 60%',
            progress80: '진행 중 80%',
            progress100: '진행 중 100%',
            complete: '완료',
            generalMessage:
              'AI 커버에 실패했습니다. 다시 시도해 주세요. 문제가 지속되면 SORISORI 지원 팀에 문의해 주세요.',
            starting: '시작 중',
          },
          trainingStatusMessage: {
            formatError: '파일 형식과 확장자가 일치하지 않거나, 파일이 손상되었거나 안전하지 않습니다',
            volumeError:
              '파일의 목소리 음량이 너무 낮거나, 파일에 목소리가 없습니다. 녹음 설정을 확인하거나 오디오 편집 소프트웨어를 사용하여 음량을 높여주세요.',
            invalidFileError: '파일을 열 수 없습니다. 파일을 확인해주세요.',
            progress10: '진행 중 10%',
            progress20: '진행 중 20%',
            progress40: '진행 중 40%',
            progress50: '진행 중 50%',
            progress60: '진행 중 60%',
            progress80: '진행 중 80%',
            progress100: '진행 중 100%',
            complete: '완료',
            generalMessage:
              '학습에 실패했습니다. 다시 시도해 주세요. 문제가 지속되면 SORISORI 지원 팀에 문의해 주세요.',
            starting: '시작 중',
          },
        },
        modal: {
          confirmationPay: '결제하기',
          confirmationCancel: '취소',
          confirmationYes: '예',
          confirmationNo: '아니오',
          combined: '통합본',
          vocal: '보컬',
          backVocal: '코러스',
          instrument: '반주',
          fileUploadFail: '파일 업로드에 실패 하였습니댜. 파일 체크 후 다시 시도해 주세요',
          trainingInProgressError: '이미 학습중입니다',
          noRemainingError: '사용 가능한 횟수를 모두 사용하였습니다',
          genericError: '파일 업로드에 실패 하였습니다. 다시 시도해주세요',
          pageLoadFail: '페이지 로딩에 실패하였습니다. 페이지를 새로고침 해주세요',
          pageLoadFailOnSubmit:
            "파일 업로드에 성공 하였지만 페이지 로딩에 실패하였습니다. 페이지를 새로고침 해주세요. 기록은 '제작기록' 탭에서 확인 가능합니다",
          gotoProfile: '내 프로필 보기',
          youtubeDownloadLink: '유튜브 다운로드 링크',
          youtubeCountryBlocked: '이 영상은 저작권/국가 제한으로 현재 국가에서 이용할 수 없습니다.',
          youtubeCountryBlockedCopyright: '이 영상은 저작권/국가 제한으로 현재 국가에서 이용할 수 없습니다.',
        },
        mixingModal: {
          label: '믹스',
          title: '믹싱',
          sliders: {
            contents: ['키 조절', '음성 볼륨', '리버브 볼륨', '리버브 길이'],
          },
          tooltip: {
            contents: [
              '남성음성으로 여성곡을 커버할경우 -4 ~ -6 추천',
              '여성음성으로 남성곡을 커버할경우 +4 ~ +6 추천',
              '과도한 키 조절은 음질을 저하 시킬 수 있습니다',
              '보컬 트랙의 음량',
              '0db는 원래 곡의 보컬 음량입니다',
              '리버브 효과의 크기',
              '0은 리버브효과가 없으며, 6은 리버브효과가 최대치로 세팅됩니다',
              '리버브의 효과의 길이',
              '발라드곡에는 2초가량이 추천되며, 빠른곡일수록 더 낮은 수치를 추천드립니다',
            ],
          },
          demo: {
            toggle: '믹싱',
            status: ['믹싱안됨', '믹싱됨'],
            description: '믹싱 기능의 차이를 들어보세요',
          },
          dialog: {
            title: '현재 요금제로는 사용 불가능한 기능입니다',
            text: '프로나 프리미엄으로 업그레이드 하시면 믹싱 기능을 사용하실 수 있습니다',
          },
          upgradeButton: ['요금제 변경', ''],
          alert: '각 믹서의 값을 설정해 주세요',
        },
        freeInferenceMessageModal: {
          messeageOne: ['무료버전에는 광고가 포함 되어 있으며', '커버를 45초간 들어보실 수 있습니다'],
          messeageTwo: ['유료 전환시 광고는 사라지며', '전곡을 즐겨보실 수 있습니다'],
          button: '요금제 확인',
        },
        youtubeReenabledModal: {
          title: '유튜브 기능이 다시 활성화되었습니다!',
          description: '유튜브 링크로 다시 AI 커버를 만들 수 있어요.',
          confirm: '확인',
          hideFor3Days: '1일간 보지 않기',
        },
        freeTrainingMessageModal: {
          messages: ['사용 가능한', '학습 크레딧이 없습니다'],
          button: '요금제 확인',
        },
        freeVocalExtractorMessageModal: {
          free: {
            message: [
              '무료 유저는',
              '최대 1개의 파일을 업로드할 수 있습니다',
              '더 많은 파일을 업로드 하시려면',
              '구독 해주세요',
            ],
          },
          basic: {
            message: [
              '기본 유저는',
              '최대 1개의 파일을 업로드할 수 있습니다',
              '더 많은 파일을 업로드 하시려면',
              '구독 해주세요',
            ],
          },
          button: '구독하기',
        },
        onetimeItems: [
          {
            type: 'GEN_CREDIT_5',
            name: '5개의 생성 크레딧',
            discount: {
              strikethrough: '5',
              name: '25개의 생성 크레딧',
              type: 'GEN_CREDIT_25_PRO',
            },
            price: {
              usd: '$5',
              thb: '฿130',
              krw: '5,000원',
              jpy: '¥590',
            },
          },
          {
            type: 'GEN_CREDIT_25',
            name: '25개의 생성 크레딧',
            discount: {
              strikethrough: '25',
              name: '150개의 생성 크레딧',
              type: 'GEN_CREDIT_150',
            },
            price: {
              usd: '$25',
              thb: '฿650',
              krw: '25,000원',
              jpy: '¥2950',
            },
          },
          {
            type: 'TRAINING_CREDIT_1',
            name: '1개의 학습 크레딧',
            price: {
              usd: '$7',
              thb: '฿250',
              krw: '8,500원',
              jpy: '¥990',
            },
          },
          {
            type: 'TRAINING_CREDIT_5',
            name: '5개의 학습 크레딧',
            discount: {
              strikethrough: '5',
              name: '7개의 학습 크레딧',
              type: 'TRAINING_CREDIT_7',
            },
            price: {
              usd: '$35',
              thb: '฿1250',
              krw: '42,500원',
              jpy: '¥4950',
            },
          },
        ],
        subscriptionItems: [
          {
            name: '무료',
            model: 'FREE', //영어로 나두기
            monthlyRate: {
              usd: '$0',
              thb: '฿0',
              krw: '0원',
              jpy: '¥0',
            },
            features: [
              {
                name: 'AI커버 두곡',
              },
              {
                name: 'MR제거 두곡',
              },
              {
                name: 'TTS 25자',
              },
              {
                name: '페이스스왑 15초 영상 한개',
              },
              {
                name: '이미지생성 5개',
              },
            ],
          },
          {
            name: '기본',
            model: 'BASIC', //영어로 나두기
            monthlyRate: {
              usd: '$9.99',
              thb: '฿279',
              krw: '14,800원',
              jpy: '¥1,699',
            },
            yearly: {
              model: 'BASIC_YEARLY',
              monthlyRate: {
                usd: '$8.30',
                thb: '฿233',
                krw: '12,333원',
                jpy: '¥1,417',
              },
            },
            features: [
              {
                name: '150개의 생성 크레딧',
                usage: [
                  '최대 150번의 AI커버',
                  '최대 150번의 MR제거',
                  '최대 1500자의 문자음성변환 (TTS)',
                  '최대 150초의 페이스스왑',
                  '최대 75번의 이미지생성(TTI)',
                ],
              },
              {
                name: '2개의 학습 크레딧',
                usage: ['최대 2번의 AI커버 음성학습', '최대 2번의 TTS 음성학습'],
              },
              {
                name: '속도: 보통',
              },
              {
                name: '학습 성능: 좋음',
              },
              {
                name: '음질: 보통 (MP3)',
              },
            ],
          },
          {
            name: '프로',
            model: 'PRO', //영어로 나두기
            monthlyRate: {
              usd: '$24.80',
              thb: '฿619',
              krw: '28,800원',
              jpy: '¥3,490',
            },
            yearly: {
              model: 'PRO_YEARLY',
              monthlyRate: {
                usd: '$20.70',
                thb: '฿516',
                krw: '₩24,000',
                jpy: '¥2,908',
              },
            },
            features: [
              {
                name: '1000개의 생성 크레딧',
                usage: [
                  '최대 1000번의 AI커버',
                  '최대 1000번의 MR제거',
                  '최대 10000자의 문자음성변환 (TTS)',
                  '최대 1000초의 페이스스왑',
                  '최대 500번의 이미지생성(TTI)',
                ],
              },
              {
                name: '5개의 학습 크레딧',
                usage: ['최대 5번의 AI커버 음성학습', '최대 5번의 TTS 음성학습'],
              },
              {
                name: '속도: 빠름',
              },
              {
                name: '학습 성능: 매우 좋음',
              },
              {
                name: '음질: 높음 (WAV)',
              },
              {
                name: '추가상품 할인',
              },
            ],
          },
          {
            name: '프리미엄',
            model: 'PREMIUM', //영어로 나두기
            monthlyRate: {
              usd: '$68.80',
              thb: '฿1680',
              krw: '88,800원',
              jpy: '¥8,990',
            },
            yearly: {
              model: 'PREMIUM_YEARLY',
              monthlyRate: {
                usd: '$57.30',
                thb: '฿1400',
                krw: '₩73,333',
                jpy: '¥7,490',
              },
            },
            features: [
              {
                name: '5000개의 생성 크레딧',
                usage: [
                  '최대 5000번의 AI커버',
                  '최대 5000번의 MR제거',
                  '최대 50000자의 문자음성변환 (TTS)',
                  '최대 5000초의 페이스스왑',
                  '최대 2500번의 이미지생성(TTI)',
                ],
              },
              {
                name: '20개의 학습 크레딧',
                usage: ['최대 20번의 AI커버 음성학습', '최대 20번의 TTS 음성학습'],
              },
              {
                name: '속도: 매우 빠름',
              },
              {
                name: '학습 성능: 최상',
              },
              {
                name: '음질: 높음 (WAV)',
              },
              {
                name: '추가상품 할인',
              },
            ],
          },
        ],
        costPerService: {
          generation: [
            {
              name: 'AI커버',
              cost: '1 생성 크레딧',
            },
            {
              name: 'MR제거',
              cost: '1 생성 크레딧',
            },
            {
              name: '문자음성변환 (TTS)',
              cost: '생성 크레딧당 10자',
            },
            {
              name: '페이스스왑',
              cost: '15초 단위 + 얼굴 하나당 15 생성 크레딧',
            },
            {
              name: 'AI이미지 생성',
              cost: '2+ 생성 크레딧',
            },
          ],
          training: [
            {
              name: 'AI커버 학습',
              cost: '1 학습 크레딧',
            },
            {
              name: 'TTS 학습',
              cost: '1 학습 크레딧',
            },
          ],
        },
        subscriptionComparison: {
          title: '구독상품 비교',
          headers: {
            feature: '기능',
            inference: 'AI커버',
            faceSwap: '페이스 스왑',
            tti: '이미지 생성',
            row: ['무료', '기본', '프로', '프리미엄'],
          },
          subscription: [
            {
              feature: '생성 크레딧당 비용',
              row: [
                '-', // FREE
                '100원 / 크레딧', // BASIC
                '28.8원 / 크레딧', // PRO
                '17.7원 / 크레딧', // PREMIUM
              ],
            },
            {
              feature: '학습 크레딧당 비용',
              row: ['-', '7400원 / 크레딧', '4100원 / 크레딧', '3552원 / 크레딧'],
            },
            {
              feature: '속도',
              row: ['느림', '보통', '빠름', '매우 빠름'],
            },
            {
              feature: '학습 성능',
              row: ['낮음', '좋음', '매우 좋음', '최상'],
            },
            {
              feature: '추가 상품 할인',
              row: ['-', '-', '-80%', '-80%'],
            },
          ],
          inference: [
            {
              feature: '키 조절',
              row: ['Y', 'Y', 'Y', 'Y'],
            },
            {
              feature: 'AI믹싱기능',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'MP3 제공',
              row: ['Y', 'Y', 'Y', 'Y'],
            },
            {
              feature: 'WAV 제공 (고음질)',
              row: ['N', 'N', 'Y', 'Y'],
            },
          ],
          faceSwap: [
            {
              feature: '화질개선',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: '워터마크 제거',
              row: ['N', 'N', 'Y', 'Y'],
            },
          ],
          tti: [
            {
              feature: '최고 생성 퀄리티 설정',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: '이미 최대 크기 설정 ',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'CFG 스케일 설정',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: '워터마크 제거',
              row: ['N', 'N', 'Y', 'Y'],
            },
          ],
        },
        faqTab: {
          title: '자주묻는질문',
          placeholder: '검색어를 입력하세요...',
          faqs: [
            {
              title: 'AI학습 관련 질문',
              qnas: [
                {
                  question: '업로드시에 어떤 파일 확장자를 지원하나요?',
                  answers: [
                    'mp3, wav, m4a, mkv, mp4, flac, ogg 여섯 가지를 지원합니다. 높은 품질의 원본 음원을 구하는 것이 중요하며, 파일을 변환할수록 음원에 손실을 일으키게 됩니다. m4a의 경우, 휴대폰 녹음기에 해당되는 확장자 입니다.',
                  ],
                },
                {
                  question: '보컬 추출을 해야하나요?',
                  answers: [
                    '소리소리AI의 학습과정에는, 매우 우수한 성능의 보컬추출 기능이 이미 포함되어 있기 때문에 따로 하실 필요가 없습니다.',
                    '기본적으로는 불필요하지만, 학습전에 보컬 추출된 음원의 퀄리티를 직접 확인하고 커버를 제작할수 있다는 장점이 있습니다.',
                    '"MR제거기능"을 통해서 보컬추출을 진행하실 수 있습니다.',
                  ],
                },
                {
                  question: '여러 곡을 업로드해서 학습해도 되나요?',
                  answers: [
                    '네, 여러 파일을 업로드 하실 수 있습니다.',
                    '같은 이유로, 직접 녹음하시는 경우에도 여러번에 나눠 녹음하신 뒤 복수의 파일을 업로드하셔도 문제되지 않습니다',
                  ],
                },
                {
                  question: '어떤 마이크로 녹음을 해야하나요?',
                  answers: [
                    '단순한 휴대폰 녹음기도 충분합니다. 다만 조용한 환경에서 무반주로 녹음하시는 것을 추천드립니다.',
                  ],
                },
                {
                  question: '노래방에서 부른 곡을 업로드해도 되나요?',
                  answers: [
                    '노래방 같은 경우, 애초에 음질도 좋지 않고, 무엇보다 음향효과가 너무 강하기 때문에 피해주시기 바랍니다. 파열음을 동반한 노래방 특유의 울리는 듯한 소리가 같이 학습될 수 있어 추천드리지 않습니다.',
                  ],
                },
                {
                  question:
                    '녹음이 완료된 뒤에는 본인의 음성이 잘 녹음 되었는지 꼭! 확인 해 주세요. 간혹 마이크가 너무 가깝거나 멀어서 음성이 파열되거나 잘 안들리는 경우가 있습니다.',
                  answers: [],
                },
                {
                  question: '제작 결과가 마음에 안드는데, 삭제하고 새로 만들 수 있나요?',
                  answers: [
                    '삭제를 하시더라도 학습 횟수가 복구되진 않습니다. 일단 학습의 시작과 동시에 서버비용이 발생하게 되다 보니, 단순히 제작하신걸 지워도 재학습을 할 수 없는점 이해해 주시기 바랍니다.',
                  ],
                },
              ],
            },
            {
              title: 'AI 커버 제작 관련 질문',
              qnas: [
                {
                  question: '학습 중에 자꾸 취소가 돼요.',
                  answers: [
                    '업로드 하신 음원파일을 확인해 주시기 바랍니다. 가장 먼저 재생이 잘 되는지 확인해 주시고, 파일을 변환하실 때 파일 확장자를 단순히 .mp3나 .wav로 바꾸신게 아닌지 확인해 주시기 바랍니다. 동영상을 사용하고 싶으신 경우 인터넷에서 간단한 변환과정을 거쳐주시기 바랍니다.',
                  ],
                },
                {
                  question: '업로드시에 어떤 파일 확장자를 지원하나요?',
                  answers: [
                    'mp3, wav, m4a, mkv, mp4, flac, ogg 여섯 가지를 지원합니다. 높은 품질의 원본 음원을 구하는 것이 중요하며, 파일을 변환할수록 음원에 손실을 일으키게 됩니다. m4a의 경우, 휴대폰 녹음기에 해당되는 확장자 입니다.',
                  ],
                },
                {
                  question: '보컬 추출을 별도로 해야하나요?',
                  answers: [
                    '소리소리AI의 커버 제작과정에는, 매우 우수한 성능의 보컬추출 기능이 자동으로 포함되어 있으므로 따로 진행하실 필요가 없습니다.',
                    '다만 직접 추출을 하실경우, 추출된 보컬의 퀄리티를 직접 확인하고 커버를 제작할수 있다는 장점이 있습니다. 이 경우 "보컬만 추출한 파일인가요?" 라는 질문에 "예"를 선택해 주시기 바랍니다.',
                  ],
                },
                {
                  question:
                    '가수 그룹 멤버중 한명만 학습시키고 싶으면 그 사람만 편집으로 부분부분 잘라서 학습시켜도 될까요?',
                  answers: [
                    '네, 하나의 음원에서 개별 멤버의 목소리를 학습시키고 싶으신 경우, 직접 부분부분 잘라서 편집을 하셔서 학습 시켜주셔야 합니다.',
                  ],
                },
                {
                  question: '피치변환은 어떻게 활용해야 하나요?',
                  answers: [
                    '남성과 여성 보컬은 일반적으로 4-6키가 차이납니다. 예를 들어 남성 AI음성으로 여성곡을 커버하시려는 경우, 키조절 도구에서 +4 에서 +6사이를 시도해보시는 것을 추천드립니다. 다만 피치변환 자체가 음질을 하락시키는 효과가 있기 때문에, AI음성이나 커버 음원에 따라 다소 불안정한 변환이 있을 수 있습니다.',
                  ],
                },
                {
                  question: '나레이션도 커버가 되나요?',
                  answers: [
                    '네 가능합니다. 평균적으로는 가창 커버보다 퀄리티가 낮을 수 있지만, 학습 재료의 품질에 따라 자연스러운 결과물을 확인하실 수 있습니다.',
                  ],
                },
                {
                  question: '제작기록 탭에서 다운로드가 안됩니다.',
                  answers: [
                    '네이버 앱이나 네이버 이메일 앱 등, 일반적인 인터넷 브라우저가 아닌 어플을 통해 로그인하신 경우에 문제가 될 수 있습니다.',
                    '기본 인터넷 앱, 크롬, 사파리, 파이어폭스 등 일반적인 인터넷 브라우저로 접속해주시면 해결되실 겁니다.',
                  ],
                },
              ],
            },
            {
              title: 'AI 커버 제작 팁',
              qnas: [
                {
                  question:
                    '음원의 품질은 AI커버에 특히 더 큰 영향을 끼칩니다. 유튜브 음원같은 경우 음원에 많은 손실이 있기 때문에, 멜론이나 벅스 등의 음원 사이트에서 정식 구매한 음원을 사용하시는 것을 가장 추천드립니다.',
                  answers: [],
                },
                {
                  question:
                    '오토튠같은 음향효과가 많거나, 코러스(백보컬)가 너무 센 음원들은 음성을 깨끗하게 분리해서 학습시키는데 어려움이 있을 수 있으므로 피하시는 것을 추천드립니다.',
                  answers: [],
                },
                {
                  question: '같은 이유로 여러명이 가창을 하거나 화음이 많은 곡은 사용하시기 어렵습니다.',
                  answers: [],
                },
              ],
            },
            {
              title: '결제 관련 질문',
              qnas: [
                {
                  question: '요금제를 업그레이드 하고 싶은데, 돈을 두배로 내게 되나요?',
                  answers: ['두 요금제의 차액만큼만 결제가 됩니다.'],
                },
                {
                  question: '구독 취소는 어떻게하나요?',
                  answers: [
                    '- 구독은 프로필 페이지에서 취소할 수 있습니다.',
                    '- 프로필 페이지는 구독 페이지에서 무료 플랜 카드의 "변경하기" 버튼을 클릭하거나 탐색 바에서 사용자 이름을 클릭하여 접근할 수 있습니다.',
                  ],
                },
                {
                  question: '이번달만 사용하고 싶은데 어떻게 해야하나요?',
                  answers: ['위 방법으로 구독취소를 누르시면, 해당 달에는 계속 사용이 가능하십니다.'],
                },
                {
                  question: '학습하지 않은 모델이나 커버 갯수는 이월되나요?',
                  answers: ['학습하지 않은 모델 갯수는 다음달로 이월되지 않습니다. 매달 지정된 수만큼 리셋이 됩니다.'],
                },
                {
                  question: '카드 결제가 안됩니다.',
                  answers: [
                    '12월 20일부로 해외카드를 포함한 국내카드와 카카오페이가 결제수단으로 추가되어 다양한 방법으로 결제하실 수 있습니다. 결제에 계속 문제가 있으신 경우 해당 은행이나 카드사에 요청을 해주셔야 합니다.',
                  ],
                },
                {
                  question: '환불 요청은 어떻게 하나요?',
                  answers: [
                    '환불 가능한 조건은 아래와 같습니다.',
                    '- 개별상품은 환불이 불가능합니다.',
                    '- 해당 달에 사용 기록이 없으셔야 합니다.',
                    '- 환불요청은 결제일로부터 3주(21일)내로 이루어져야 합니다.',
                    '- 요금제와 상관없이 3천원의 환불 수수료가 발생합니다.',
                    '- 구독 해지는 스스로 해주셔야 합니다. 구독은 프로필 페이지에서 해지 가능합니다.',
                    '- 프로필 페이지는 구독 페이지에서 무료 플랜 카드의 "변경하기" 버튼을 클릭하거나 탐색 바에서 사용자 이름을 클릭하여 접근할 수 있습니다.',
                  ],
                },
                {
                  question: '환불은 얼마나 걸리나요?',
                  answers: [
                    '문의를 넣으신 날 기준으로 신용카드의 경우 영업일 5-8일이 걸리고, 카카오페이의 경우 조금 더 짧을 수 있습니다.',
                  ],
                },
              ],
            },
            {
              title: '기타 질문',
              qnas: [
                {
                  question: '회원탈퇴는 어떻게 하나요?',
                  answers: [
                    '디스코드로 오셔서 문의 남겨주시면 안내를 도와드리겠습니다.',
                    '직접 탈퇴도 하실 수 있도록 해당 기능은 현재 개발중입니다.',
                  ],
                },
                {
                  question: '디스코드는 뭔가요?',
                  answers: [
                    '많은 소리소리AI 유저님들께서 활동하고 계시는 커뮤니티 입니다. 유저님들께서 서로 다양한 정보교류와 공유가 가능하며, 작업물들에 대한 평가도 받아볼 수 있는 유익한 공간입니다.',
                  ],
                },
                {
                  question: '이번달에 사용량을 모두 사용했는데, 음성학습이나 MR제거를 추가로 할수있나요?',
                  answers: [
                    '요금제 페이지에 가셔서, 개별상품 탭을 누르시면 구매 가능하십니다.',
                    '일반적으론 추가 모델 제작 개별 상품을 구매하시는 것보다 상위 요금제를 사용하시는게 훨씬 경제적입니다.',
                  ],
                },
              ],
            },
          ],
        },
        contactTab: {
          title: '문의사항',
          placeholder: {
            type: '문의 종류',
            email: '이메일',
            text: '내용을 입력하세요',
            refund:
              "환불 가능한 조건은 다음과 같습니다.\n\n1. 개별상품은 환불이 불가능합니다.\n2. 해당 달에 사용 기록이 없으셔야 합니다.\n3. 환불요청은 결제일로부터 3주(21일)내로 이루어져야 합니다.\n4. 요금제와 상관없이 3천원의 환불 수수료가 발생합니다.\n5. 구독 해지는 스스로 해주셔야 합니다. 구독은 프로필 페이지에서 해지 가능합니다.\n6. 프로필 페이지는 구독 페이지에서 무료 플랜 카드의 '변경하기' 버튼을 클릭하거나 탐색 바에서 사용자 이름을 클릭하여 접근할 수 있습니다.",
          },
          message: {
            deleteAccount:
              '계정을 삭제하면 복구할 수 없습니다. 사용중인 웹 구독은 자동으로 취소되지만, 모바일 구독은 앱 스토어를 통해 별도로 취소해야 합니다.',
            confirmDeleteAccount: "확인을 위해 'DELETE'를 입력하세요.",
            deleteConfirm: '계정 삭제',
            accountDeletedMessage: '계정이 성공적으로 삭제되었습니다. 이제 로그아웃됩니다.',
            type: '문의 종류를 선택해주세요',
            email: '이메일 형식이 올바르지 않습니다',
            content: '내용이 입력되지 않았습니다',
            loading: '정보를 전송중입니다. 잠시만 기다려주세요',
            success: '등록이 완료되었습니다',
            refundSuccess: '환불 요청이 성공적으로 제출되었습니다. 상태를 확인하기 위해서는 이메일을 확인해 주세요.',
            fail: '전송에 실패했습니다. 다시 시도해주세요',
            useDiscord: '학습 및 제작 관련 질문은 자주묻는질문 탭과 디스코드 커뮤니티를 활용해주시면 감사하겠습니다',
          },
          contactType: ['학습/제작 기능 관련 문의', 'API 문의', '환불 문의', '계정 삭제', '기타 비즈니스 문의'],
          submit: '등록하기',
        },
        emailPreferenceTab: {
          title: '이메일 설정',
          header: '특별한 오퍼와 새로운 기능들, 그리고 중요한 소식들을 받아보세요',
          choiceLabels: {
            announcement: '공지사항',
            notification: '알림',
            newsletter: '뉴스레터',
            promotion: '프로모션',
          },
          submit: {
            save: '저장하기',
          },
          modal: {
            success: '등록이 완료되었습니다',
            error: '문제가 발생하였습니다. 다시 시도 해주세요.',
          },
        },
        profileTab: {
          title: '내 프로필',
          sections: {
            login: {
              title: '로그인 정보',
              logout: '로그아웃',
            },
            payment: {
              title: '구독 정보',
              changePayment: '결제 수단 변경',
              updateSubscription: '요금제 변경',
              cancelSubscriptionChange: '구독 변경 취소',
              history: '결제 기록 보기',
              cancel: '구독 취소',
              currentSubscription: '현재 요금제',
              nextPaymentDate: '다음 결제일',
              currentCycle: '현재 주기',
              nextCreditResetDate: 'Next credit reset date',
              nextSubscriptionType: '다음 요금제',
            },
            question: {
              title: '문의 사항',
              contentPre: '결제 및 환불 관련 기타 질문은',
              contentLink: '문의사항',
              contentPost: '탭을 이용해 주시면 감사하겠습니다',
            },
          },
          subscriptionType: {
            FREE: '무료',
            BASIC: '기본',
            PRO: '프로',
            PREMIUM: '프리미엄',
            BASIC_YEARLY: '기본 (YEARLY)',
            PRO_YEARLY: '프로 (YEARLY)',
            PREMIUM_YEARLY: '프리미엄 (YEARLY)',
          },
        },
        paymentModal: {
          title: '결제 기록',
          date: '날짜',
          info: '정보',
          amount: '금액',
        },
      },
    },
    th: {
      translation: {
        languageDetector: 'th',
        requestFailed: 'คำขอไม่สำเร็จ โปรดลองอีกครั้ง',
        pageLoadFailed: 'ไม่สามารถโหลดได้ โปรดรีเฟรชหน้าเว็บนี้',
        signIn: 'เข้าสู่ระบบ',
        yes: 'ใช่',
        no: 'ไม่',
        trainingCountText: 'Training Credits',
        genCountText: 'Gen Credits',
        appBar: {
          create: 'Create',
          account: 'Account',
          music: 'AI Music',
          speech: 'AI Speech',
          image: 'AI Image',
          video: 'AI Video',
          history: 'History',
        },
        defaultModels: ['เสียงตัวอย่าง (ชาย)'],
        trainingTab: {
          title: 'สร้างโมเดลเสียง AI',
          tabs: ['สร้างโมเดลใหม่', 'โมเดลพร้อมใช้'],
          stepOne: {
            title: 'อัปโหลดเสียงของคุณ',
            tooltip: {
              titleOne: 'คำแนะนำ',
              contentsOne: [
                'คุณภาพสำคัญกว่าความยาว เสียงที่คุณภาพดี 15 นาที จะใช้ได้ดีกว่าเสียงที่มีคุณภาพต่ำยาว 30 นาที',
                'ไม่ควรใช้ เสียงที่ใส่เอฟเฟกต์มากเกินไป เช่น ออโต้จูน',
                'เสียงที่อัดในสตูดิโอ จะใช้ได้ดีกว่าเสียงที่อัดจากการแสดงสด',
                'โปรดใช้เพลงร้องเดี่ยว ไม่ใช้เพลงที่ร้องคู่',
                'ใช้เสียงร้องเพลงมากกว่าเสียงสนทนา',
                'ถ้าคุณอยากสร้างเพลงแร็พ ให้อัพโหลดเสียงของคุณตอนที่คุณกำลังแร็พอยู่',
              ],
              titleTwo: 'กรณีใช้เสียงตัวเอง',
              contentsTwo: [
                'สามารถใช้มือถืออัดเสียงตัวเองได้',
                'สามารถอัพโหลดคลิปเสียงหลายๆคลิปได้ ไม่จำเป็นต้องเป็นคลิปยาวคลิปเดียว',
                'แนะนำให้อัดเสียงในสภาพแวดล้อมที่เงียบสนิท',
                'อย่าบันทึกเสียงในห้องคาราโอเกะ',
                'กรุณาตรวจสอบว่าการบันทึกสำเร็จหรือไม่ก่อนที่จะอัปโหลด',
              ],
            },
            trainingSubTitles: ['อัปโหลดไฟล์เสียง'],
            externalSubTitles: ['อัปโหลดโมเดลพร้อมใช้'],
            dragAndDropText: 'ลากและวางไฟล์',
            dragAndDropDuration: '(ความยาวเสียงของไฟล์ทั้งหมดรวมกัน {{minDuration}}-{{maxDuration}} นาที)',
            dragAndDropButton: 'เลือกไฟล์',
            durationText: 'ความยาวเสียงทั้งหมด',
            durationUnit: 'นาที',
            tabs: {
              fileUpload: {
                vocalExtractionText: 'ไฟล์นี้เป็นไฟล์ที่แยกเฉพาะเสียงร้องใช่หรือไม่?',
                vocalExtractionYes: 'ใช่',
                vocalExtractionNo: 'ไม่ใช่',
                vocalExtractionTooltip: {
                  title: 'อะไรคือการแยกเสียงร้องออกจากเพลง?',
                  contents: [
                    'คลิก “ใช่” เฉพาะในกรณีที่ไฟล์ที่กำลังจะอัพโหลด ได้ถูกแยกเสียงร้องออกมาแล้วเท่านั้น',
                    'ไม่ต้องใช้ในกรณีส่วนใหญ่',
                  ],
                },
              },
            },
          },
          stepTwo: {
            title: 'ตั้งชื่อ',
            subTitles: ['กรุณาตั้งชื่อเสียง AI และเทรนโมเดล'],
            placeholder: 'Give a label to your model',
          },
          submit: {
            upload: 'อัพโหลด',
            free: 'กรุณาสมัครสมาชิก',
            inProgress: 'อยู่ระหว่างดำเนินการ',
            noRemaining: 'คุณไม่มีเครดิตเหลือแล้ว',
            start: 'เริ่มเทรน',
            uploading: 'กำลังอัพโหลด',
            remainingCountText: 'Training Credits left',
            tooltip: {
              contents: [
                'การเทรนนิ่งจะใช้เวลาประมาณ 0.5-1 ชม',
                'อาจใช้เวลานานกว่านี้หากมีผู้ใช้จำนวนมาก',
                'คุณสามารถตรวจสอบสถานะได้ในแท็บ “ประวัติ”',
              ],
            },
          },
          modal: {
            exceedModelCount:
              'จำนวนเสียง AI ที่สามารถเก็บไว้ในระบบได้เต็มแล้ว โปรดไปที่แท็บการผลิตและลบเสียงที่มีอยู่ของคุณออก หรือเปลี่ยนไปใช้แพลนที่สูงขึ้น',
            exceedMaxDuration: 'คุณไม่สามารถอัปโหลดคลิปเสียงที่นานกว่า {{maxDuration}} นาทีได้',
            minDuration: 'กรุณาอัปโหลดคลิปเสียงที่มีความยาวอย่างน้อย {{minDuration}} นาที',
            notSupportedFileType: 'ไม่รองรับไฟล์ประเภทนี้',
            imgModalConfirm: 'เริ่ม',
            imgModalCancel: 'กลับไป',
            noLabel: 'กรุณาตั้งชื่อ',
            missingFile: 'โปรดส่งไฟล์ทั้งหมด',
            noFile: 'Please upload files',
            longLabel: 'Label cannot exceed 25 characters',
          },
        },
        communityUploadTab: {
          title: 'อัพโหลดที่คอมมิวนิตี้',
          tabs: [' แชร์ ', 'โมเดลจากที่อื่น'],
          stepOne: {
            tabs: {
              fileUpload: {
                dragAndDropText: 'ลากและวางไฟล์ที่นี่',
              },
            },
            title: 'ขั้นตอนที่ 1: อัพโหลดรูป',
            subTitles: ['อัพโหลดรูปโปรไฟล์ที่นี่'],
          },
          stepTwo: {
            title: 'ขั้นตอนที่ 2: เลือกโมเดลเสียง',
            trainingSubTitles: ['เลือกโมเดลเสียงที่คุณอยากแชร์'],
            externalSubTitles: ['โปรดอัพโหลดโมเดลเสียงที่คุณอยากแชร์'],
            dragAndDropText: ['อัพโหลดไฟล์ Path', 'อัพโหลดไฟล์ Index'],
            dragAndDropButton: 'เลือกไฟล์',
            voice: 'เสียง',
          },
          stepThree: {
            title: 'ขั้นตอนที่ 3: ตั้งชื่อให้โมเดล',
            subTitle: 'โปรดตั้งชื่อให้โมเดล',
            genderLabel: 'โปรดเลือกเพศของโทนเสียงโมเดลที่คุณอยากแชร์',
            gender: ['ชาย', 'หญิง'],
            anonymousText: 'ซ่อนชื่อโปรไฟล์ของฉัน',
          },
          stepFour: {
            title: 'ขั้นตอนที่ 4: เลือก Tag',
            subTitle: 'โปรดเลือก Tag ประเภทที่เหมาะสมกับโมเดลเสียงของคุณ',
            tags: ['ประเภท', 'ประเทศ'],
          },
          submit: {
            upload: 'แชร์',
            start: 'แชร์',
            uploading: 'กำลังอัพโหลด โปรดรอสักครู่',
          },
          modal: {
            noImage: 'Please upload an image',
            noModel: 'Please select a voice model to share',
            noTag: 'Please select at least one tag for each field',
            noLabel: 'Please give a label',
            longLabel: 'Label cannot exceed 25 characters',
          },
        },
        inferenceTab: {
          title: 'สร้าง Cover เพลง AI',
          stepOne: {
            tooltip: {
              title: 'คำถามที่พบบ่อยในการสร้าง Cover เพลง AI',
              contents: [
                'คุณภาพเสียงของเสียงต้นแบบมีความสำคัญมากต่อผลลัพธ์',
                'เสียงที่อัดในสตูดิโอ จะใช้ได้ดีกว่าเสียงที่อัดจากการแสดงสดง',
                'ไม่ควรใช้ เสียงที่ใส่เอฟเฟกต์มากเกินไป เช่น ออโต้จูน',
                'ไม่แนะนำสำหรับเพลงที่มีเสียงคอรัสเยอะๆ',
              ],
            },
            title: 'อัปโหลดเพลง',
            subTitles: ['โปรดอัปโหลดเพลงที่คุณต้องการ Cover'],
            tabs: {
              fileUpload: {
                title: 'อัปโหลดไฟล์',
                dragAndDropText: 'ลากและวางไฟล์',
                dragAndDropButton: 'เลือกไฟล์',
                dragAndDropDuration: '(รองรับไฟล์ได้สูงสุด 75 MB)',
                vocalExtractionText: 'ไฟล์นี้เป็นไฟล์ที่แยกเฉพาะเสียงร้องใช่หรือไม่?',
                vocalExtractionYes: 'ใช่',
                vocalExtractionNo: 'ไม่ใช่',
                vocalExtractionTooltip: {
                  title: 'อะไรคือการแยกเสียงร้องออกจากเพลง?',
                  contents: [
                    'คลิก “ใช่” เฉพาะในกรณีที่ไฟล์ที่กำลังจะอัพโหลด ได้ถูกแยกเสียงร้องออกมาแล้วเท่านั้น',
                    'ไม่ต้องใช้ในกรณีส่วนใหญ่',
                  ],
                },
              },
              youtube: {
                title: 'ลิงค์ยูทูป',
                linkPlaceholder: 'ไม่เกิน 10 นาทีเท่านั้น',
                linkbutton: 'ใช้',
                durationUnit: ['นาที', 'วินาที'],
              },
              recording: {
                title: 'การบันทึกเสียง',
                startButton: 'เริ่มการบันทึก',
                saveButton: 'บันทึก',
                recordingButton: 'การบันทึก',
                userRecording: 'เสียงบันทึกจากผู้ใช้งาน',
              },
              ttm: {
                title: 'AI Music',
                button: 'Select / Create AI Song',
              },
            },
          },
          stepTwo: {
            title: 'เลือกเสียง AI',
            modelInput: {
              placeHolder: 'เลือก AI Voice Model',
              myModel: 'โมเดลของฉัน',
              defaultModel: 'โมเดลพื้นฐาน',
            },
            keyInput: {
              title: 'การปรับคีย์',
              tooltip: {
                contents: [
                  'เมื่อคัฟเวอร์เพลงผู้หญิงด้วยเสียงผู้ชาย แนะนำให้ใช้ -4 ถึง -6',
                  'เมื่อคัฟเวอร์เพลงผู้ชายด้วยเสียงผู้หญิง แนะนำให้ใช้ +4 ถึง +6',
                  'การปรับคีย์มากเกินไปอาจทำให้คุณภาพเสียงลดลง',
                ],
              },
            },
            dragAndDropText: 'คลิปที่นี่เพื่อเลือกโมเดลเสียง AI',
          },
          stepThree: {
            title: 'Configuration',
            subTitles: 'เลือกการตั้งค่ามิกเซอร์, รูปแบบเอาท์พุต, และตั้งชื่อ Cover ของคุณ',
            labelInput: {
              placeHolder: 'กรุณาตั้งชื่อ',
            },
            ouputFormatLabel: 'กรุณาเลือกประเภทไฟล์ในการออก Cover',
            tooltip: {
              outputFormatMessage: 'ไฟล์ประเภท WAV สำหรับแพลน PRO/PREMIUM เท่านั้น',
              upgradePrompt: 'คลิกที่นี่เพื่ออัพเกรด',
              subscribePrompt: 'คลิกที่นี่เพื่อสมัครสมาชิก',
              title: 'สิ่งนี้หมายความว่า?',
              contents: ["ถ้าไม่มีการตั้งค่า จะตั้งต้นที่ 'เสียง - ที่มา'", 'สามารถเปลี่ยนได้ทีหลังที่ "ประวัติ'],
            },
          },
          submit: {
            completedAndLoadingPlayer:
              'สร้างสำเร็จเรียบร้อย กำลังโหลดเครื่องเล่นเสียง หรือผู้ใช้งานสามารถดาวน์โหลดเพลงได้ในแท็บ ‘ประวัติ’',
            alreadyInProgress: 'อยู่ระหว่างดำเนินการ',
            noRemaining: 'เครดิตของเดือนนี้หมดแล้ว',
            start: 'เริ่มการแปลงเสียง',
            uploading: 'กำลังอัพโหลด กรุณารอสักครู่',
            tryAgain: 'โปรดลองอีกครั้ง',
            tryAgainYoutubeDown: 'โปรดลองอีกครั้ง หากการอัปโหลด YouTube ล้มเหลวอย่างต่อเนื่อง โปรดใช้การอัปโหลดไฟล์แทน',
            inProgress:
              'กำลังอยู่ระหว่างดำเนินการ - คุณสามารถที่จะทิ้งหน้านี้ไว้ หรือ ปิดหน้านี้ลง และ ตรวจสอบสถานะได้ในแท็บ “ประวัติ”',
            remainingCountText: 'Gen Credits left',
            tooltip: {
              contents: [
                'การสร้าง Cover เพลง AI ใช้เวลาประมาณ 1-4 นาที',
                'อาจใช้เวลานานขึ้นเล็กน้อยหากมีผู้ใช้จำนวนมาก',
                'คุณสามารถตรวจสอบสถานะได้ในแท็บ “ประวัติ”',
              ],
            },
          },
          modal: {
            watermark:
              'เวอร์ชั่นฟรีจะมาพร้อมกับลายน้ำในไฟล์เสียง ผู้ใช้งานสามารถสมัครสมาชิกเพื่อรับไฟล์เสียงที่ไม่มีลายน้ำได้',
            exceedModelCount:
              'Basic Plan จัดให้คุณเก็บ voice model ได้สูงสุด 3 โมเดลเท่านั้น หากต้องการดำเนินการต่อ โปรดลบโมเดลที่มีอยู่',
            exceedMaxSize: 'คุณสามารถอัปโหลดไฟล์ได้สูงสุด 75MB เท่านั้น',
            tooManyFiles: 'สามารถอัพโหลดได้เพียง 1 ไฟล์เท่านั้น',
            notSupportedFileType: 'ไม่รองรับรูปแบบไฟล์นี้',
            inProgress: 'กำลังดำเนินการ',
            noRemaining: 'คุณได้ใช้เครดิตที่มีอยู่หมดแล้ว',
            emptyYoutubeLink: 'อัพโหลดเพลงที่คุณต้องการคัฟเวอร์',
            noModalSelected: 'โปรดเลือกโมเดล',
            noLabel: 'กรุณาตั้งชื่อ',
            invalidYoutubeLink: 'ลิงก์ YouTube ไม่ถูกต้อง',
            youtubeLinkTooLong: 'คุณไม่สามารถใช้ลิงค์ของ YouTube ที่นานกว่า 10 นาทีได้',
            longLabel: 'Label cannot exceed 100 characters',
          },
        },
        ttsInferenceTab: {
          title: 'AI แปลงข้อความเป็นเสียงพูด',
          stepOne: {
            title: 'เลือกเสียง AI',
            modelInput: {
              placeHolder: 'เลือกโมเดลเสียง AI',
              myModel: 'โมเดลของฉัน',
            },
            ttsTextAreaPlaceholder: 'พิมพ์ข้อความที่จะแปลงเป็นเสียงพูดที่นี่',
            dragAndDropText: 'คลิกเพื่อหาและเลือกโมเดลเสียง',
          },
          stepTwo: {
            title: 'ใส่ข้อความที่จะแปลง',
          },
          submit: {
            completedAndLoadingPlayer:
              "แปลงข้อความเป็นเสียงเรียบร้อย กำลังโหลดเครื่องเล่นเสียง หรือผู้ใช้งานสามารถเข้าไปดาวน์โหลดไฟล์ได้ที่ 'เสียงพูด AI' ใน แท็บด์ 'ประวัติ TTS'",
            alreadyInProgress: 'กำลังดำเนินการ',
            noRemaining: 'ไม่มีเครดิตเหลือสำหรับเดือนนี้',
            start: 'เริ่ม',
            uploading: 'กำลังอัพโหลด - โปรดรอสักครู่',
            tryAgain: 'โปรดลองอีกครั้ง',
            inProgress:
              "กำลังแปลงข้อความเป็นเสียง -  คุณสามารถที่จะทิ้งหน้านี้ไว้ หรือ ปิดหน้านี้ลง และ ตรวจสอบสถานะได้ใน 'เสียงพูด AI' ใน แท็บด์ 'ประวัติ TTS'",
            requiredCredits: 'Required credits',
            remainingCredits: 'Remaining credits',
            setting: 'ตั้งค่า',
          },
          modal: {
            selectModalTitle: 'โมเดลเสียง AI',
            addNewModelText: 'คลิกเพื่อสร้างโมเดลเสียงใหม่',
            exceedTextSize: 'สามารถแปลงได้ไม่เกิน {{characterLimitPerInference}} ตัวอักษรในเวลาเดียวกัน',
            inProgress: 'อยู่ในระหว่างการแปลงเสียง',
            noRemaining: 'ไม่มีเครดิตเหลือสำหรับเดือนนี้',
            noModalSelected: 'โปรดเลือกโมเดลเสียง',
            noText: 'โปรดใส่ข้อความ',
            variability: 'ความเสถียรของเสียง',
            stable: 'เสถียร',
            variable: 'ความขึ้นลงของโทนเสียง',
            similarity: 'ความเหมือน',
            low: 'ต่ำ',
            high: 'สูง',
            longLabel: 'Label cannot exceed 50 characters',
          },
        },
        ttiInferenceTab: {
          title: 'Text To Image',
          stepOne: {
            title: 'Select an image model and set its similarity (optional)',
            modelTag: ['People', 'Style'],
            plusButton: 'Click to find an image model',
            modelStrength: 'Similarity',
            duplicateModels: 'Duplicate models exist',
          },
          stepTwo: {
            title: 'Write a description for the image',
            subTitles: ['Describe the image that the AI will generate'],
            ttiTextAreaPlaceholder: 'Type your desired text and the AI will generate an image for you',
          },
          stepThree: {
            title: 'Generate Result Image',
            subtitle: '(Required generation credits: 2)',
          },
          ttiCommunityTab: {
            title: 'AI Image Models',
            categoryTab: ['My Models'],
            createNewModel: 'Create Image Model',
          },
          submit: {
            alreadyInProgress: 'In Progress',
            noRemaining: 'No remaining credits left for this month',
            start: 'Start',
            tryAgain: 'Please Try Again',
            requiredCredits: 'Credits Required',
            remainingCredits: 'Remaining Credits',
            setting: 'Setting',
            nsfwWarning: ['NSFW text detected', 'Three violations will block upload for 1 minute'],
            nsfwBlock: ['Repeated NSFW text detected', 'Upload blocked for 1 minute'],
            uploading: ['Uploading', 'Please wait a moment'],
            complete: ['TTI Inference completed', 'Loading images...'],
            inProgress: [
              'Converting',
              'You may wait or leave the page and download the image in the "History" tab',
              'Creation may take 1-5 minutes depending on the settings',
            ],
            inProgressNoTick: ['Converting', 'You may download the image in the "History" tab'],
          },
          modal: {
            exceedTextSize: 'Can not convert more than {{characterLimitPerInference}} characters at a time',
            inProgress: 'Conversion in progress',
            lackRemaining: 'Lack remaining credits',
            noText: 'Please add text',
            setting: 'Setting',
            ratio: 'Aspect Ratio',
            size: 'Size',
            quality: 'Quality',
            guidance: 'CFG Scale',
            watermark: 'Watermark',
            quantity: 'Quantity',
            horizontal: '16:9',
            vertical: '9:16',
            square: '1:1',
            small: 'Small',
            medium: 'Medium',
            large: 'Large',
            low: 'Low',
            moderate: 'Moderate',
            high: 'High',
            creative: 'Creative',
            balanced: 'Balanced',
            strict: 'Strict',
            on: 'On',
            off: 'Off',
            longLabel: 'Label cannot exceed 25 characters',
          },
          tooltip: {
            watermarkContents: [
              'Turning on the watermark adds the SoriSori logo to your image',
              'Only Pro or Premium users can disable the watermark',
            ],
            ratioContents: [
              'Choose the desired aspect ratio for your image',
              '16:9 (Horizontal): Ideal for widescreen displays, presentations, and landscape-oriented content',
              '9:16 (Vertical): Best for mobile content, stories, and portrait-oriented designs',
              '1:1 (Square): Perfect for social media posts, providing a balanced and versatile format',
            ],
            sizeContents: [
              'Choose the image size, based on the aspect ratio',
              '16:9 (Horizontal):',
              'Small: 640x360px - Suitable for lightweight contents',
              'Medium: 960x544px - Great for standard quality needs',
              'Large: 1280x720px - Perfect for high-quality displays',
              '9:16 (Vertical):',
              'Small: 360x640px - Ideal for mobile-friendly stories',
              'Medium: 544x960px - A good balance with enhanced clarity',
              'Large: 720x1280px - Best for full-screen mobile designs',
              '1:1 (Square):',
              'Small: 480x480px - Suitable for quick previews',
              'Medium: 720x720px - Excellent for social media posts with good resolution',
              'Large: 1080x1080px - Best for high-quality social media contents',
            ],
            guidanceContents: [
              'CFG (Classifier-Free Guidance) Scale determines the balance between creativity and adherence to the input prompt',
              'Creative (2.0): Prioritizes imaginative and diverse outputs, potentially deviating from the prompt',
              'Balanced (3.5): Strikes a harmony between creativity and prompt accuracy (Recommended)',
              'Strict (5.0): Ensures precise adherence to the prompt, with less creative flexibility',
            ],
            stepsConetents: [
              'The quality of the generated image depends on the time spent refining it',
              'Low (20 steps): Produces images quickly with basic details',
              'Medium (30 steps): Creates images with more detail and a good balance of quality',
              'High (40 steps): Generates the most detailed and refined images but takes more time',
            ],
            batchSizeContents: [
              'Quantity refers to the number of images to process at the same time',
              'The number of images you want to process simultaneously',
              '1: Processes one image at a time',
              '2: Processes two images at a time.',
              '3: Processes three images at a time',
              '4: Processes four images at once',
            ],
            coinContents: [
              '2 credits per image',
              'Requires extra credits based on the setting',
              'Max size costs 1 additional credit',
              'Max quality costs 1 additional credit',
              'Max cfg scale costs 1 additional credit',
            ],
          },
          dialog: {
            title: "Sorry, this feature isn't available for you",
            text: 'Upgrade to PRO or PREMIUM tier to get access to the setting feature!',
          },
        },
        ttsTrainingTab: {
          title: 'เทรนนิ่งเสียงสำหรับแปลงข้อความเป็นเสียง AI',
          stepOne: {
            tooltip: {
              contentsOne: [
                'เน้นคุณภาพมากกว่าปริมาณ ใช้เสียงตัวอย่างคุณภาพดีความยาว 5 นาทีนั้นดีกว่าใช้เสียงคุณภาพไม่ดีความยาว 10 นาที',
                'โปรดใช้เสียงตัวอย่างที่ชัดเจน ไม่มีเสียงอื่นๆ รบกวน',
                'โปรดเลือกใช้เสียงตัวอย่างจากการพูดคุยแทนเสียงร้อง',
                'แต่ละไฟล์ควรมีขนาดไม่เกิน 10mb',
                'สามารถอัพโหลดได้สูงสุด 10 ไฟล์',
              ],
            },
            sizeLimitText: '(แต่ละไฟล์ควรมีขนาดไม่เกิน 10mb)',
            numberLimitText: '(สูงสุด 10 ไฟล์)',
            dragAndDropDuration: '(ความยาวเสียงของไฟล์ทั้งหมดรวมกัน {{minDuration}}วินาที-{{maxDuration}}นาที)',
            second: 'วินาที',
          },
          modal: {
            sizeTooLarge: 'แต่ละไฟล์ควรมีขนาดไม่เกิน 10mb',
            tooManyFiles: 'สามารถอัพโหลดได้สูงสุดไม่เกิน 10 ไฟล์',
            exceedMaxDuration: 'คุณไม่สามารถอัปโหลดคลิปเสียงที่นานกว่า {{maxDuration}} นาทีได้',
            minDuration: 'กรุณาอัปโหลดคลิปเสียงที่มีความยาวอย่างน้อย {{minDuration}} วินาที',
            duplicateFiles: 'ไม่สามารถอัปโหลดไฟล์ที่ซ้ำกันได้',
          },
          submit: {
            tooltip: {
              contents: [
                'การเทรนโมเดลเสียงใช้เวลา 0.5-10 นาทีโดยประมาณ',
                'ระยะเวลาการเทรนโมเดลอาจขึ้นกับแพ็กเกจของสมาชิก',
                "คุณสามารถเข้าไปดูสถานะได้ที่'เสียง AI' ใน แท็บด์ 'ประวัติ TTS'",
              ],
            },
          },
        },
        ttiTrainingTab: {
          title: 'Text To Image Training',
          stepOne: {
            title: 'Upload Image Files and Select Cover Image',
            dragAndDropText: 'Drag and drop image files',
            sizeLimitText: '(Max 10 MB each)',
            numberLimitText: ['(Min 5 Files ~ Up to ', ' Files)'],
            thumbnailTag: 'Thumbnail',
            nsfwBlockMessage:
              'Some of the uploaded images were detected as inappropriate and will not be used for training',
            tooltip: {
              contents: [
                'The more images you upload, the better the model quality',
                'Images containing inappropriate content will not be used for training',
              ],
            },
          },
          stepTwo: {
            title: 'Select Model Type',
            usage: ['Person', 'Style'],
            tooltip: {
              contents: [
                '"Person" models learn to generate images of people, animals, or objects (e.g., humans, cats, cars).',
                '"Style" models learn specific artistic styles or details to generate images (e.g., cartoon, watercolor, Studio Ghibli).',
              ],
            },
          },
          stepThree: {
            title: 'Set Training Quality',
            subTitles: 'Quality increases with larger numbers',
            sliderLabel: 'Training Quality',
            tooltip: {
              contents: [
                'A higher training quality value improves the overall model performance.',
                'Level-1 learning quality requires 500 training iterations, and each higher level adds another 500 iterations.',
                'Increasing training quality enhances the detail and fidelity of generated images.',
              ],
            },
          },
          stepFour: {
            title: 'Label Your Model',
            placeholder: 'Use a name that clearly describes the model',
            tooltipEx:
              '(e.g. Donald Trump, the 45th and 47th President of the United States, Hollywood actress Emma Watson)',
          },
          modal: {
            fileUpgrade: ['With your current plan, you can only upload up to ', ' files.'],
            stepUpgrade: 'With your current plan, you can only train up to 1 step.',
            upgradeButton: 'Upgrade Subscription',
            nsfwChecking: 'Uploading image files. Please wait a moment.',
            uploadSuccess: 'The model was successfully uploaded. You can view the created model in the "History" tab.',
            longLabel: 'The name cannot exceed 25 characters.',
          },
          submit: {
            tooltip: {
              contents: [
                'Training quality level 1 is free.',
                'Levels 2 and above are available only for Pro/Premium users.',
                'From level 2 onward, each increase in quality consumes 1 credit.',
                'AI image training takes 10~60 minutes, depending on file count and quality.',
              ],
            },
          },
        },
        ttmInference: {
          title: 'AI Text To Music',
          stepOne: {
            title: 'Describe Your Style & Lyrics',
            promptMethod: {
              prompt: 'Prompt',
              tags: 'Tags',
              tooltip: {
                title: 'Style',
                contents: [
                  'Prompt: Enter a prompt to describe the style of music you want, generates more unique results',
                  'Tags: Select tags to describe the style of music you want, generates more accurate and consistent results',
                  'If left empty, style will be generated based on the lyrics',
                ],
              },
            },
            lyricMethod: {
              generate: 'Generate Lyrics',
              custom: 'Custom',
              tooltip: {
                title: 'Lyrics',
                contents: [
                  'Generate lyrics: Enter a prompt to describe the subject and style of lyrics you want',
                  'Custom: Enter your own lyrics, make sure to structure your lyrics with the provided labels',
                  'If left empty, lyrics will be generated based on the style',
                ],
              },
            },
            instrumental: 'Instrumental',
            noOptions: 'No options',
            placeholder: {
              prompt: 'Describe your style',
              tags: 'Search for tags',
              generateLyrics: 'Describe your lyrics',
              customLyrics: 'Enter your lyrics',
            },
            tooltip: {
              contents: [
                'Recommended to provide inputs for style and lyrics for a more accurate sound',
                'You can also skip style or lyrics and let AI generate them for you, based on your input',
                'If instrumental mode is on, you must provide a prompt or tags',
              ],
            },
          },
          stepTwo: {
            title: 'Create an AI Cover (optional)',
            selectVoice: 'Select AI Voice',
            tooltip: {
              contents: ['Costs 1 extra Gen Credit'],
            },
          },
          stepThree: {
            title: 'Output Settings',
            placeholder: 'Enter a label for your song',
            tooltip: {
              outputFormatMessage: 'ไฟล์ประเภท WAV สำหรับแพลน PRO/PREMIUM เท่านั้น',
              upgradePrompt: 'คลิกที่นี่เพื่ออัพเกรด',
              subscribePrompt: 'คลิกที่นี่เพื่อสมัครสมาชิก',
            },
          },
          submit: {
            creditUsage: 'Gen Credits per song',
            info: ['Song generation takes 30-40 seconds', 'AI Cover will take an additional 1-4 minutes'],
            start: 'Start',
            alreadyInProgress: 'In Progress',
            uploading: 'Uploading - Please wait a moment',
            inProgress: 'Generating - You may wait or leave the page and download the song in the "History" tab',
            completedAndLoadingPlayer:
              'Song generation completed. Loading audio player, but you may also download the song in the "History" tab',
            completedCoverAndLoadingPlayer:
              'AI cover generation completed. Loading audio player, but you may also download the song in the "History" tab',
            tryAgain: 'Please try again',
            lackRemaining: 'Not enough remaining gen credits',
          },
          modal: {
            inProgress: 'Generation in progress',
            coverInProgress: 'AI cover generation in progress',
            lackRemaining: 'Not enough remaining gen credits',
            emptyParams: 'Please enter a prompt, tags, or lyrics',
            noLabel: 'Please add a label',
            longLabel: 'Label cannot exceed 100 characters',
          },
          selectModal: {
            generate: {
              title: 'Generate AI Song',
              button: 'Create',
            },
            history: {
              title: 'History',
              button: 'History',
              searchbar: 'Search',
            },
          },
        },
        videoEditorTab: {
          title: 'Video Editor',
          addSource: 'Source',
          tooltip: {
            hide: 'Hide source',
            mute: 'Mute source',
            move: 'Move source',
            scale: 'Resize source',
            resetScale: 'Reset source size',
            snap: 'Enable timeline snapping',
            addText: 'Add a text source',
            editText: 'Edit selected text',
            zoom: 'Zoom in/out timeline',
          },
          modal: {
            longLabel: 'Label cannot exceed 50 characters',
          },
        },
        addSourceModal: {
          title: 'Add a source',
          sourceOptions: ['AI Cover', 'TTS', 'Youtube', 'Upload'],
          searchbar: 'Search',
          pagination: {
            loader: 'Loading...',
          },
          voice: 'AI Voice',
          youtube: {
            placeholder: 'Max 10 minutes',
            button: 'Search',
            invalidYoutubeLink: 'This is an incorrect YouTube link',
            youtubeLinkTooLong: 'The YouTube video may not exceed 10 minutes',
          },
          upload: {
            dragAndDropText: 'Drag and drop a video/audio/image file',
            sizeLimitText: '(Max 75 MB)',
            acceptedAudio: '.mp3, .wav, .flac, and .ogg',
            acceptedVideo: '.mp4 and .mkv',
            acceptedImage: '.jpeg, .png, and .webp',
            button: 'Select file',
            notSupportedFileType: 'This file format is not supported',
            tooManyFiles: 'Please upload one file at a time',
            exceedMaxSize: 'You can only upload files up to 75MB',
          },
          loading: ['Uploading file', '(may take up to a minute for larger files)'],
        },
        textEditorModal: {
          title: ['Add text', 'Edit text'],
          placeholder: 'Type your text here...',
          add: 'Add',
          save: 'Save',
        },
        videoExportModal: {
          title: 'Export video',
          placeholder: 'Give your exported video a label',
          watermark: 'Show watermark',
          start: 'Start',
          rendering: [
            'You may wait or leave the page and download the video in the "History" tab',
            'Exporting your video (may take up to a minute)',
          ],
          success: ['Video is ready', 'Your download will start automatically. If not, click the button below.'],
          tooltip: {
            contents: [
              'Export time will depend on the length of your video',
              'You will be taken to the History tab where you can check the progress',
            ],
          },
          videoRenderError: 'Could not render the video. Please try again',
        },
        // faceSwapTab
        faceSwapTab: {
          title: 'Face Swap',
          stepOne: {
            title: 'Step 1: Upload and Trim Your Video',
            subTitles:
              'Please upload the video you want to perform face swapping on, and edit it to the desired segment',
            tags: {
              sourceFile: 'Source File',
            },
            dragAndDropText: 'Drag and drop file',
            dragAndDropButton: 'Select File',
            dragAndDropDuration: '(Max 75 MB)',
            dragAndDropFormat: '(Supported Formats: mp4, mov)',
            youtubeLinkText: 'Please enter the YouTube link you want',
            youtubeLinkInput: 'Enter the YouTube link here (Max 15 mins)',
            trimVideo: ['You do not have enough credits', 'Please trim the video to less than ', ' seconds'],
          },
          stepTwo: {
            title: 'Step 2: Select Faces You Want To Change',
            subTitles:
              'Please select faces you want to change from your video, and replace the selected face from the previous step with your desired face',
            tags: {
              preview: 'Preview',
              detectedFaces: 'Recognized Faces',
            },
            settings: {
              title: 'Settings',
              sharpness: 'Sharpness of the Swapped Face',
              blendRatio: 'Original-Swapped Image Blend Ratio',
              watermark: 'Watermark',
              leftCoin: ['You have ', ' credits left'],
              poorCoin: [
                'You are short of ',
                ' credits ',
                'Please reduce the number of faces',
                'or trim the video length',
              ],
              requiredCoin: ' credits required',
              blednRatioMarks: ['Very Low', 'Low', 'High', 'Very High'],
              originalVideo: 'Quality Enhancement Not Set',
              compareQuality: 'Blend Ratio Settings Comparison',
            },
          },
          stepThree: {
            title: 'Step 3: Face Swap Completed',
            subTitles: 'Check out the resulting image or video created by swapping faces',
            tags: {
              sourceFile: 'Final Video',
            },
          },
          button: {
            settings: 'Settings',
            start: 'Start',
            selectImage: 'Select Image',
            apply: 'Apply',
            createNew: 'Create New',
            preview: 'Preview',
            inProgress: 'In Progress',
            goToHistory: ['History', 'Check'],
            prev: 'Prev',
            next: 'Next',
            buyCredit: 'Buy Credits',
          },
          dialog: {
            upgradeText: 'Upgrade to PRO or PREMIUM tier to get access to remove the watermark!',
            faceSelectionModal: 'Choose A Face',
            renderingError: [
              'An error occurred while loading the result video',
              'The credits you used were not deducted',
            ],
            reload: 'Try Again',
            videoLabelPlaceholder: 'Enter video title',
            sharpnessOn: 'Upgrade to PRO or PREMIUM tier to get access to use Sharpness of the Swapped Face!',
          },
          loading: {
            1: 'Detecting faces ...',
            2: 'Finding faces ...',
            3: 'preparing the result video',
            4: 'preparing preview image',
            5: 'ready for the result video',
            youtubeLinkUpload: {
              1: 'We are processing your video.',
              2: 'Depending on its length, it may take between 1 to 4 minutes.',
            },
            finalVideoGenerating: [
              'Your video is currently being processed',
              "Depending on the video's length and the number of faces being transformed, this may take approximately 2-5 minutes",
              'Please wait until the process is complete to play the video immediately',
              "If you leave the screen before it's finished, you can still monitor the production status and download the video later from the 'History' tab",
            ],
          },
          error: {
            facesInImage: 'Error while processing the face images',
            invalidFileType: 'Please upload .png or .jpeg file',
            fileTooLarge: 'Please upload under 10MB',
            noFacesSelected: 'Please select at least one face you want to change',
            noFacesDetected: 'Please try again with a different image that clearly shows a face',
            noFacesFound: 'No face detected. Please upload a video containing a face and try again.',
            faceDetectApiError: 'Please check your internet connection and try again',
            showPreview: 'Error while showing preview',
            uploadFailed: 'Failed to upload the result video',
            renderingFailed: 'Failed to render the result video',
            pollingError: 'Error while polling',
            pollingTimeout: [
              'We apologize for the inconvenience.',
              'The server response is currently delayed.',
              'You can check and download the status of your ongoing creations in the "History" tab.',
              'If the creation fails, no credits will be deducted.',
            ],
            youtubeLinkTooLong: 'The YouTube video may not exceed 15 minutes',
            downloadFailed: 'Failed to download the result video',
            nsfwVideo: 'NSFW content detected',
          },
          submit: {
            tryAgain: 'Please try again',
          },
          modal: {
            inProgress: 'Conversion in progress',
            noRemaining: [
              'No remaining Faceswap credits left for this month',
              'Upgrade to PRO or PREMIUM tier, or purchase individual products to replenish your credits',
            ],
            longLabel: 'Label cannot exceed 50 characters',
          },
          tooltip: {
            sharpness: {
              1: 'It is a technology that enhances resolution by inserting new pixels between existing pixels in an image.',
              2: 'It can improve the sharpness of the face image you upload (upscaling).',
              3: 'As the upscaling value increases, the quality and clarity of the face image improve; however, if the background video quality is low, the face may appear unnatural.',
            },
            coinLogic: [
              'Credit Calculation Formula = (credits based on video length) x (Number of faces to change)',
              'Add 15 credits for every 15-second interval based on video length (e.g., 1~15 seconds -> 15 credits, 16~30 seconds -> 30 credits)',
              'Multiply by the number of faces to change (e.g., 14-second video, 2 faces to change -> 15 credits x 2 = 30 credits)',
            ],
            coinCal: [
              'Required number of credits = (Video length: ',
              'Required number of credits = (Video length: ',
              ' sec -> ',
              ' credit ) x ( Number of faces: ',
              ' credit ) x ( Number of faces: ',
              ' ) = ',
              ' credits',
            ],
            coin: 'credits',
            videoLength: 'Trimmed Length:',
            creditUsed: 'Required Credits:',
          },
        },
        // vocalExtractorTab
        vocalExtractorTab: {
          title: 'ตัวแยกเสียง',
          stepOne: {
            title: 'อัพโหลดไฟล์เสียง',
            tabs: {
              fileUpload: {
                title: 'ไฟล์เสียง',
                dragAndDropText: 'ลากและวางไฟล์ที่นี่',
                dragAndDropButton: 'เลือกไฟล์',
                dragAndDropDuration: '(สูงสุด 75 MB)',
              },
              youtube: {
                title: 'Youtube',
                linkPlaceholder: 'สูงสุด 10 นาที',
                linkbutton: 'ค้นหา',
                durationUnit: ['นาที', 'วินาที'],
              },
            },
            vocalExtractorSubTitles: ['อัพโหลดไฟล์เพื่อทำการคัดแยกเสียง'],
            tooltip: {
              contents: [
                'แผน Premium สามารถอัพโหลดไฟล์ได้สูงสุด 10 ไฟล์ต่อครั้ง',
                'แผน Pro สามารถอัพโหลดไฟล์ได้สูงสุด 5 ไฟล์ต่อครั้ง',
                'แผน ฟรีและ Basic สามารถอัพโหลดไฟล์ได้ 1 ไฟล์ต่อครั้ง',
                'ความยาวของไฟล์เสียงทั้งหมดรวมกันต้องไม่เกิน 60 นาที',
              ],
            },
            maxUploadNumText: {
              premiumCustomAdmin: 'อัพโหลดสูงสุด 10 ไฟล์',
              pro: 'อัพโหลดสูงสุด 5 ไฟล์',
              basicFree: 'อัพโหลดสูงสุด 1 ไฟล์',
            },
          },
          stepTwo: {
            title: 'ตั้งชื่อไฟล์แยกเสียง',
            labelInput: {
              placeHolder: 'ตั้งชื่อไฟล์แยกเสียง',
            },
          },
          stepThree: {
            title: 'เลือกประเภทรูปแบบการแสดงผล',
            subTitles: 'เลือกประเภทเอาท์พุตและตั้งชื่อไฟล์แยกเสียงนี้',
            tooltip: {
              outputFormatMessage: 'สามารถโหลดไฟล์ประเภท WAV ได้ในแผน PRO/PREMIUM เท่านั้น',
              upgradePrompt: 'อัพเกรดที่นี่',
              subscribePrompt: 'สมัครที่นี่',
            },
          },
          submit: {
            alreadyInProgress: 'กำลังดำเนินการ',
            upload: 'อัพโหลด',
            inProgress:
              'กำลังดำเนินการ - ผู้ใช้งานสามารถรอหรือออกจากหน้านี้ และสามารถเข้าไปดาวน์โหลดไฟล์ได้ที่หน้า “ประวัติ” ที่เมนูด้านข้าง',
            noRemaining: 'โปรดสมัครสมาชิกเพื่อใช้งานตัวแยกเสียงเพิ่มเติม',
            start: 'เริ่ม',
            uploading: 'กำลังอัพโหลด โปรดรอซักครู่',
            tryAgain: 'กรุณาลองอีกครั้ง',
            remainingCountText: 'Gen Credits left',
          },
          modal: {
            notSupportedFileType: 'ไม่สามารถรองรับไฟล์ประเภทนี้ได้',
            invalidYoutubeLink: 'ลิงก์ Youtube นี้ไม่ถูกต้อง',
            youtubeLinkTooLong: 'วีดีโอจาก Youtube ความยาวต้องไม่เกิน 10 นาที',
            noRemaining: 'โปรดสมัครสมาชิกเพื่อรับเครดิตการเทรนโมเดลเพิ่มเติม',
            emptyYoutubeLink: 'โปรดอัพโหลดเพลงที่ต้องการใช้ตัวถอดเสียง',
            inProgress: 'อยู่ระหว่างดำเนินการถอดเสียง',
            exceedMaxSize: 'สามารถอัพโหลดไฟล์ได้ถึง 75MB',
            exceedMaxDuration: 'ความยาวของเสียงทั้งหมดรวมกันต้องไม่เกิน 60 นาที',
            premiumCustomManyFiles: 'Premium/Custom users can upload',
            proManyFiles: 'Pro users can upload',
            manyFiles: 'files at a time',
            noFiles: 'โปรดอัพโหลดไฟล์เพื่อแยกเสียง',
            lackRemaining: 'โปรดสมัครสมาชิกเพื่อใช้ตัวแยกเสียงเพิ่มเติม',
            uploadStatusNotValid: 'ไม่มีเครดิตหลงเหลือ หรือ กำลังรอการดำเนินการ',
            tryAgain: 'โปรดลองอีกครั้ง:',
            noLabel: 'Please give a label to your vocal extract',
            longLabel: 'Label cannot exceed 50 characters',
          },
        },
        historyTab: {
          title: 'ประวัติ',
          inProgress: 'อยู่ระหว่างดำเนินการ',
          failed: 'Failed',
          freeVersionTag: 'ทดลองใช้ฟรี',
          freePrefix: 'เวอร์ชั่นฟรีจะมาพร้อมลายน้ำ SorisoriAI ในไฟล์เสียง',
          tooltip: {
            contents: [
              'การสร้างไฟล์เสียง ใช้เวลาโดยเฉลี่ย 2-4 นาที',
              'การเทรนโมเดลเสียงใช้เวลาโดยเฉลี่ย 0.5-1 ชั่วโมง',
              'อาจใช้เวลานานขึ้นหากมีผู้ใช้งานจำนวนมาก',
            ],
          },
          tabs: {
            inference: {
              title: 'AI คัฟเวอร์',
            },
            training: {
              title: 'เทรนนิ่งเสียง AI',
            },
            vocalExtract: {
              title: 'ตัวแยกเสียง',
            },
            community: {
              title: 'คอมมิวนิตี้',
            },
            videoEditor: {
              title: 'Video Editor',
            },
            faceSwap: {
              title: 'Face Swap',
            },
            image: {
              title: 'AI Image',
              makeNewAIImage: 'Create New AI Image',
            },
            ttiTraining: {
              title: 'AI Image Model',
              makeNewTraining: 'Create New Image Model',
              style: 'Style',
              object: 'Object',
            },
            ttm: {
              title: 'AI Music',
            },
          },
          changeButton: 'เปลี่ยน',
          cancelButton: 'ยกเลิก',
          confirmModelDelete:
            'คุณแน่ใจว่าต้องการลบหรือไม่? การลบโมเดลจะไม่ช่วยให้คุณได้เครดิตในการสร้างโมเดลที่ได้ใช้ไปแล้วคืนมาหรือเพิ่มขึ้น',
          confirmDelete: 'คุณแน่ใจหรือว่าต้องการลบ?',
          searchbar: 'ค้นหา',
          infoIcon: {
            source: 'แหล่งที่มา',
            voice: 'เสียง',
            pitch: 'คีย์เสียง',
            mixing: {
              title: 'Mixer settings',
              vocalLevel: 'Vocal Level',
              reverbLevel: 'Reverb Level',
              reverbLength: 'Reverb Length',
            },
            tts: {
              voice: 'เสียง',
              variability: 'ความเสถียรของเสียง',
              similarity: 'ความเหมือนของเสียง',
            },
            errorMessage: 'ข้อผิดพลาด',
          },
          pagination: {
            loader: 'กำลังโหลด...',
          },
          modal: {
            error: 'โปรดรีเฟรชหน้านี้',
            label: 'ชื่อ',
            username: 'Username',
            image: 'ภาพ',
            filterError: 'ไม่พบฟิลเตอร์เสียง',
          },
          trainingInfo: {
            files: 'ไฟล์ที่ถูกใช้',
            extracted: 'เสียงร้องที่ถูกแยกแล้ว',
            shared: 'แชร์ในคอมมิวนิตี้แล้ว',
            yes: 'ใช่',
            no: 'ไม่',
            status: 'สถานะ',
            errorFile: 'ไฟล์ที่มีข้อผิดพลาด',
          },
          voice: 'เสียง AI',
          ttmInfo: {
            tags: 'Tags',
            prompt: 'Prompt',
            lyricPrompt: 'Lyric Prompt',
            lyrics: 'Lyrics',
            failed:
              "Text to Music has failed, please try again. If the issue persists, please contact SORISORI's support team.",
          },
          noOptions: 'No options',
          creations: {
            title: 'My Creations',
            tabs: [
              { title: 'AI Cover', tab: 'music' },
              { title: 'Text To Music', tab: 'ttm' },
              { title: 'Text To Speech', tab: 'speech' },
              { title: 'Text To Image', tab: 'image' },
              { title: 'Face Swap', tab: 'faceSwap' },
              { title: 'Vocal Extract', tab: 'vocalExtract' },
              { title: 'Video Editor', tab: 'videoEditor' },
            ],
          },
          models: {
            title: 'My Models',
            tabs: [
              { title: 'AI Cover Training', tab: 'music' },
              { title: 'TTS Training', tab: 'speech' },
              { title: 'TTI Training', tab: 'image' },
              { title: 'Community', tab: 'community' },
            ],
          },
        },
        subscriptionTab: {
          title: 'สมัครสมาชิก',
          pageTitleOne: 'SorisoriAI',
          subtitleOne: '🔥โมเดลยอดนิยมของเดือนนี้',
          subtitleTwo: 'รายการทั้งหมด',
          popular: 'ยอดนิยม',
          cancel: {
            message: 'คุณแน่ใจหรือไม่ว่าต้องการยกเลิกสมาชิก?',
            success: 'ยกเลิกสมาชิกเรียบร้อย!',
            fail: 'ไม่สามารถยกเลิกสมาชิกได้ โปรดลองอีกครั้ง',
          },
          cancelChange: {
            message: 'คุณแน่ใจหรือไม่ว่าต้องการคืนค่าการเปลี่ยนแปลงการสมัครสมาชิก?',
            success: 'สำเร็จ คืนค่าการเปลี่ยนแปลงเรียบร้อย!',
            fail: 'ไม่สามารถคืนค่าการเปลี่ยนแปลงได้ โปรดลองอีกครั้ง',
          },
          onetime: {
            message: 'คุณแน่ใจหรือไม่ว่าต้องการดำเนินการคำสั่งซื้อนี้?',
            success: 'สั่งซื้อสำเร็จ!',
            fail: 'ไม่สามารถสั่งซื้อได้ โปรดลองอีกครั้ง',
          },
          downgrade: {
            message: 'คุณแน่ใจหรือไม่ว่าต้องการลดแผนสมาชิก?',
            success: 'ลดแผนสมาชิกสำเร็จ!',
            fail: 'ไม่สามารถลดแผนสมาชิกได้ โปรดลองอีกครั้ง',
          },
          upgrade: {
            message:
              'คุณแน่ใจหรือไม่ว่าต้องการอัพเกรดแผนสมาชิก? เมื่อคลิก "ชำระเงิน" เราจะดำเนินการผ่านวิธีการชำระเงินปัจจุบันของคุณ',
            success: 'อัพเกรดแผนสมาชิกสำเร็จ!',
            fail: 'ไม่สามารถอัพเกรดได้ โปรดลองอีกครั้ง',
            paymentFailed: 'การชำระเงินล้มเหลว โปรดอัพเดตวิธีการชำระเงินที่หน้าโปรไฟล์ของคุณและลองอีกครั้ง',
          },
          annualize: {
            message:
              "Are you sure you want to change to a lower tier yearly plan? Once you click 'Pay', payment will be made with the existing payment method.",
            success: 'Subscription changed successfully!',
            fail: 'Subscription change failed. Please try again.',
            paymentFailed: 'Payment failed. Please update the payment method from My Profile or try again.',
          },
          disabled: {
            tooltip: {
              contents: ['Yearly to monthly subscription transition is not available'],
            },
          },
          mobilePaymentRequired:
            'ผู้ใช้งานสามารถจัดการแผนสมาชิกของคุณได้ในแอปพลิเคชั่นมือถือที่ใช้สมัครสมาชิกมาก่อนหน้านี้',
          tabs: {
            subscription: {
              title: 'สมัครสมาชิก',
              pastDue: 'ชำระเงินล้มเหลว',
              month: 'เดือน',
              monthly: 'Monthly',
              yearly: 'Yearly',
              upfront: 'Billed yearly',
              yearlyTag: '2 Months Free',
              subscribe: 'สมัคร',
              change: 'เปลี่ยน',
              currentTier: 'Current Tier',
              popular: 'Most Popular',
              value: 'Best Value',
              moreCredits: 'Need more credits?',
              discount: '80% discount on additional credits',
            },
            creditInfo: {
              title: 'How do credits work?',
              contents: [
                'Get new credits every month to use our AI generation and training services',
                'Credit usage will vary across services (see below)',
                'Credits reset every month and unused credits do not roll over to the next month (Additional credits purchased do not expire)',
              ],
            },
            creditUsage: {
              title: 'Cost per service',
              generation: 'Generation service',
              training: 'Training service',
              cost: 'Cost',
            },
          },
          paymentModal: {
            usePromoCode: 'ใช้โค้ดส่วนลด',
            promoCodePlaceholder: 'โค้ดส่วนลด',
            applyButton: 'ใช้โค้ด',
            submit: 'Continue',
            promoCodeApplied: 'ใช้โค้ดส่วนลดแล้ว',
            invalidPromoCode: 'โค้ดส่วนลดไม่ถูกต้อง',
            genericError: 'ไม่สามารถทำตามคำขอได้ โปรดลองอีกครั้ง',
            promoCodeError: {
              doesNotExist: 'Invalid promo code. Please check the promo code',
              invalidSubscriptionType: 'This promo code is only valid for PRO and PREMIUM plans',
              onlyFirstTime: 'This promo code is valid for first-time users only',
            },
          },
        },
        communityTab: {
          title: 'คอมมิวนิตี้',
          subTitle: 'เลือกเสียงที่คุณต้องการแล้วสร้าง AI Cover ได้เลย!',
          subtitleOne: '🔥Popular Models',
          subtitleTwo: 'Full List',
          inProgress: 'อยู่ระหว่างดำเนินการ',
          tags: 'ประเภท',
          failed: 'ไม่สำเร็จ',
          freeVersionTag: 'ทดลองใช้ฟรี',
          freePrefix: 'เวอร์ชั่นฟรีจะมาพร้อมลายน้ำ SorisoriAI ในไฟล์เสียง',
          voiceOptions: ['คอมมิวนิตี้', 'เสียงของฉัน', 'Favorites'],
          sortOptions: ['ล่าสุด', 'likes', 'ครั้งที่ใช้', 'ชื่อ'],
          tooltip: {
            contents: [
              'การสร้างไฟล์เสียง ใช้เวลาโดยเฉลี่ย 2-4 นาที',
              'การเทรนโมเดลเสียงใช้เวลาโดยเฉลี่ย 2-4 ชั่วโมง',
              'อาจใช้เวลานานขึ้นหากมีผู้ใช้งานจำนวนมาก',
            ],
          },
          tabs: {
            inference: {
              title: 'AI คัฟเวอร์',
            },
            training: {
              title: 'เทรนนิ่งเสียง AI',
            },
            vocalExtract: {
              title: 'ตัวแยกเสียง',
            },
          },
          changeButton: 'เปลี่ยน',
          cancelButton: 'ยกเลิก',
          confirmModelDelete:
            'คุณแน่ใจว่าต้องการลบหรือไม่? การลบโมเดลจะไม่ช่วยให้คุณได้เครดิตในการสร้างโมเดลที่ได้ใช้ไปแล้วคืนมาหรือเพิ่มขึ้น',
          confirmInferenceDelete: 'คุณแน่ใจหรือว่าต้องการลบ?',
          confirmVocalExtractDelete: 'คุณแน่ใจหรือว่าต้องการลบ?',
          searchbar: 'ค้นหา',
          infoIcon: {
            source: 'แหล่งที่มา',
            voice: 'เสียง',
            pitch: 'คีย์',
          },
          pagination: {
            loader: 'กำลังโหลด...',
          },
          modal: {
            error: 'โปรดรีเฟรชหน้านี้',
            aihubError: 'This model has expired, please select another model.',
          },
          button: {
            share: 'แชร์',
          },
        },
        supportTab: {
          title: 'คอมมิวนิตี้',
          link: 'https://discord.gg/AVREYrRZv4',
        },
        pipeline: {
          inferenceStatusMessage: {
            formatError: 'ไม่สามารถเปิดไฟล์ได้เนื่องจากฟอร์แมทไฟล์หรือนามสกุลไฟล์ไม่ถูกต้อง',
            volumeError:
              'ระดับเสียงร้องในไฟล์อาจเบาเกินไป หรือไม่พบเสียงร้องในไฟล์เสียงนี้ โปรดเพิ่มความดังให้เสียงร้องและลองอีกครั้ง',
            invalidFileError: 'ไม่สามารถเปิดไฟล์ได้ โปรดตรวจสอบไฟล์อีกครั้ง',
            invalidAihubModel: 'This model has expired, please select another model.',
            progress10: 'อยู่ระหว่างดำเนินการ 10%',
            progress20: 'อยู่ระหว่างดำเนินการ 20%',
            progress40: 'อยู่ระหว่างดำเนินการ 40%',
            progress50: 'อยู่ระหว่างดำเนินการ 50%',
            progress60: 'อยู่ระหว่างดำเนินการ 60%',
            progress80: 'อยู่ระหว่างดำเนินการ 80%',
            progress100: 'อยู่ระหว่างดำเนินการ 100%',
            complete: 'เสร็จสิ้น',
            generalMessage: 'AI Cover ล้มเหลว โปรดลองอีกครั้ง หากปัญหายังคงมีอยู่ โปรดติดต่อทีมสนับสนุนของ SORISORI',
            starting: 'กำลังเริ่มต้น',
          },
          trainingStatusMessage: {
            formatError: 'ไม่สามารถเปิดไฟล์ได้เนื่องจากฟอร์แมทไฟล์หรือนามสกุลไฟล์ไม่ถูกต้อง',
            volumeError:
              'ระดับเสียงร้องในไฟล์อาจเบาเกินไป หรือไม่พบเสียงร้องในไฟล์เสียงนี้ โปรดเพิ่มความดังให้เสียงร้องและลองอีกครั้ง',
            invalidFileError: 'ไม่สามารถเปิดไฟล์ได้ โปรดตรวจสอบไฟล์อีกครั้ง',
            progress10: 'อยู่ระหว่างดำเนินการ 10%',
            progress20: 'อยู่ระหว่างดำเนินการ 20%',
            progress40: 'อยู่ระหว่างดำเนินการ 40%',
            progress50: 'อยู่ระหว่างดำเนินการ 50%',
            progress60: 'อยู่ระหว่างดำเนินการ 60%',
            progress80: 'อยู่ระหว่างดำเนินการ 80%',
            progress100: 'อยู่ระหว่างดำเนินการ 100%',
            complete: 'เสร็จสิ้น',
            generalMessage: 'การฝึกอบรมล้มเหลว โปรดลองอีกครั้ง หากปัญหายังคงมีอยู่ โปรดติดต่อทีมสนับสนุนของ SORISORI',
            starting: 'กำลังเริ่มต้น',
          },
        },
        modal: {
          confirmationPay: 'ชำระเงิน',
          confirmationCancel: 'ยกเลิก',
          confirmationYes: 'ใช่',
          confirmationNo: 'ไม่ใช่',
          combined: 'รวมกัน',
          backVocal: 'เสียงคอรัส',
          vocal: 'เสียงร้องหลัก',
          instrument: 'ดนตรีประกอบ',
          fileUploadFail: 'ไม่สามารถอัพโหลดไฟล์ได้ในขณะนี้ กรุณาตรวจสอบไฟล์และลองใหม่อีกครั้ง',
          trainingInProgressError: 'มีการเทรนนิ่งอยู่ในขณะนี้',
          genericError: 'ไม่สามารถดำเนินการตามคำขอได้ กรุณาลองอีกครั้ง',
          noRemainingError: 'คุณไม่มีเครดิตเหลือแล้ว',
          pageLoadFail: 'ไม่สามารถโหลดหน้าเว็บได้ กรุณารีเฟรชหน้านี้',
          pageLoadFailOnSubmit:
            'การอัพโหลดสำเร็จ แต่ไม่สามารถโหลดหน้าเว็บได้ในขณะนี้ กรุณารีเฟรชหน้านี้ หรือสามารถตรวจสอบสถานะของไฟล์ได้ที่แท็บ ‘ประวัติ’ ที่เมนูด้านข้าง',
          gotoProfile: 'ไปหน้าโปรไฟล์ของฉัน',
          youtubeDownloadLink: 'Youtube Download Link',
          youtubeCountryBlocked:
            'วิดีโอนี้ไม่สามารถใช้งานได้ในประเทศปัจจุบันของคุณเนื่องจากข้อจำกัดด้านลิขสิทธิ์หรือข้อจำกัดตามภูมิภาค',
          youtubeCountryBlockedCopyright:
            'วิดีโอนี้ไม่สามารถใช้งานได้ในประเทศปัจจุบันของคุณเนื่องจากข้อจำกัดด้านลิขสิทธิ์หรือข้อจำกัดตามภูมิภาค',
        },
        mixingModal: {
          label: 'มิกซ์',
          title: 'การมิกซ์เสียง',
          sliders: {
            contents: ['คีย์เสียงร้อง', 'ความดังเสียงร้อง', 'ระดับเสียงสะท้อน', 'ความยาวของเสียงสะท้อน'],
          },
          tooltip: {
            contents: [
              '-4 ถึง -6 คือช่วงคีย์ที่แนะนำเมื่อใช้เสียงร้องเพศชายในเพลงคีย์ผู้หญิง',
              '+4 ถึง +6 คือช่วงคีย์ที่แนะนำเมื่อใช้เสียงร้องเพศหญิงในเพลงคีย์ผู้ชาย',
              'การปรับคีย์ที่มากเกินไปอาจส่งผลต่อคุณภาพของเสียงผลลัพท์',
              'ความดังของเสียงร้อง',
              '0db คือความดังระดับเดียวกับเสียงร้องต้นฉบับ',
              'ระดับของเอฟเฟกต์เสียงสะท้อน (Reverb)',
              '0 คือไม่มีเสียงสะท้อน, 6 คือเสียงสะท้อนระดับมาก',
              'ความยาวของหางเสียงสะท้อนในหน่วยวินาที',
              '2s คือความยาวที่แนะนำสำหรับเพลงช้าซึ้ง และแนะนำให้ความยาวเสียงสะท้อนสั้นลงสำหรับเพลงเร็ว',
            ],
          },
          demo: {
            toggle: 'มิกซ์ซิ่ง',
            status: ['ไม่มิกซ์', 'มิกซ์'],
            description: 'ฟังความแตกต่างระหว่างเสียงที่ยังไม่มิกซ์และที่มิกซ์แล้ว',
          },
          dialog: {
            title: 'ขออภัย คุณไม่สามารถเข้าถึงฟีเจอร์นี้ได้',
            text: 'อัพเกรดเป็นแผน PRO หรือ PREMIUM เพื่อเข้าถึงฟีเจอร์การมิกซ์เสียงของเรา!',
          },
          upgradeButton: ['อัพเกรดเป็น ', 'PRO'],
        },
        freeInferenceMessageModal: {
          messeageOne: ['เวอร์ชั่นฟรีมาพร้อมโฆษณาขั้น และเสียงทดลองความยาว 45 วินาที'],
          messeageTwo: ['โปรดสมัครสมาชิกเพื่อสร้าง', 'เพลงเต็มความยาวแบบไม่มีโฆษณา'],
          button: 'สมัครสมาชิก',
        },
        youtubeReenabledModal: {
          title: 'ฟีเจอร์ YouTube กลับมาแล้ว!',
          description: 'คุณสามารถสร้าง AI คัฟเวอร์ด้วยลิงก์ YouTube ได้อีกครั้งแล้วค่ะ',
          confirm: 'ตกลง',
          hideFor3Days: 'ไม่แสดงอีก 1 วัน',
        },
        freeTrainingMessageModal: {
          messages: ['สามารถเทรนนิ่งโมเดลเสียง AI', 'เมื่อสมัครสมาชิก', 'หรือสั่งซื้อบริการแบบครั้งเดียว'],
          button: 'สมัครสมาชิก',
        },
        freeVocalExtractorMessageModal: {
          free: {
            message: ['ผู้ใช้งานฟรี', 'สามารถอัพโหลดได้ครั้งละ 1 ไฟล์', 'โปรดอัพเดรดเพื่อเพิ่มการอัพโหลด'],
          },
          basic: {
            message: ['ผู้ใช้งานแผน Basic', 'สามารถอัพโหลดได้ครั้งละ 1 ไฟล์', 'โปรดอัพเดรดเพื่อเพิ่มการอัพโหลด'],
          },
          button: 'คลิกที่นี่เพื่อสมัครสมาชิก',
        },
        onetimeItems: [
          {
            type: 'GEN_CREDIT_5',
            name: '5 Gen Credits',
            discount: {
              strikethrough: '5',
              name: '25 Gen Credits',
              type: 'GEN_CREDIT_25_PRO',
            },
            price: {
              usd: '$5',
              thb: '฿130',
              krw: '₩5,000',
              jpy: '¥590',
            },
          },
          {
            type: 'GEN_CREDIT_25',
            name: '25 Gen Credits',
            discount: {
              strikethrough: '25',
              name: '150 Gen Credits',
              type: 'GEN_CREDIT_150',
            },
            price: {
              usd: '$25',
              thb: '฿650',
              krw: '₩25,000',
              jpy: '¥2950',
            },
          },
          {
            type: 'TRAINING_CREDIT_1',
            name: '1 Training Credit',
            price: {
              usd: '$7',
              thb: '฿250',
              krw: '₩8,500',
              jpy: '¥990',
            },
          },
          {
            type: 'TRAINING_CREDIT_5',
            name: '5 Training Credits',
            discount: {
              strikethrough: '5',
              name: '7 Training Credits',
              type: 'TRAINING_CREDIT_7',
            },
            price: {
              usd: '$35',
              thb: '฿1250',
              krw: '₩42,500',
              jpy: '¥4950',
            },
          },
        ],
        subscriptionItems: [
          {
            name: 'FREE',
            model: 'FREE', //leave in english
            monthlyRate: {
              usd: '$0',
              thb: '฿0',
              krw: '₩0',
              jpy: '¥0',
            },
            features: [
              {
                name: '2 AI Covers',
              },
              {
                name: '2 Vocal Extracts',
              },
              {
                name: '25 TTS characters',
              },
              {
                name: 'One 15 sec Face Swap video',
              },
              {
                name: '5 TTI generations',
              },
            ],
          },
          {
            name: 'BASIC',
            model: 'BASIC', //leave in english
            monthlyRate: {
              usd: '$9.99',
              thb: '฿279',
              krw: '₩14,800',
              jpy: '¥1,699',
            },
            yearly: {
              model: 'BASIC_YEARLY',
              monthlyRate: {
                usd: '$8.30',
                thb: '฿233',
                krw: '₩12,333',
                jpy: '¥1,417',
              },
            },
            features: [
              {
                name: '150 Gen Credits',
                usage: [
                  'Up to 150 AI Covers',
                  'Up to 150 Vocal Extracts',
                  'Up to 1500 TTS characters',
                  'Up to 150 sec of Face Swap',
                  'Up to 75 TTI generations',
                ],
              },
              {
                name: '2 Training credits',
                usage: ['Up to 2 AI voices', 'Up to 2 TTS voices'],
              },
              {
                name: 'Speed: Slow',
              },
              {
                name: 'Train Quality: Medium',
              },
              {
                name: 'Sound Quality: Normal (MP3)',
              },
            ],
          },
          {
            name: 'PRO',
            model: 'PRO', //leave in english
            monthlyRate: {
              usd: '$24.80',
              thb: '฿619',
              krw: '₩28,800',
              jpy: '¥3,490',
            },
            yearly: {
              model: 'PRO_YEARLY',
              monthlyRate: {
                usd: '$20.70',
                thb: '฿516',
                krw: '₩24,000',
                jpy: '¥2,908',
              },
            },
            features: [
              {
                name: '1000 Gen credits',
                usage: [
                  'Up to 1000 AI Covers',
                  'Up to 1000 Vocal Extracts',
                  'Up to 10000 TTS characters',
                  'Up to 1000 sec of Face Swap',
                  'Up to 500 TTI generations',
                ],
              },
              {
                name: '5 Training credits',
                usage: ['Up to 5 AI cover voices', 'Up to 5 TTS voices'],
              },
              {
                name: 'Speed: Fast',
              },
              {
                name: 'Train Quality: High',
              },
              {
                name: 'Sound Quality: High (WAV)',
              },
              {
                name: 'Discount on additional products',
              },
            ],
          },
          {
            name: 'PREMIUM',
            model: 'PREMIUM', //leave in english
            monthlyRate: {
              usd: '$68.80',
              thb: '฿1680',
              krw: '₩88,800',
              jpy: '¥8,990',
            },
            yearly: {
              model: 'PREMIUM_YEARLY',
              monthlyRate: {
                usd: '$57.30',
                thb: '฿1400',
                krw: '₩73,333',
                jpy: '¥7,490',
              },
            },
            features: [
              {
                name: '5000 Gen credits',
                usage: [
                  'Up to 5000 AI Covers',
                  'Up to 5000 Vocal Extracts',
                  'Up to 50000 TTS Characters',
                  'Up to 5000 sec of Face Swap',
                  'Up to 2500 TTI generations',
                ],
              },
              {
                name: '20 Training credits',
                usage: ['Up to 20 AI voices', 'Up to 20 TTS voices'],
              },
              {
                name: 'Speed: Very Fast',
              },
              {
                name: 'Train Quality: Best',
              },
              {
                name: 'Sound Quality: High (WAV)',
              },
              {
                name: 'Discount on additional products',
              },
            ],
          },
        ],
        costPerService: {
          generation: [
            {
              name: 'AI Cover',
              cost: '1 Gen Credit',
            },
            {
              name: 'Vocal Extract',
              cost: '1 Gen Credit',
            },
            {
              name: 'Text to Speech',
              cost: '10 characters per Gen Credit',
            },
            {
              name: 'Face Swap',
              cost: '15 Gen Credits per face, per 15s',
            },
            {
              name: 'Text to Image',
              cost: '2+ Gen Credits',
            },
          ],
          training: [
            {
              name: 'TTS Voice Model',
              cost: '1 Training Credit',
            },
            {
              name: 'AI Voice Model',
              cost: '1 Training Credit',
            },
          ],
        },
        subscriptionComparison: {
          title: 'Compare Subscriptions',
          headers: {
            feature: 'Feature',
            inference: 'AI Cover',
            faceSwap: 'Face Swap',
            tti: 'Text to Image',
            row: ['FREE', 'BASIC', 'PRO', 'PREMIUM'],
          },
          subscription: [
            {
              feature: 'Gen Credit Value',
              row: [
                '-', // FREE
                '$0.1 per credit', // BASIC
                '$0.025 per credit', // PRO
                '$0.013 per credit', // PREMIUM
              ],
            },
            {
              feature: 'Training Credit Value',
              row: ['-', '$5 per credit', '$3.6 per credit', '$2.75 per credit'],
            },
            {
              feature: 'Speed',
              row: ['Slow', 'Medium', 'Fast', 'Very Fast'],
            },
            {
              feature: 'Training Quality',
              row: ['Low', 'Good', 'Very Good', 'Best'],
            },
            {
              feature: 'Discount on additional credits',
              row: ['-', '-', '-80%', '-80%'],
            },
          ],
          inference: [
            {
              feature: 'Pitch Change',
              row: ['Y', 'Y', 'Y', 'Y'],
            },
            {
              feature: 'AI Mixing',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'MP3',
              row: ['Y', 'Y', 'Y', 'Y'],
            },
            {
              feature: 'WAV (HQ)',
              row: ['N', 'N', 'Y', 'Y'],
            },
          ],
          faceSwap: [
            {
              feature: 'Video Enhancement',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'Watermark Removal',
              row: ['N', 'N', 'Y', 'Y'],
            },
          ],
          tti: [
            {
              feature: 'Maximum Quality',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'Maximum Size Setting',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'CFG Scale Setting',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'Watermark Removal',
              row: ['N', 'N', 'Y', 'Y'],
            },
          ],
        },
        faqTab: {
          title: 'คำถามที่พบบ่อย',
          placeholder: 'พิมพ์เพื่อค้นหา...',
          faqs: [
            {
              title: 'คำถามเกี่ยวกับการเทรนและการสร้างโมเดลเสียง AI',
              qnas: [
                {
                  question: 'สามารถใช้ประเภทไฟล์ใดได้บ้าง?',
                  answers: [
                    'Sorisori.ai สามารถรับไฟล์ได้ทั้งหมด 6 ชนิด: mp3, wav, m4a, mkv, mp4, flac, ogg. สิ่งสำคัญที่สุดคือคุณภาพของเสียงต้นแบบ การแปลงชนิดไฟล์อาจส่งผลต่อคุณภาพเสียงที่ลดลง ไฟล์เสียงชนิด m4a จะใกล้เคียงกับคุณภาพของการอัดเสียงจากมือถือ',
                  ],
                },
                {
                  question: 'ตัวแยกเสียง (Vocal Extractor) จำเป็นหรือไม่?',
                  answers: [
                    'Sorisori AI มีบริการตัวแยกเสียงอัตโนมัติที่จะช่วยคัดแยกเสียงได้อย่างมีประสิทธิภาพ เช่น การคัดแยกเสียงร้องออกจากเสียงดนตรี ทั้งนี้ ขั้นตอนการแยกเสียงนั้นขึ้นอยู่กับความจำเป็นของแต่ละบุคคล หากผู้ใช้งานมีเสียงต้นแบบที่คุณภาพสูงและไม่มีเสียงอื่นๆ รบกวน ก็ไม่จำเป็นต้องใช้ตัวแยกเสียงแต่อย่างใด',
                  ],
                },
                {
                  question: 'สามารถอัพโหลดหลายๆ ไฟล์ในการเทรน AI ได้หรือไม่?',
                  answers: [
                    'ในการเทรน AI สามารถอัพโหลดหลายๆ ไฟล์พร้อมกันได้ หากเป็นเสียงที่ผู้ใช้งานกดอัดเอง สามารถกดอัดแยกไฟล์และอัพโหลดแยกกันได้เช่นเดียวกัน',
                  ],
                },
                {
                  question: 'ไมโครโฟนที่แนะนำสำหรับการอัดเสียงเพื่อเทรน AI',
                  answers: [
                    'โปรแกรมอัดเสียงในมือถือสามารถให้คุณภาพที่เพียงพอต่อการเทรน AI แนะนำให้อัดเสียงในพื้นที่ที่เงียบสนิท ไม่มีเสียงรบกวน',
                  ],
                },
                {
                  question: 'การอัพโหลดเพลงที่อัดมาจากห้องคาราโอเกะ',
                  answers: ['ไม่แนะนำให้อัพโหลดไฟล์เสียงที่อัดมาจากห้องร้องคาราโอเกะเนื่องจากปัญหาเรื่องคุณภาพเสียง'],
                },
                {
                  question: 'คุณภาพเสียง',
                  answers: [
                    'โปรดตรวจสอบคุณภาพเสียงหลังจากการอัดเสียงทุกครั้ง ในบางกรณี ระยะห่างของไมค์อาจส่งผลต่อคุณภาพของเสียงได้',
                    '',
                  ],
                },
                {
                  question: 'หากเราลบโมเดลเสียง เราสามารถเทรนใหม่ได้หรือไม่?',
                  answers: ['การลบโมเดลเสียงจะไม่คืนเครดิตการเทรนเสียง'],
                },
              ],
            },
            {
              title: 'คำถามเกี่ยวกับการสร้างคัฟเวอร์ AI',
              qnas: [
                {
                  question: ' การยกเลิกระหว่างการเทรนนิ่ง',
                  answers: [
                    "ระหว่างการอัพโหลด โปรดตรวจเช็คประเภทไฟล์ให้ถูกต้อง และโปรดรอจนกว่าระบบจะขึ้นว่า 'กำลังอยู่ระหว่างดำเนินการ'",
                  ],
                },
                {
                  question: 'ประเภทไฟล์ที่สามารถใช้ทำ AI คัฟเวอร์ได้',
                  answers: [
                    'สามารถรับไฟล์ได้ทั้งหมด 6 ชนิด: mp3, wav, m4a, mkv, mp4, flac, ogg. สิ่งสำคัญที่สุดคือคุณภาพของเสียงต้นแบบ การแปลงชนิดไฟล์อาจส่งผลต่อคุณภาพเสียงที่ลดลง ไฟล์เสียงชนิด m4a จะใกล้เคียงกับคุณภาพของการอัดเสียงจากมือถือ',
                  ],
                },
                {
                  question: 'ตัวแยกเสียง (Vocal Extractor) จำเป็นหรือไม่?',
                  answers: [
                    'Sorisori AI มีบริการตัวแยกเสียงอัตโนมัติที่จะช่วยคัดแยกเสียงได้อย่างมีประสิทธิภาพ เช่น การคัดแยกเสียงร้องออกจากเสียงดนตรี ทั้งนี้ ในการสร้าง AI คัฟเวอร์นั้นไม่จำเป็นต้องใช้ตัวแยกเสียงแต่อย่างใด',
                  ],
                },
                {
                  question: 'ใช้เสียงตัวอย่างคัฟเวอร์ได้หรือไม่?',
                  answers: ['สามารถใช้เสียงตัวอย่างสร้างคัฟเวอร์ได้'],
                },
                {
                  question: 'ปัญหาการดาวน์โหลดจากหน้าเว็บ',
                  answers: [
                    'แนะนำให้ใช้ Browsers เช่า Chrome, Safari, Firefox เป็นต้น ในการใช้งานและดาวน์โหลดเพลง หากใช้ผ่านโปรแกรมหรือแอปอื่นๆ อาจส่งผลต่อการดาวน์โหลดได้',
                  ],
                },
              ],
            },
            {
              title: 'คำแนะนำเกี่ยวกับการสร้างคัฟเวอร์ AI',
              qnas: [
                {
                  question: 'คุณภาพของเสียงต้นฉบับ',
                  answers: [
                    'คุณภาพของคัฟเวอร์AI ขึ้นอยู่กับคุณภาพของเสียงต้นฉบับ เราขอแนะนำให้เลือกที่มาของต้นฉบับเสียงที่ให้คุณภาพสูงที่สุด',
                  ],
                },
                {
                  question: 'หลีกเลี่ยงเสียงเอฟเฟกต์และคอรัส',
                  answers: [
                    'โปรดหลีกเลี่ยงการใช้เสียงต้นฉบับที่ผ่านการแปลงเสียงด้วยเอฟเฟกต์หรือมีเสียงคอรัสแทรก แนะนำให้ใช้ตัวแยกเสียง (Vocal Extractor) ในการแยกเสียงร้องออกจากเสียงคอรัสก่อนนำเสียงต้นฉบับมาสร้างโมเดลเสียง AI',
                  ],
                },
                {
                  question: 'การประสานเสียง',
                  answers: [
                    'โปรดหลีกเลี่ยงเพลงหรือเสียงต้นฉบับที่มีนักร้องหลายคนร้องพร้อมกันในเวลาเดียวกัน โปรดเลี่ยงโดยเฉพาะเสียงต้นฉบับที่มีการร้องประสานเสียง',
                  ],
                },
              ],
            },
            {
              title: 'คำถามเกี่ยวกับการชำระเงิน',
              qnas: [
                {
                  question: 'การคำนวณค่าธรรมเนียมการอัปเกรด',
                  answers: ['ค่าธรรมเนียมการอัปเกรดคือความแตกต่างระหว่างแผนการสมัครใช้งานสองแบบ'],
                },
                {
                  question: 'การยกเลิกการสมัครใช้งาน',
                  answers: [
                    '- สามารถยกเลิกการสมัครใช้งานได้จากหน้าโปรไฟล์',
                    '- สามารถเข้าถึงหน้าโปรไฟล์ได้โดยการคลิกปุ่ม "เปลี่ยนแปลง" บนบัตรแผนฟรีในหน้าการสมัครใช้งานหรือการคลิกชื่อผู้ใช้งานบนแถบนำทาง',
                  ],
                },
                {
                  question: 'ใช้งานได้เฉพาะเดือนปัจจุบันเท่านั้นหรือไม่?',
                  answers: [
                    'หากคุณยกเลิกการสมัครใช้งานโดยใช้วิธีข้างต้น คุณสามารถใช้งานได้ต่อไปจนถึงสิ้นเดือนปัจจุบัน',
                  ],
                },
                {
                  question: 'การโอนย้ายโมเดลและครอบคลุมที่ไม่ได้ใช้งาน',
                  answers: [
                    'โมเดลหรือครอบคลุมที่ไม่ได้ใช้งานจะไม่ถูกโอนย้ายไปยังเดือนถัดไป มันจะถูกตั้งค่าใหม่เป็นจำนวนที่จัดสรรไว้ในแต่ละเดือน',
                  ],
                },
                {
                  question: 'ปัญหาการชำระเงินด้วยบัตร',
                  answers: [
                    'ตั้งแต่วันที่ 20 ธันวาคม 2024, ได้รับการรองรับบัตรที่ได้รับการอนุมัติระหว่างประเทศ, บัตรในประเทศเกาหลี และ KakaoPay หากคุณยังพบปัญหาในการชำระเงิน คุณจำเป็นต้องติดต่อธนาคารหรือผู้ออกบัตรของคุณ',
                  ],
                },
                {
                  question: 'นโยบายการคืนเงิน',
                  answers: [
                    'เงื่อนไขสำหรับการคืนเงินมีดังนี้:',
                    '- สินค้าแต่ละรายการไม่สามารถคืนเงินได้',
                    '- คุณต้องไม่มีประวัติการใช้งานในเดือนนั้น',
                    '- ต้องทำการขอคืนเงินภายในสามสัปดาห์ (21 วัน) นับจากวันที่ชำระเงิน',
                    '- ค่าธรรมเนียมการคืนเงิน 3 ดอลลาร์จะเกิดขึ้นไม่ว่าจะเป็นแผนใด',
                    '- คุณต้องยกเลิกการสมัครใช้งานด้วยตัวเอง สามารถยกเลิกการสมัครใช้งานได้จากหน้าโปรไฟล์',
                    '- สามารถเข้าถึงหน้าโปรไฟล์ได้โดยการคลิกปุ่ม "เปลี่ยนแปลง" บนบัตรแผนฟรีในหน้าการสมัครใช้งานหรือการคลิกชื่อผู้ใช้งานบนแถบนำทาง',
                  ],
                },
                {
                  question: 'ใช้เวลานานแค่ไหนในการดำเนินการคืนเงิน?',
                  answers: [
                    'ขึ้นอยู่กับวันที่สอบถาม โดยปกติแล้วจะใช้เวลา 5-8 วันทำการสำหรับบัตรเครดิต และอาจจะใช้เวลาสั้นกว่าสำหรับ KakaoPay',
                  ],
                },
              ],
            },
            {
              title: 'คำถามเพิ่มเติม',
              qnas: [
                {
                  question: 'การลบบัญชีผู้ใช้งาน',
                  answers: [
                    'เบื้องต้นผู้ใช้งานสามารถติดต่อ Sorisori.ai ผ่าน Discord เพื่อทำเรื่องในการลบบัญชีผู้ใช้งาน เรากำลังพัฒนาระบบที่จะเพิ่ม Feature ให้ผู้ใช้งานสามารถจัดการบัญชีได้เองในอนาคต',
                  ],
                },
                {
                  question: 'Discord คืออะไร?',
                  answers: [
                    'Discord คือพื้นที่สำหรับคอมมิวนิตี้ของผู้ใช้งาน AI เสียง มีไว้สำหรับผู้ใช้งานได้แลกเปลี่ยนผลงาน ข้อมูลข่าวสารต่างๆ ร่วมกัน',
                  ],
                },
              ],
            },
          ],
        },
        contactTab: {
          title: 'ติดต่อเรา',
          placeholder: {
            type: 'ประเภทการติดต่อ',
            email: 'อีเมล',
            text: 'ข้อความ',
            refund:
              'นโยบายการคืนเงิน\n\n1. สินค้าแต่ละรายการไม่สามารถคืนเงินได้\n2. คุณต้องไม่มีประวัติการใช้งานในเดือนนั้น\n3. ต้องทำการขอคืนเงินภายในสามสัปดาห์ (21 วัน) นับจากวันที่ชำระเงิน\n4. ค่าธรรมเนียมการคืนเงิน 3 ดอลลาร์จะเกิดขึ้นไม่ว่าจะเป็นแผนใด\n5. คุณต้องยกเลิกการสมัครใช้งานด้วยตัวเอง สามารถยกเลิกการสมัครใช้งานได้จากหน้าโปรไฟล์\n6. สามารถเข้าถึงหน้าโปรไฟล์ได้โดยการคลิกปุ่ม "เปลี่ยนแปลง" บนบัตรแผนฟรีในหน้าการสมัครใช้งานหรือการคลิกชื่อผู้ใช้งานบนแถบนำทาง',
          },
          message: {
            deleteAccount:
              'การลบบัญชีของคุณเป็นการกระทำถาวร การสมัครสมาชิกที่ใช้งานอยู่จะถูกยกเลิกโดยอัตโนมัติ แต่การสมัครสมาชิกผ่านมือถือจะต้องยกเลิกผ่านร้านค้าแอปของคุณ',
            confirmDeleteAccount: "พิมพ์ 'DELETE' เพื่อยืนยัน",
            deleteConfirm: 'ลบบัญชี',
            accountDeletedMessage: 'บัญชีของคุณถูกลบเรียบร้อยแล้ว ตอนนี้คุณจะถูกออกจากระบบ',
            type: 'โปรดเลือกประเภทการติดต่อ',
            email: 'โปรดใส่อีเมลของคุณ',
            content: 'โปรดเขียนข้อความที่นี่',
            loading: 'กำลังส่งคำร้อง กรุณารอสักครู่',
            success: 'การส่งคำร้องสำเร็จเรียบร้อย',
            refundSuccess: 'คำขอคืนเงินถูกส่งเรียบร้อยแล้ว กรุณาตรวจสอบอีเมลของคุณเพื่อดูสถานะ.',
            fail: 'ไม่สามารถส่งคำร้องได้ โปรดลองอีกครั้ง',
            useDiscord:
              'หากมีคำถามเพิ่มเติมเกี่ยวกับการทำ Cover หรือการสร้างโมเดลเสียง สามารถเข้าไปที่ ""คำถามที่พบบ่อย"" หรือไปที่กลุ่ม Discord ของเรา​',
          },
          contactType: ['การสร้างโมเดลเสียง/สร้าง Cover', 'เกี่ยวกับ API', 'ขอคืนเงิน', 'ลบบัญชี', 'ติดต่อเรื่องอื่นๆ'],
          submit: 'ส่งคำร้อง',
        },
        emailPreferenceTab: {
          title: 'การตั้งค่าอีเมล',
          header: 'อย่าพลาดข้อเสนอสุดพิเศษ ฟีเจอร์ใหม่ๆ และอัพเดตสุดพิเศษก่อนใครกับเรา!',
          choiceLabels: {
            announcement: 'ประกาศ',
            notification: 'การแจ้งเตือน',
            newsletter: 'จดหมายข่าว',
            promotion: 'โปรโมชั่น',
          },
          submit: {
            save: 'บันทึก',
          },
          modal: {
            success: 'บันทึกสำเร็จ',
            error: 'เกิดข้อผิดพลาด กรุณาลองอีกครั้ง',
          },
        },
        profileTab: {
          title: 'โปรไฟล์ของฉัน',
          sections: {
            login: {
              title: 'บัญชี',
              logout: 'ออกจากระบบ',
            },
            payment: {
              title: 'การชำระเงิน',
              changePayment: 'เปลี่ยนการชำระเงิน',
              updateSubscription: 'อัพเดตแผนสมาชิก',
              cancelSubscriptionChange: 'คืนค่าการเปลี่ยนแปลงสมาชิก',
              history: 'ดูประวัติการชำระเงิน',
              cancel: 'ยกเลิกแผนสมาชิก',
              currentSubscription: 'แผนสมาชิกปัจจุบัน',
              nextPaymentDate: 'วันเรียกชำระเงินครั้งถัดไป',
              currentCycle: 'รอบบิลปัจจุบัน',
              nextCreditResetDate: 'Next credit reset date',
              nextSubscriptionType: 'รอบบิลครั้งถัดไป',
            },
            question: {
              title: 'คำถาม',
              contentPre: 'โปรดใช้ ',
              contentLink: 'ติดต่อเรา',
              contentPost: ' แท็บสำหรับคำถามเกี่ยวกับการชำระ/คืนเงิน',
            },
          },
          subscriptionType: {
            FREE: 'FREE',
            BASIC: 'BASIC',
            PRO: 'PRO',
            PREMIUM: 'PREMIUM',
            BASIC_YEARLY: 'BASIC (YEARLY)',
            PRO_YEARLY: 'PRO (YEARLY)',
            PREMIUM_YEARLY: 'PREMIUM (YEARLY)',
          },
        },
        paymentModal: {
          title: 'ประวัติการชำระเงิน',
          date: 'วันที่',
          info: 'ข้อมูล',
          amount: 'จำนวน',
        },
      },
    },
    ja: {
      translation: {
        languageDetector: 'ja',
        requestFailed: '再度お試しください',
        pageLoadFailed: 'ページの読み込みに失敗しました。リロードしてください',
        signIn: 'サインイン',
        defaultModels: ['サンプル音声 A(男)'],
        yes: 'はい',
        no: 'いいえ',
        trainingCountText: 'Training Credits',
        genCountText: 'Gen Credits',
        appBar: {
          create: 'Create',
          account: 'Account',
          music: 'AI Music',
          speech: 'AI Speech',
          image: 'AI Image',
          video: 'AI Video',
          history: 'History',
        },
        trainingTab: {
          title: 'AI音声学習',
          tabs: ['直接学習', '外部モデル'],
          stepOne: {
            title: '音声アップロード',
            tooltip: {
              titleOne: 'アップロード注意点',
              contentsOne: [
                '量より質。低品質30分より高品質15分の音源を',
                'オートチューンのような過度な音響効果の入った曲はダメ',
                'ライブ音源よりは正式音源をお勧めします',
                '必ず！ソローの曲を使うこと',
                '会話音声より歌声を使う事',
                'ラップカバーの場合、ラップの音源がお勧め',
              ],
              titleTwo: '直接録音する場合',
              contentsTwo: [
                'モバイルレコーダーでもOK',
                '一発で録音する必要はないです',
                '歌声だけアップロードすることをお勧めします',
                'カラオケでの録音はお勧めしません',
                'アップロードする前に録音をもう一回確認',
              ],
            },
            trainingSubTitles: ['学習させる音声ファイルをアップロードしてください'],
            externalSubTitles: ['外部モデルをアップロードしてください'],
            dragAndDropText: 'ドラッグ・アンド・ドロップ',
            dragAndDropDuration: '(総合{{minDuration}}分以上、{{maxDuration}}分)',
            dragAndDropButton: 'ファイル選択',
            durationText: '全体の音源の長さ',
            durationUnit: '分',
            tabs: {
              fileUpload: {
                vocalExtractionText: 'ボーカルだけが抽出されていますか？',
                vocalExtractionYes: 'はい',
                vocalExtractionNo: 'いいえ',
                vocalExtractionTooltip: {
                  title: 'ボーカル抽出注意点',
                  contents: [
                    'ボーカルだけが抽出された音源である場合に"はい"をクリック',
                    '普通の音源の場合には該当なし',
                  ],
                },
              },
            },
          },
          stepTwo: {
            title: 'モデル名付け',
            subTitles: ['AI音声に名前を付けて学習を始めてください'],
            placeholder: 'Give a label to your model',
          },
          submit: {
            upload: 'アップロード',
            free: 'サブスクライブしてください',
            inProgress: '学習中',
            noRemaining: '使用可能回数が残っていません',
            start: '学習開始',
            uploading: 'アップロード中です',
            remainingCountText: 'Training Credits left',
            tooltip: {
              contents: [
                '音声学習には0.5~1時間掛かります',
                'サーバーにアクセスが集中している場合、学習が遅れる可能性があります',
                '"ヒストリー"タブから学習状況を確認できます',
              ],
            },
          },
          modal: {
            exceedModelCount:
              '無料・基本プランでは最大3個の音声モデルを所持できます。プランのアップグレード、または所持している音声モデルのいずれかを削除してください',
            exceedMaxDuration: '{{maxDuration}}分以上の音声ファイルはアップロードできません',
            minDuration: '{{minDuration}}分以上の音声ファイルをアップロードしてください',
            notSupportedFileType: '認識できないファイル形式です',
            imgModalConfirm: '進む',
            imgModalCancel: '戻る',
            noLabel: '名前を入力してください',
            missingFile: 'すべてのファイルを入れてください',
            noFile: 'Please upload files',
            longLabel: 'Label cannot exceed 25 characters',
          },
        },
        communityUploadTab: {
          title: 'モデルの共有',
          tabs: ['自分のモデル ', '外部ファイル'],
          stepOne: {
            title: 'ステップ１:イメージアップロード',
            subTitles: ['モデルに合うイメージをアップロードしてください'],
            tabs: {
              fileUpload: {
                dragAndDropText: 'ファイルをドラッグ・アンド・ドロップ',
              },
            },
          },
          stepTwo: {
            title: 'ステップ２: ボイスモデル選択',
            trainingSubTitles: ['ボイスを選択してください'],
            externalSubTitles: ['ボイスモデルをアップロードしてください'],
            dragAndDropText: ['Path ファイルをアップロード', 'Index ふファイルをアップロード'],
            dragAndDropButton: 'ファイル選択',
            voice: 'ボイス',
          },
          stepThree: {
            title: 'ステップ３: モデル名付け',
            subTitle: 'モデルに名前を付けてください',
            genderLabel: 'モデルの性別を選択してください',
            gender: ['男性', '女性'],
            anonymousText: 'ユーザーネームを隠します',
          },
          stepFour: {
            title: 'ステップ４: モデルのタグ付け',
            subTitle: 'モデルに合うタグをすべて付けてください',
            tags: ['ジャンル', '国'],
          },
          submit: {
            upload: 'アップロード',
            start: 'モデルの共有',
            uploading: 'アップロード中。お待ちください',
          },
          modal: {
            noImage: 'Please upload an image',
            noModel: 'Please select a voice model to share',
            noTag: 'Please select at least one tag for each field',
            noLabel: 'Please give a label',
            longLabel: 'Label cannot exceed 25 characters',
          },
        },
        inferenceTab: {
          title: 'AIカバー',
          stepOne: {
            tooltip: {
              title: 'AIカバーの注意点',
              contents: [
                '音源の音質は極めて重要',
                '音楽にて買った正式音源を使用してください',
                'オートチューンのような過度な音響効果の入った曲はダメ',
                'コーラスの多い曲はお勧めしません',
              ],
            },
            title: '曲アップロード',
            subTitles: ['カバーする曲をアップロードしてください'],
            tabs: {
              fileUpload: {
                title: 'ファイルをアップロード',
                dragAndDropText: 'ドラッグ・アンド・ドロップ',
                dragAndDropButton: 'ファイルを選択',
                dragAndDropDuration: '(最大容量 75 MB)',
                vocalExtractionText: 'ボーカルだけが抽出されていますか？',
                vocalExtractionYes: 'はい',
                vocalExtractionNo: 'いいえ',
                vocalExtractionTooltip: {
                  title: 'ボーカル抽出注意点',
                  contents: [
                    'ボーカルだけが抽出された音源である場合に"はい"をクリック',
                    '普通の音源の場合には該当なし',
                  ],
                },
              },
              youtube: {
                title: 'youtubeリンク',
                linkPlaceholder: '10分未満から可能',
                linkbutton: '使用する',
                durationUnit: ['分', '秒'],
              },
              recording: {
                title: '音声録音',
                startButton: '録音開始',
                saveButton: 'セーブ',
                recordingButton: '録音中',
                userRecording: 'ユーザー音声録音',
              },
              ttm: {
                title: 'AI Music',
                button: 'Select / Create AI Song',
              },
            },
          },
          stepTwo: {
            title: 'AI音声を選んでください',
            modelInput: {
              placeHolder: 'AI音声選択',
              myModel: '自分のモデル',
              defaultModel: '基本モデル',
            },
            dragAndDropText: 'ボイスモデルを探す',
          },
          stepThree: {
            title: '設定',
            subTitles: 'ミキサーの値、 ファイル拡張子, ファイル名を設定してください',
            labelInput: {
              placeHolder: 'ファイル名を入力してください',
            },
            ouputFormatLabel: 'ファイル形式を選択してください',
            tooltip: {
              outputFormatMessage: 'WAV形式はプロ・プレミアムプランから選択できます',
              upgradePrompt: 'ここからプランのアップグレード',
              subscribePrompt: 'ここからサブスクライブ',
              title: 'AIカバー名前設定に関するヘルプ',
              contents: ['直接設定しない場合、「音声 - 参照元」で設定されます', '後で制作記録で変更可能'],
            },
          },
          submit: {
            completedAndLoadingPlayer:
              'カバー完了。オーディオプレイヤーをロードしています。いつでも"ヒストリー"タブからダウンロードできます',
            alreadyInProgress: 'カバー中',
            noRemaining: '使用可能回数が残っていません',
            start: '変換開始',
            uploading: 'アップロードしています。少しお待ちください',
            tryAgain: 'またやり直してください',
            tryAgainYoutubeDown:
              'もう一度お試しください。YouTubeのアップロードが繰り返し失敗する場合は、ファイルアップロードをご利用ください',
            inProgress:
              '変換しています。完了次第音源の再生ができます。"ヒストリー"タブから直ぐにカバー結果の確認やダウンロードできます',
            remainingCountText: 'Gen Credits left',
            tooltip: {
              contents: [
                'AIカバーには1~4分ほど掛かります',
                'サーバーにアクセスが集中している場合、学習が遅れる可能性があります',
                '"ヒストリー"タブから学習状況を確認できます',
              ],
            },
          },
          modal: {
            watermark:
              '無料プランではウォーターマーク（透かし）が含まれます。有料プランにアップグレードすることでウォーターマークは無くなります',
            exceedModelCount:
              '無料・基本プランでは最大3個の音声モデルを所持できます。プランのアップグレード、または所持している音声モデルのいずれかを削除してください',
            exceedMaxSize: '最大75MBのファイルまでアップロードできます',
            tooManyFiles: 'ファイルは最大1個までアップロードできます',
            notSupportedFileType: '認識できないファイル形式です',
            inProgress: 'すでに学習中です',
            noRemaining: '使用可能回数が残っていません',
            emptyYoutubeLink: 'カバーする曲をアップロードしてください',
            noModalSelected: 'ボイスモデルを選択してください',
            noLabel: '名前を入れてください',
            invalidYoutubeLink: 'リンクを認識できません',
            youtubeLinkTooLong: '10分未満から可能',
            longLabel: 'Label cannot exceed 100 characters',
          },
        },
        ttsInferenceTab: {
          title: 'AIテキスト音声変換',
          stepOne: {
            title: 'AI音声を選んでください',
            modelInput: {
              placeHolder: 'AI音声モデルを選択',
              myModel: '自分のモデル',
            },
            ttsTextAreaPlaceholder: 'テキスト入力で音声への変換ができます',
            dragAndDropText: '音声モデルを探すにはクリック',
          },
          stepTwo: {
            title: '変換するテキストを入力してください',
          },
          submit: {
            completedAndLoadingPlayer:
              '製作完了。オーディオプレイヤーをロード中です。"AIテキスト音声変換"-"ヒストリー"タブからすぐダウンロードできます',
            alreadyInProgress: '変換中',
            noRemaining: '使用可能な文字数が残っていません',
            start: '変換開始',
            uploading: 'アップロード中です。少しお待ちください',
            tryAgain: 'またやり直してください',
            inProgress:
              '変換中です。製作完了後、すぐ音源を再生することができます。"AIテキスト音声変換"-"ヒストリー"タブからもすぐダウンロードできます',
            requiredCredits: 'Required credits',
            remainingCredits: 'Remaining credits',
            setting: '設定',
          },
          modal: {
            selectModalTitle: 'AI音声',
            addNewModelText: '新しい音声を製作',
            exceedTextSize: '一回当たり変換可能な文字数を超えています。文字数 : {{characterLimitPerInference}}',
            inProgress: 'すでに学習中です',
            noRemaining: '今月使用可能な回数が残っていません',
            noModalSelected: '音声モデルを選択してください',
            noText: 'テキストを入力してください',
            variability: '変動性',
            stable: '単調さ',
            variable: '変動的',
            similarity: '類似度',
            low: '低い',
            high: '高い',
            longLabel: 'Label cannot exceed 50 characters',
          },
        },
        ttiInferenceTab: {
          title: 'Text To Image',
          stepOne: {
            title: 'Select an image model and set its similarity (optional)',
            modelTag: ['People', 'Style'],
            plusButton: 'Click to find an image model',
            modelStrength: 'Similarity',
            duplicateModels: 'Duplicate models exist',
          },
          stepTwo: {
            title: 'Write a description for the image',
            subTitles: ['Describe the image that the AI will generate'],
            ttiTextAreaPlaceholder: 'Type your desired text and the AI will generate an image for you',
          },
          stepThree: {
            title: 'Generate Result Image',
            subtitle: '(Required generation credits: 2)',
          },
          ttiCommunityTab: {
            title: 'AI Image Models',
            categoryTab: ['My Models'],
            createNewModel: 'Create Image Model',
          },
          submit: {
            alreadyInProgress: 'In Progress',
            noRemaining: 'No remaining credits left for this month',
            start: 'Start',
            tryAgain: 'Please Try Again',
            requiredCredits: 'Credits Required',
            remainingCredits: 'Remaining Credits',
            setting: 'Setting',
            nsfwWarning: ['NSFW text detected', 'Three violations will block upload for 1 minute'],
            nsfwBlock: ['Repeated NSFW text detected', 'Upload blocked for 1 minute'],
            uploading: ['Uploading', 'Please wait a moment'],
            complete: ['TTI Inference completed', 'Loading images...'],
            inProgress: [
              'Converting',
              'You may wait or leave the page and download the image in the "History" tab',
              'Creation may take 1-5 minutes depending on the settings',
            ],
            inProgressNoTick: ['Converting', 'You may download the image in the "History" tab'],
          },
          modal: {
            exceedTextSize: 'Can not convert more than {{characterLimitPerInference}} characters at a time',
            inProgress: 'Conversion in progress',
            lackRemaining: 'Lack remaining credits',
            noText: 'Please add text',
            setting: 'Setting',
            ratio: 'Aspect Ratio',
            size: 'Size',
            quality: 'Quality',
            guidance: 'CFG Scale',
            watermark: 'Watermark',
            quantity: 'Quantity',
            horizontal: '16:9',
            vertical: '9:16',
            square: '1:1',
            small: 'Small',
            medium: 'Medium',
            large: 'Large',
            low: 'Low',
            moderate: 'Moderate',
            high: 'High',
            creative: 'Creative',
            balanced: 'Balanced',
            strict: 'Strict',
            on: 'On',
            off: 'Off',
            longLabel: 'Label cannot exceed 25 characters',
          },
          tooltip: {
            watermarkContents: [
              'Turning on the watermark adds the SoriSori logo to your image',
              'Only Pro or Premium users can disable the watermark',
            ],
            ratioContents: [
              'Choose the desired aspect ratio for your image',
              '16:9 (Horizontal): Ideal for widescreen displays, presentations, and landscape-oriented content',
              '9:16 (Vertical): Best for mobile content, stories, and portrait-oriented designs',
              '1:1 (Square): Perfect for social media posts, providing a balanced and versatile format',
            ],
            sizeContents: [
              'Choose the image size, based on the aspect ratio',
              '16:9 (Horizontal):',
              'Small: 640x360px - Suitable for lightweight contents',
              'Medium: 960x544px - Great for standard quality needs',
              'Large: 1280x720px - Perfect for high-quality displays',
              '9:16 (Vertical):',
              'Small: 360x640px - Ideal for mobile-friendly stories',
              'Medium: 544x960px - A good balance with enhanced clarity',
              'Large: 720x1280px - Best for full-screen mobile designs',
              '1:1 (Square):',
              'Small: 480x480px - Suitable for quick previews',
              'Medium: 720x720px - Excellent for social media posts with good resolution',
              'Large: 1080x1080px - Best for high-quality social media contents',
            ],
            guidanceContents: [
              'CFG (Classifier-Free Guidance) Scale determines the balance between creativity and adherence to the input prompt',
              'Creative (2.0): Prioritizes imaginative and diverse outputs, potentially deviating from the prompt',
              'Balanced (3.5): Strikes a harmony between creativity and prompt accuracy (Recommended)',
              'Strict (5.0): Ensures precise adherence to the prompt, with less creative flexibility',
            ],
            stepsConetents: [
              'The quality of the generated image depends on the time spent refining it',
              'Low (20 steps): Produces images quickly with basic details',
              'Medium (30 steps): Creates images with more detail and a good balance of quality',
              'High (40 steps): Generates the most detailed and refined images but takes more time',
            ],
            batchSizeContents: [
              'Quantity refers to the number of images to process at the same time',
              'The number of images you want to process simultaneously',
              '1: Processes one image at a time',
              '2: Processes two images at a time.',
              '3: Processes three images at a time',
              '4: Processes four images at once',
            ],
            coinContents: [
              '2 credits per image',
              'Requires extra credits based on the setting',
              'Max size costs 1 additional credit',
              'Max quality costs 1 additional credit',
              'Max cfg scale costs 1 additional credit',
            ],
          },
          dialog: {
            title: "Sorry, this feature isn't available for you",
            text: 'Upgrade to PRO or PREMIUM tier to get access to the setting feature!',
          },
        },
        ttsTrainingTab: {
          title: 'AIテキスト音声変換',
          stepOne: {
            tooltip: {
              contentsOne: [
                '量より質。低品質10分より高品質5分の音源を',
                '背景音の入ってないきれいな音声を使うこと',
                '会話音声より歌声を使う事',
                '最大10MBのファイルまでアップロードできます',
                'ファイルは最大10個までアップロードできます',
              ],
            },
            sizeLimitText: '(各ファイルは10MB以下である必要があります)',
            numberLimitText: '(ファイルは最大10個まで)',
            dragAndDropDuration: '(総合{{minDuration}}秒以上、{{maxDuration}}分)',
            second: '秒',
          },
          modal: {
            sizeTooLarge: '各ファイルは10MB以下である必要があります.',
            tooManyFiles: 'ファイルは最大10個までアップロードできます.',
            exceedMaxDuration: '{{maxDuration}}分以上の音声ファイルはアップロードできません',
            minDuration: '{{minDuration}}秒以上の音声ファイルをアップロードしてください',
            duplicateFiles: '重複したファイルをアップロードすることはできません.',
          },
          submit: {
            tooltip: {
              contents: [
                '音声学習には0.5~10分掛かります',
                'サーバーにアクセスが集中している場合、学習が遅れる可能性があります',
                "'AIテキスト音声変換'-'ヒストリー'タブから確認できます",
              ],
            },
          },
        },
        ttiTrainingTab: {
          title: 'Text To Image Training',
          stepOne: {
            title: 'Upload Image Files and Select Cover Image',
            dragAndDropText: 'Drag and drop image files',
            sizeLimitText: '(Max 10 MB each)',
            numberLimitText: ['(Min 5 Files ~ Up to ', ' Files)'],
            thumbnailTag: 'Thumbnail',
            nsfwBlockMessage:
              'Some of the uploaded images were detected as inappropriate and will not be used for training',
            tooltip: {
              contents: [
                'The more images you upload, the better the model quality',
                'Images containing inappropriate content will not be used for training',
              ],
            },
          },
          stepTwo: {
            title: 'Select Model Type',
            usage: ['Person', 'Style'],
            tooltip: {
              contents: [
                '"Person" models learn to generate images of people, animals, or objects (e.g., humans, cats, cars).',
                '"Style" models learn specific artistic styles or details to generate images (e.g., cartoon, watercolor, Studio Ghibli).',
              ],
            },
          },
          stepThree: {
            title: 'Set Training Quality',
            subTitles: 'Quality increases with larger numbers',
            sliderLabel: 'Training Quality',
            tooltip: {
              contents: [
                'A higher training quality value improves the overall model performance.',
                'Level-1 learning quality requires 500 training iterations, and each higher level adds another 500 iterations.',
                'Increasing training quality enhances the detail and fidelity of generated images.',
              ],
            },
          },
          stepFour: {
            title: 'Label Your Model',
            placeholder: 'Use a name that clearly describes the model',
            tooltipEx:
              '(e.g. Donald Trump, the 45th and 47th President of the United States, Hollywood actress Emma Watson)',
          },
          modal: {
            fileUpgrade: ['With your current plan, you can only upload up to ', ' files.'],
            stepUpgrade: 'With your current plan, you can only train up to 1 step.',
            upgradeButton: 'Upgrade Subscription',
            nsfwChecking: 'Uploading image files. Please wait a moment.',
            uploadSuccess: 'The model was successfully uploaded. You can view the created model in the "History" tab.',
            longLabel: 'The name cannot exceed 25 characters.',
          },
          submit: {
            tooltip: {
              contents: [
                'Training quality level 1 is free.',
                'Levels 2 and above are available only for Pro/Premium users.',
                'From level 2 onward, each increase in quality consumes 1 credit.',
                'AI image training takes 10~60 minutes, depending on file count and quality.',
              ],
            },
          },
        },
        ttmInference: {
          title: 'AI Text To Music',
          stepOne: {
            title: 'Describe Your Style & Lyrics',
            promptMethod: {
              prompt: 'Prompt',
              tags: 'Tags',
              tooltip: {
                title: 'Style',
                contents: [
                  'Prompt: Enter a prompt to describe the style of music you want, generates more unique results',
                  'Tags: Select tags to describe the style of music you want, generates more accurate and consistent results',
                  'If left empty, style will be generated based on the lyrics',
                ],
              },
            },
            lyricMethod: {
              generate: 'Generate Lyrics',
              custom: 'Custom',
              tooltip: {
                title: 'Lyrics',
                contents: [
                  'Generate lyrics: Enter a prompt to describe the subject and style of lyrics you want',
                  'Custom: Enter your own lyrics, make sure to structure your lyrics with the provided labels',
                  'If left empty, lyrics will be generated based on the style',
                ],
              },
            },
            instrumental: 'Instrumental',
            noOptions: 'No options',
            placeholder: {
              prompt: 'Describe your style',
              tags: 'Search for tags',
              generateLyrics: 'Describe your lyrics',
              customLyrics: 'Enter your lyrics',
            },
            tooltip: {
              contents: [
                'Recommended to provide inputs for style and lyrics for a more accurate sound',
                'You can also skip style or lyrics and let AI generate them for you, based on your input',
                'If instrumental mode is on, you must provide a prompt or tags',
              ],
            },
          },
          stepTwo: {
            title: 'Create an AI Cover (optional)',
            selectVoice: 'Select AI Voice',
            tooltip: {
              contents: ['Costs 1 extra Gen Credit'],
            },
          },
          stepThree: {
            title: 'Output Settings',
            placeholder: 'Enter a label for your song',
            tooltip: {
              outputFormatMessage: 'WAV形式はプロ・プレミアムプランから選択できます',
              upgradePrompt: 'ここからプランのアップグレード',
              subscribePrompt: 'ここからサブスクライブ',
            },
          },
          submit: {
            creditUsage: 'Gen Credits per song',
            info: ['Song generation takes 30-40 seconds', 'AI Cover will take an additional 1-4 minutes'],
            start: 'Start',
            alreadyInProgress: 'In Progress',
            uploading: 'Uploading - Please wait a moment',
            inProgress: 'Generating - You may wait or leave the page and download the song in the "History" tab',
            completedAndLoadingPlayer:
              'Song generation completed. Loading audio player, but you may also download the song in the "History" tab',
            completedCoverAndLoadingPlayer:
              'AI cover generation completed. Loading audio player, but you may also download the song in the "History" tab',
            tryAgain: 'Please try again',
            lackRemaining: 'Not enough remaining gen credits',
          },
          modal: {
            inProgress: 'Generation in progress',
            coverInProgress: 'AI cover generation in progress',
            lackRemaining: 'Not enough remaining gen credits',
            emptyParams: 'Please enter a prompt, tags, or lyrics',
            noLabel: 'Please add a label',
            longLabel: 'Label cannot exceed 100 characters',
          },
          selectModal: {
            generate: {
              title: 'Generate AI Song',
              button: 'Create',
            },
            history: {
              title: 'History',
              button: 'History',
              searchbar: 'Search',
            },
          },
        },
        videoEditorTab: {
          title: 'Video Editor',
          addSource: 'Source',
          tooltip: {
            hide: 'Hide source',
            mute: 'Mute source',
            move: 'Move source',
            scale: 'Resize source',
            resetScale: 'Reset source size',
            snap: 'Enable timeline snapping',
            addText: 'Add a text source',
            editText: 'Edit selected text',
            zoom: 'Zoom in/out timeline',
          },
          modal: {
            longLabel: 'Label cannot exceed 50 characters',
          },
        },
        addSourceModal: {
          title: 'Add a source',
          sourceOptions: ['AI Cover', 'TTS', 'Youtube', 'Upload'],
          searchbar: 'Search',
          pagination: {
            loader: 'Loading...',
          },
          voice: 'AI Voice',
          youtube: {
            placeholder: 'Max 10 minutes',
            button: 'Search',
            invalidYoutubeLink: 'This is an incorrect YouTube link',
            youtubeLinkTooLong: 'The YouTube video may not exceed 10 minutes',
          },
          upload: {
            dragAndDropText: 'Drag and drop a video/audio/image file',
            sizeLimitText: '(Max 75 MB)',
            acceptedAudio: '.mp3, .wav, .flac, and .ogg',
            acceptedVideo: '.mp4 and .mkv',
            acceptedImage: '.jpeg, .png, and .webp',
            button: 'Select file',
            notSupportedFileType: 'This file format is not supported',
            tooManyFiles: 'Please upload one file at a time',
            exceedMaxSize: 'You can only upload files up to 75MB',
          },
          loading: ['Uploading file', '(may take up to a minute for larger files)'],
        },
        textEditorModal: {
          title: ['Add text', 'Edit text'],
          placeholder: 'Type your text here...',
          add: 'Add',
          save: 'Save',
        },
        videoExportModal: {
          title: 'Export video',
          placeholder: 'Give your exported video a label',
          watermark: 'Show watermark',
          start: 'Start',
          rendering: [
            'You may wait or leave the page and download the video in the "History" tab',
            'Exporting your video (may take up to a minute)',
          ],
          success: ['Video is ready', 'Your download will start automatically. If not, click the button below.'],
          tooltip: {
            contents: [
              'Export time will depend on the length of your video',
              'You will be taken to the History tab where you can check the progress',
            ],
          },
          videoRenderError: 'Could not render the video. Please try again',
        },

        faceSwapTab: {
          title: 'Face Swap',
          stepOne: {
            title: 'Step 1: Upload and Trim Your Video',
            subTitles:
              'Please upload the video you want to perform face swapping on, and edit it to the desired segment',
            tags: {
              sourceFile: 'Source File',
            },
            dragAndDropText: 'Drag and drop file',
            dragAndDropButton: 'Select File',
            dragAndDropDuration: '(Max 75 MB)',
            dragAndDropFormat: '(Supported Formats: mp4, mov)',
            youtubeLinkText: 'Please enter the YouTube link you want',
            youtubeLinkInput: 'Enter the YouTube link here (Max 15 mins)',
            trimVideo: ['You do not have enough credits', 'Please trim the video to less than ', ' seconds'],
          },
          stepTwo: {
            title: 'Step 2: Select Faces You Want To Change',
            subTitles:
              'Please select faces you want to change from your video, and replace the selected face from the previous step with your desired face',
            tags: {
              preview: 'Preview',
              detectedFaces: 'Recognized Faces',
            },
            settings: {
              title: 'Settings',
              sharpness: 'Sharpness of the Swapped Face',
              blendRatio: 'Original-Swapped Image Blend Ratio',
              watermark: 'Watermark',
              leftCoin: ['You have ', ' credits left'],
              poorCoin: [
                'You are short of ',
                ' credits ',
                'Please reduce the number of faces',
                'or trim the video length',
              ],
              requiredCoin: ' credits required',
              blednRatioMarks: ['Very Low', 'Low', 'High', 'Very High'],
              originalVideo: 'Quality Enhancement Not Set',
              compareQuality: 'Blend Ratio Settings Comparison',
            },
          },
          stepThree: {
            title: 'Step 3: Face Swap Completed',
            subTitles: 'Check out the resulting image or video created by swapping faces',
            tags: {
              sourceFile: 'Final Video',
            },
          },
          button: {
            settings: 'Settings',
            start: 'Start',
            selectImage: 'Select Image',
            apply: 'Apply',
            createNew: 'Create New',
            preview: 'Preview',
            inProgress: 'In Progress',
            goToHistory: ['History', 'Check'],
            prev: 'Prev',
            next: 'Next',
            buyCredit: 'Buy Credits',
          },
          dialog: {
            upgradeText: 'Upgrade to PRO or PREMIUM tier to get access to remove the watermark!',
            faceSelectionModal: 'Choose A Face',
            renderingError: [
              'An error occurred while loading the result video',
              'The credits you used were not deducted',
            ],
            reload: 'Try Again',
            videoLabelPlaceholder: 'Enter video title',
            sharpnessOn: 'Upgrade to PRO or PREMIUM tier to get access to use Sharpness of the Swapped Face!',
          },
          loading: {
            1: 'Detecting faces ...',
            2: 'Finding faces ...',
            3: 'preparing the result video',
            4: 'preparing preview image',
            5: 'ready for the result video',
            youtubeLinkUpload: {
              1: 'We are processing your video.',
              2: 'Depending on its length, it may take between 1 to 4 minutes.',
            },
            finalVideoGenerating: [
              'Your video is currently being processed',
              "Depending on the video's length and the number of faces being transformed, this may take approximately 2-5 minutes",
              'Please wait until the process is complete to play the video immediately',
              "If you leave the screen before it's finished, you can still monitor the production status and download the video later from the 'History' tab",
            ],
          },
          error: {
            facesInImage: 'Error while processing the face images',
            invalidFileType: 'Please upload .png or .jpeg file',
            fileTooLarge: 'Please upload under 10MB',
            noFacesSelected: 'Please select at least one face you want to change',
            noFacesDetected: 'Please try again with a different image that clearly shows a face',
            noFacesFound: 'No face detected. Please upload a video containing a face and try again.',
            faceDetectApiError: 'Please check your internet connection and try again',
            showPreview: 'Error while showing preview',
            uploadFailed: 'Failed to upload the result video',
            renderingFailed: 'Failed to render the result video',
            pollingError: 'Error while polling',
            pollingTimeout: [
              'We apologize for the inconvenience.',
              'The server response is currently delayed.',
              'You can check and download the status of your ongoing creations in the "History" tab.',
              'If the creation fails, no credits will be deducted.',
            ],
            youtubeLinkTooLong: 'The YouTube video may not exceed 15 minutes',
            downloadFailed: 'Failed to download the result video',
            nsfwVideo: 'NSFW content detected',
          },
          submit: {
            tryAgain: 'Please try again',
          },
          modal: {
            inProgress: 'Conversion in progress',
            noRemaining: [
              'No remaining Faceswap credits left for this month',
              'Upgrade to PRO or PREMIUM tier, or purchase individual products to replenish your credits',
            ],
            longLabel: 'Label cannot exceed 50 characters',
          },
          tooltip: {
            sharpness: {
              1: 'It is a technology that enhances resolution by inserting new pixels between existing pixels in an image.',
              2: 'It can improve the sharpness of the face image you upload (upscaling).',
              3: 'As the upscaling value increases, the quality and clarity of the face image improve; however, if the background video quality is low, the face may appear unnatural.',
            },
            coinLogic: [
              'Credit Calculation Formula = (credits based on video length) x (Number of faces to change)',
              'Add 15 credits for every 15-second interval based on video length (e.g., 1~15 seconds -> 15 credits, 16~30 seconds -> 30 credits)',
              'Multiply by the number of faces to change (e.g., 14-second video, 2 faces to change -> 15 credits x 2 = 30 credits)',
            ],
            coinCal: [
              'Required number of credits = (Video length: ',
              'Required number of credits = (Video length: ',
              ' sec -> ',
              ' credit ) x ( Number of faces: ',
              ' credit ) x ( Number of faces: ',
              ' ) = ',
              ' credits',
            ],
            coin: 'credits',
            videoLength: 'Trimmed Length:',
            creditUsed: 'Required Credits:',
          },
        },
        // MR除去ページ
        vocalExtractorTab: {
          title: 'MR除去',
          stepOne: {
            title: '音声アップロード',
            tabs: {
              fileUpload: {
                title: 'ファイルアップグレード',
                dragAndDropText: 'ドラッグ・アンド・ドロップ',
                dragAndDropButton: 'ファイルを',
                dragAndDropDuration: ' (最大容量 75 MB)',
              },
              youtube: {
                title: ' youtubeリンク',
                linkPlaceholder: '10分未満から可能',
                linkbutton: '使用する',
                durationUnit: ['分', '秒'],
              },
            },
            vocalExtractorSubTitles: ['MR除去をする音声ファイルをアップロードしてください'],
            tooltip: {
              contents: [
                'プレミアムユーザーは一度に最大10個のファイルをアップロードできます',
                'プロユーザーは一度に最大5個のファイルをアップロードできます',
                '基本/無料ユーザーは一度に1個のファイルをアップロードできます',
                'オーディオファイルの総長は60分を超えることができません',
              ],
            },
            maxUploadNumText: {
              premiumCustomAdmin: '最大10個のファイルをアップロード可能',
              pro: '最大5個のファイルをアップロード可能',
              basicFree: '最大1個のファイルをアップロード可能',
            },
          },
          stepTwo: {
            title: 'ファイル名を決めてください',
            labelInput: {
              placeHolder: 'ファイル名を決めてください',
            },
          },
          stepThree: {
            title: 'ファイル形式を選択してください',
            subTitles: 'ファイル拡張子とファイル名を設定してください',
            tooltip: {
              outputFormatMessage: 'WAV形式はプロ・プレミアムプランから選択できます',
              upgradePrompt: 'ここからプランのアップグレード',
              subscribePrompt: 'ここからサブスクライブ',
            },
          },
          submit: {
            alreadyInProgress: 'カバー中',
            upload: 'アップロード',
            inProgress: '変換しています。"ヒストリー"タブから直ぐにカバー結果の確認やダウンロードできます',
            noRemaining: '使用可能回数が残っていません',
            start: '開始',
            uploading: 'アップロードしています。少しお待ちください',
            tryAgain: 'しばらく経ってからやり直してください',
            remainingCountText: 'Gen Credits left',
          },
          modal: {
            notSupportedFileType: '認識できないファイル形式です',
            invalidYoutubeLink: 'リンクを認識できません',
            youtubeLinkTooLong: '10分未満から可能',
            noRemaining: '使用可能回数が残っていません',
            emptyYoutubeLink: ' MR除去をする音声ファイルをアップロードしてください',
            inProgress: 'すでに学習中です',
            exceedMaxSize: '最大75MBのファイルまでアップロードできます',
            exceedMaxDuration: '総再生時間は60分を超えることができません',
            premiumCustomManyFiles: 'Premium/Custom users can upload',
            proManyFiles: 'Pro users can upload',
            manyFiles: 'files at a time',
            noFiles: 'MRを削除する音声ファイルを追加してください',
            lackRemaining: '使用可能な回数を超えています',
            uploadStatusNotValid: 'MR削除の残り回数が不足しているか、すでに進行中です',
            tryAgain: 'アップロードに失敗したファイル:',
            noLabel: 'Please give a label to your vocal extract',
            longLabel: 'Label cannot exceed 50 characters',
          },
        },
        historyTab: {
          title: 'ヒストリー',
          inProgress: '進行中',
          failed: '失敗',
          freeVersionTag: '無料プラン',
          freePrefix: '無料プランではウォーターマーク（透かし）が含まれます',
          tooltip: {
            contents: [
              'AIカバーには2~4分ほど掛かります',
              '音声学習には0.5~1時間掛かります',
              "作業が失敗になった場合、'問い合わせ'タブをご利用ください",
            ],
          },
          tabs: {
            inference: {
              title: 'AIカバー',
            },
            training: {
              title: 'AI音声',
            },
            vocalExtract: {
              title: 'MR除去',
            },
            community: {
              title: 'コミュニティ',
            },
            videoEditor: {
              title: 'Video Editor',
            },
            faceSwap: {
              title: 'Face Swap',
            },
            image: {
              title: 'AI Image',
              makeNewAIImage: 'Create New AI Image',
            },
            ttiTraining: {
              title: 'AI Image Model',
              makeNewTraining: 'Create New Image Model',
              style: 'Style',
              object: 'Object',
            },
            ttm: {
              title: 'AI Music',
            },
          },
          changeButton: '変更',
          cancelButton: 'キャンセル',
          confirmModelDelete: 'このモデルを削除しても再学習できません。削除しますか？',
          confirmDelete: '本当に削除しますか？',
          searchbar: '検索',
          infoIcon: {
            source: '著作権',
            voice: '音声',
            pitch: 'キー設定',
            mixing: {
              title: 'Mixer settings',
              vocalLevel: 'Vocal Level',
              reverbLevel: 'Reverb Level',
              reverbLength: 'Reverb Length',
            },
            tts: {
              voice: '音声',
              variability: '変動性',
              similarity: '類似度',
            },
            errorMessage: 'エラー',
          },
          pagination: {
            loader: 'ロード中...',
          },
          modal: {
            error: 'ページを更新してください',
            label: '名前',
            username: 'またはユーザーネーム',
            image: '画像',
            filterError: '音声フィルターが見つかりません',
          },
          trainingInfo: {
            files: '使用した音源',
            extracted: 'ボーカル抽出機能使用',
            shared: 'コミュニティに共有',
            yes: 'はい',
            no: 'いいえ',
            status: 'ステータス',
            errorFile: 'エラーがあるファイル',
          },
          voice: 'AI音声',
          ttmInfo: {
            tags: 'Tags',
            prompt: 'Prompt',
            lyricPrompt: 'Lyric Prompt',
            lyrics: 'Lyrics',
            failed:
              "Text to Music has failed, please try again. If the issue persists, please contact SORISORI's support team.",
          },
          noOptions: 'No options',
          creations: {
            title: 'My Creations',
            tabs: [
              { title: 'AI Cover', tab: 'music' },
              { title: 'Text To Music', tab: 'ttm' },
              { title: 'Text To Speech', tab: 'speech' },
              { title: 'Text To Image', tab: 'image' },
              { title: 'Face Swap', tab: 'faceSwap' },
              { title: 'Vocal Extract', tab: 'vocalExtract' },
              { title: 'Video Editor', tab: 'videoEditor' },
            ],
          },
          models: {
            title: 'My Models',
            tabs: [
              { title: 'AI Cover Training', tab: 'music' },
              { title: 'TTS Training', tab: 'speech' },
              { title: 'TTI Training', tab: 'image' },
              { title: 'Community', tab: 'community' },
            ],
          },
        },
        subscriptionTab: {
          title: 'プラン',
          pageTitleOne: 'ソリソリAI',
          popular: '人気プラン',
          cancel: {
            message: 'サブスクリプションをキャンセルしますか？',
            success: 'サブスクリプションのキャンセルが完了しました！',
            fail: 'サブスクリプションのキャンセルに失敗しました。再度お試しください。',
          },
          cancelChange: {
            message: 'サブスクリプションの変更をキャンセルしますか？',
            success: 'サブスクリプションの変更キャンセルが完了しました！',
            fail: 'サブスクリプションの変更キャンセルに失敗しました。再度お試しください。',
          },
          onetime: {
            message: '購入しますか？',
            success: '購入が完了しました！',
            fail: '決済に失敗しました。再度お試しください。',
          },
          downgrade: {
            message: '料金プランの変更を進めますか？',
            success: '料金プランの変更が完了しました！',
            fail: '料金プランの変更に失敗しました。再度お試しください。',
          },
          upgrade: {
            message: '料金プランの変更を進めますか？既存の決済方法で決済が試行されます。',
            success: '料金プランの変更が完了しました！',
            fail: '料金プランの変更に失敗しました。再度お試しください。',
            paymentFailed: '決済に失敗しました。マイプロフィールで決済手段を変更するか、再度お試しください。',
          },
          annualize: {
            message:
              "Are you sure you want to change to a lower tier yearly plan? Once you click 'Pay', payment will be made with the existing payment method.",
            success: 'Subscription changed successfully!',
            fail: 'Subscription change failed. Please try again.',
            paymentFailed: 'Payment failed. Please update the payment method from My Profile or try again.',
          },
          disabled: {
            tooltip: {
              contents: ['Yearly to monthly subscription transition is not available'],
            },
          },
          mobilePaymentRequired:
            'モバイルアプリでサブスクリプションを設定さ れたため、サブスクリプション管理もモバイル アプリで行ってください。',
          tabs: {
            subscription: {
              title: 'サブスクライブ',
              pastDue: '未決済',
              month: '月',
              monthly: 'Monthly',
              yearly: 'Yearly',
              upfront: 'Billed yearly',
              yearlyTag: '2 Months Free',
              subscribe: 'サブスクライブ',
              change: '変更する',
              currentTier: 'Current Tier',
              popular: 'Most Popular',
              value: 'Best Value',
              moreCredits: 'Need more credits?',
              discount: '80% discount on additional credits',
            },
            creditInfo: {
              title: 'How do credits work?',
              contents: [
                'Get new credits every month to use our AI generation and training services',
                'Credit usage will vary across services (see below)',
                'Credits reset every month and unused credits do not roll over to the next month (Additional credits purchased do not expire)',
              ],
            },
            creditUsage: {
              title: 'Cost per service',
              generation: 'Generation service',
              training: 'Training service',
              cost: 'Cost',
            },
          },
          paymentModal: {
            usePromoCode: 'プロモーションコードを使用',
            promoCodePlaceholder: 'プロモーションコード',
            applyButton: '使用',
            submit: 'Continue',
            promoCodeApplied: 'プロモーションコード適用',
            invalidPromoCode: '無効なプロモーションコードです',
            genericError: '再度お試しください',
            promoCodeError: {
              doesNotExist: 'Invalid promo code. Please check the code',
              invalidSubscriptionType: 'This promo code is only valid for PRO and PREMIUM plans',
              onlyFirstTime: 'This promo code is valid for first-time users only',
            },
          },
        },
        communityTab: {
          title: 'コミュニティ',
          subTitle: '希望の声を選んでAIカバーを作ってみてください!',
          subtitleOne: '🔥今月の人気モデル',
          subtitleTwo: '全リスト',
          inProgress: 'カバー中',
          tags: 'タグ',
          failed: '失敗',
          sortOptions: ['新しい順', 'いいね順', '製作回数', 'モデル名'],
          freeVersionTag: '無料プラン',
          freePrefix: '無料プランではウォーターマーク（透かし）が含まれます',
          voiceOptions: ['コミュニティ', '自分の音声', 'いいね'],
          tooltip: {
            contents: [
              'AIカバーには2~4分ほど掛かります',
              '音声学習には2~4時間掛かります',
              "作業が失敗になった場合、'Q&A'タブをご利用ください",
            ],
          },
          tabs: {
            inference: {
              title: 'AIカバー',
            },
            training: {
              title: 'AI音声',
            },
            vocalExtract: {
              title: 'MR除去',
            },
          },
          changeButton: '変更',
          cancelButton: 'キャンセル',
          confirmModelDelete: 'このモデルを削除しても再学習できません。削除しますか？',
          confirmInferenceDelete: '本当に削除しますか？',
          confirmVocalExtractDelete: '本当に削除しますか？',
          searchbar: '検索',
          infoIcon: {
            source: '著作権',
            voice: '音声',
            pitch: 'キー設定',
          },
          pagination: {
            loader: 'ロード中...',
          },
          modal: {
            error: 'ページを更新してください',
            aihubError: 'This model has expired, please select another model.',
          },
          button: {
            share: 'モデル共有',
          },
        },
        supportTab: {
          title: 'Discord',
          link: 'https://discord.gg/AVREYrRZv4',
        },
        pipeline: {
          inferenceStatusMessage: {
            formatError: 'ファイル形式と拡張子が一致していないか、ファイルが破損しているか安全ではありません',
            volumeError:
              'ファイル内の音声の音量が小さすぎるか、音声が含まれていません。録音設定を確認するか、音声編集ソフトを使用して音量を上げてください。',
            invalidFileError: 'ファイルを開くことができません。ファイルを確認してください。',
            progress10: '進行中 10%',
            progress20: '進行中 20%',
            progress40: '進行中 40%',
            progress50: '進行中 50%',
            progress60: '進行中 60%',
            progress80: '進行中 80%',
            progress100: '進行中 100%',
            complete: '完了',
            generalMessage:
              'AIカバーが失敗しました。再度お試しください。問題が続く場合は、SORISORIサポートチームに連絡してください。',
            starting: '開始中',
          },
          trainingStatusMessage: {
            formatError: 'ファイル形式と拡張子が一致していないか、ファイルが破損しているか安全ではありません',
            volumeError:
              'ファイル内の音声の音量が小さすぎるか、音声が含まれていません。録音設定を確認するか、音声編集ソフトを使用して音量を上げてください。',
            invalidFileError: 'ファイルを開くことができません。ファイルを確認してください。',
            invalidAihubModel: 'This model has expired, please select another model.',
            progress10: '進行中 10%',
            progress20: '進行中 20%',
            progress40: '進行中 40%',
            progress50: '進行中 50%',
            progress60: '進行中 60%',
            progress80: '進行中 80%',
            progress100: '進行中 100%',
            complete: '完了',
            generalMessage:
              'トレーニングが失敗しました。再度お試しください。問題が続く場合は、SORISORIサポートチームに連絡してください。',
            starting: '開始中',
          },
        },
        modal: {
          confirmationPay: '支払う',
          confirmationCancel: 'キャンセル',
          confirmationYes: 'はい',
          confirmationNo: 'いいえ',
          combined: 'ミックス',
          vocal: 'ボーカル',
          backVocal: 'コーラス',
          instrument: '伴奏',
          fileUploadFail: 'ファイルアップロードに失敗しました。ファイルをもう一回確認しやり直してください',
          trainingInProgressError: 'すでに学習中です',
          noRemainingError: '使用可能な回数をすべて使用しました',
          genericError: 'ファイルのアップロードに失敗しました。再試行してください',
          pageLoadFail: 'ページを読み込めませんでした。ページを更新してください',
          pageLoadFailOnSubmit:
            "ファイルアップロードに成功しましたが、ページをロードできませんでした。ページを更新してください。'ヒストリー'タブから確認できます",
          gotoProfile: 'マイプロフィールを見る',
          youtubeDownloadLink: 'Youtube Download Link',
          youtubeCountryBlocked: 'この動画は著作権/地域制限により、現在の国では利用できません。',
          youtubeCountryBlockedCopyright: 'この動画は著作権/地域制限により、現在の国では利用できません。',
        },
        mixingModal: {
          label: 'ミックス',
          title: 'ミキシング',
          sliders: {
            contents: ['キー調整', '音声ボリューム', 'リバーブボリューム', 'リバーブ長さ'],
          },
          tooltip: {
            contents: [
              '男性音声で女性曲をカバーする場合 -4 ~ -6 推奨',
              '女性音声で男性曲をカバーする場合 +4 ~ +6 推奨',
              '過度なキー調整は音質を低下させる可能性があります',
              'ボーカルトラックの音量',
              '0dBは元の曲のボーカル音量です',
              'リバーブ効果の大きさ',
              '0はリバーブ効果がなく、6はリバーブ効果が最大です',
              'リバーブ効果の長さ',
              'バラード曲には約2秒を推奨し、テンポの速い曲ほど低い数値を推奨します',
            ],
          },
          demo: {
            toggle: 'ミキシング',
            status: ['ミキシング不可', 'ミキシング可'],
            description: 'ミキシング機能の違いを聞いてみましょう',
          },
          dialog: {
            title: '現在の料金プランでは使用不可能な機能です',
            text: 'プロまたはプレミアムにアップグレードするとミキシング機能を使用することができます!',
          },
          upgradeButton: ['アップグレード', 'プロ'],
          alert: 'ミキサーの値を指定してください',
        },
        freeInferenceMessageModal: {
          messeageOne: ['無料版には広告が含まれており', '45秒に制限されています'],
          messeageTwo: ['有料製品を使用して', '広告なしのフルレングスの曲を生成します'],
          button: '購読する',
        },
        youtubeReenabledModal: {
          title: 'YouTube機能が復活しました！',
          description: 'YouTubeリンクで再度AIカバーを作成できます。',
          confirm: '確認',
          hideFor3Days: '1日間表示しない',
        },
        freeTrainingMessageModal: {
          messages: ['AI学習は有料版に切り替え後', 'ご利用いただけます'],
          button: 'プランを確認',
        },
        freeVocalExtractorMessageModal: {
          free: {
            message: [
              '無料ユーザーは',
              '最大1つのファイルを',
              'アップロードできます',
              'より多くのファイルを',
              'アップロードしたい場合は',
              'サブスクリプションに',
              '加入してください',
            ],
          },
          basic: {
            message: [
              '基本ユーザーは',
              '最大1つのファイルを',
              'アップロードできます',
              'より多くのファイルを',
              'アップロードしたい場合は',
              'サブスクリプションに',
              '加入してください',
            ],
          },
          button: 'サブスクする',
        },
        onetimeItems: [
          {
            type: 'GEN_CREDIT_5',
            name: '5 Gen Credits',
            discount: {
              strikethrough: '5',
              name: '25 Gen Credits',
              type: 'GEN_CREDIT_25_PRO',
            },
            price: {
              usd: '$5',
              thb: '฿130',
              krw: '5,000ウォン',
              jpy: '¥590',
            },
          },
          {
            type: 'GEN_CREDIT_25',
            name: '25 Gen Credits',
            discount: {
              strikethrough: '25',
              name: '150 Gen Credits',
              type: 'GEN_CREDIT_150',
            },
            price: {
              usd: '$25',
              thb: '฿650',
              krw: '25,000ウォン',
              jpy: '¥2950',
            },
          },
          {
            type: 'TRAINING_CREDIT_1',
            name: '1 Training Credit',
            price: {
              usd: '$7',
              thb: '฿250',
              krw: '8,500ウォン',
              jpy: '¥990',
            },
          },
          {
            type: 'TRAINING_CREDIT_5',
            name: '5 Training Credits',
            discount: {
              strikethrough: '5',
              name: '7 Training Credits',
              type: 'TRAINING_CREDIT_7',
            },
            price: {
              usd: '$35',
              thb: '฿1250',
              krw: '42,500ウォン',
              jpy: '¥4950',
            },
          },
        ],
        subscriptionItems: [
          {
            name: '無料プラン',
            model: 'FREE', //leave in english
            monthlyRate: {
              usd: '$0',
              thb: '฿0',
              krw: '0ウォン',
              jpy: '¥0',
            },
            features: [
              {
                name: '2 AI Covers',
              },
              {
                name: '2 Vocal Extracts',
              },
              {
                name: '25 TTS characters',
              },
              {
                name: 'One 15 sec Face Swap video',
              },
              {
                name: '5 TTI generations',
              },
            ],
          },
          {
            name: '基本プラン',
            model: 'BASIC', //leave in english
            monthlyRate: {
              usd: '$9.99',
              thb: '฿279',
              krw: '14,800ウォン',
              jpy: '¥1,699',
            },
            yearly: {
              model: 'BASIC_YEARLY',
              monthlyRate: {
                usd: '$8.30',
                thb: '฿233',
                krw: '12,333ウォン',
                jpy: '¥1,417',
              },
            },
            features: [
              {
                name: '150 Gen Credits',
                usage: [
                  'Up to 150 AI Covers',
                  'Up to 150 Vocal Extracts',
                  'Up to 1500 TTS characters',
                  'Up to 150 sec of Face Swap',
                  'Up to 75 TTI generations',
                ],
              },
              {
                name: '2 Training credits',
                usage: ['Up to 2 AI voices', 'Up to 2 TTS voices'],
              },
              {
                name: 'Speed: Slow',
              },
              {
                name: 'Train Quality: Medium',
              },
              {
                name: 'Sound Quality: Normal (MP3)',
              },
            ],
          },
          {
            name: 'プロプラン',
            model: 'PRO', //leave in english
            monthlyRate: {
              usd: '$24.80',
              thb: '฿619',
              krw: '28,800ウォン',
              jpy: '¥3,490',
            },
            discountedFrom: {
              thb: '฿880',
            },
            yearly: {
              model: 'PRO_YEARLY',
              monthlyRate: {
                usd: '$20.70',
                thb: '฿516',
                krw: '24,000ウォン',
                jpy: '¥2,908',
              },
            },
            features: [
              {
                name: '1000 Gen credits',
                usage: [
                  'Up to 1000 AI Covers',
                  'Up to 1000 Vocal Extracts',
                  'Up to 10000 TTS characters',
                  'Up to 1000 sec of Face Swap',
                  'Up to 500 TTI generations',
                ],
              },
              {
                name: '5 Training credits',
                usage: ['Up to 5 AI cover voices', 'Up to 5 TTS voices'],
              },
              {
                name: 'Speed: Fast',
              },
              {
                name: 'Train Quality: High',
              },
              {
                name: 'Sound Quality: High (WAV)',
              },
              {
                name: 'Discount on additional products',
              },
            ],
          },
          {
            name: 'プレミアムプラン',
            model: 'PREMIUM', //leave in english
            monthlyRate: {
              usd: '$68.80',
              thb: '฿1680',
              krw: '88,800ウォン',
              jpy: '¥8,990',
            },
            yearly: {
              model: 'PREMIUM_YEARLY',
              monthlyRate: {
                usd: '$57.30',
                thb: '฿1400',
                krw: '73,333ウォン',
                jpy: '¥7,490',
              },
            },
            features: [
              {
                name: '5000 Gen credits',
                usage: [
                  'Up to 5000 AI Covers',
                  'Up to 5000 Vocal Extracts',
                  'Up to 50000 TTS Characters',
                  'Up to 5000 sec of Face Swap',
                  'Up to 2500 TTI generations',
                ],
              },
              {
                name: '20 Training credits',
                usage: ['Up to 20 AI voices', 'Up to 20 TTS voices'],
              },
              {
                name: 'Speed: Very Fast',
              },
              {
                name: 'Train Quality: Best',
              },
              {
                name: 'Sound Quality: High (WAV)',
              },
              {
                name: 'Discount on additional products',
              },
            ],
          },
        ],
        costPerService: {
          generation: [
            {
              name: 'AI Cover',
              cost: '1 Gen Credit',
            },
            {
              name: 'Vocal Extract',
              cost: '1 Gen Credit',
            },
            {
              name: 'Text to Speech',
              cost: '10 characters per Gen Credit',
            },
            {
              name: 'Face Swap',
              cost: '15 Gen Credits per face, per 15s',
            },
            {
              name: 'Text to Image',
              cost: '2+ Gen Credits',
            },
          ],
          training: [
            {
              name: 'TTS Voice Model',
              cost: '1 Training Credit',
            },
            {
              name: 'AI Voice Model',
              cost: '1 Training Credit',
            },
          ],
        },
        subscriptionComparison: {
          title: 'Compare Subscriptions',
          headers: {
            feature: 'Feature',
            inference: 'AI Cover',
            faceSwap: 'Face Swap',
            tti: 'Text to Image',
            row: ['FREE', 'BASIC', 'PRO', 'PREMIUM'],
          },
          subscription: [
            {
              feature: 'Gen Credit Value',
              row: [
                '-', // FREE
                '$0.1 per credit', // BASIC
                '$0.025 per credit', // PRO
                '$0.013 per credit', // PREMIUM
              ],
            },
            {
              feature: 'Training Credit Value',
              row: ['-', '$5 per credit', '$3.6 per credit', '$2.75 per credit'],
            },
            {
              feature: 'Speed',
              row: ['Slow', 'Medium', 'Fast', 'Very Fast'],
            },
            {
              feature: 'Training Quality',
              row: ['Low', 'Good', 'Very Good', 'Best'],
            },
            {
              feature: 'Discount on additional credits',
              row: ['-', '-', '-80%', '-80%'],
            },
          ],
          inference: [
            {
              feature: 'Pitch Change',
              row: ['Y', 'Y', 'Y', 'Y'],
            },
            {
              feature: 'AI Mixing',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'MP3',
              row: ['Y', 'Y', 'Y', 'Y'],
            },
            {
              feature: 'WAV (HQ)',
              row: ['N', 'N', 'Y', 'Y'],
            },
          ],
          faceSwap: [
            {
              feature: 'Video Enhancement',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'Watermark Removal',
              row: ['N', 'N', 'Y', 'Y'],
            },
          ],
          tti: [
            {
              feature: 'Maximum Quality',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'Maximum Size Setting',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'CFG Scale Setting',
              row: ['N', 'N', 'Y', 'Y'],
            },
            {
              feature: 'Watermark Removal',
              row: ['N', 'N', 'Y', 'Y'],
            },
          ],
        },
        faqTab: {
          title: 'よくある質問',
          placeholder: '検索...',
          faqs: [
            {
              title: 'AI学習関連の質問',
              qnas: [
                {
                  question: 'アップロードする時に出力できるファイル形式は何がありますか？',
                  answers: [
                    'mp3, wav, m4a, mkv, mp4, flac, ogg の６つを提供しています。高めの品質の音源を学習させるのが大事であり、ファイルを変換するたびに品質は低くなります。m4aの場合、モバイルレコーダーに該当するファイル形式です',
                  ],
                },
                {
                  question: 'ボーカル抽出は必修ですか',
                  answers: [
                    'ソリソリAIの学習過程には、すでに優秀なボーカル抽出機能が含まれています。従って、ボーカル抽出は必修ではありません',
                    '基本的には不要ですが、学習する前に音源の音質が確認してからカバー曲を作れるという長所があります。',
                    '"MR除去機能"からボーカル抽出ができます',
                  ],
                },
                {
                  question: '複数の曲をアップロードして学習させることもできますか？',
                  answers: [
                    'はい、複数の曲をアップロードすることもできます',
                    '同様に、直接録音の場合にも複数回に分けてアップロードできます',
                  ],
                },
                {
                  question: '録音するときにはどのマイクを使う必要がありますか',
                  answers: ['モバイルレコーダーでも大丈夫です。静かな環境で録音することをおすすめします'],
                },
                {
                  question: 'カラオケにて録音したものを学習させても大丈夫ですか？',
                  answers: [
                    'カラオケえの録音は音質も悪いし、何より音響効果が強くてお控え目です。破裂音を伴うカラオケ特有の鳴り響く音が音声モデルに入る可能性があります',
                  ],
                },
                {
                  question:
                    '録音してからは必ず確認してください。マイクとの距離が近くて破裂音が入ったりよく聞こえないことがよくあります',
                  answers: [],
                },
                {
                  question: '学習結果が気に入りません。もう１回モデルを学習させることはできますか？',
                  answers: [
                    'モデルを削除しても学習回数は復旧されません。学習開始と同時にサーバーに費用が発生するので、削除しても学習回数をすることはできかねます。何卒ご理解お願いします',
                  ],
                },
              ],
            },
            {
              title: 'AIカバー関連の質問',
              qnas: [
                {
                  question: '学習するとき繰り返してキャンセルされます',
                  answers: [
                    'アップロードした音源ファイルを確認してください。ファイルを変換する時に単純にファイル名を.mp3や.wavに変えたのではないか確認してください。ネット上のファイル形式変換器を利用してください',
                  ],
                },
                {
                  question: 'アップロードする時に出力できるファイル形式は何がありますか？',
                  answers: [
                    'mp3, wav, m4a, mkv, mp4, flac, ogg の６つを提供しています。高めの品質の音源を学習させるのが大事であり、ファイルを変換するたびに品質は低くなります。m4aの場合、モバイルレコーダーに該当するファイル形式です',
                  ],
                },
                {
                  question: 'ボーカル抽出は必修ですか',
                  answers: [
                    'ソリソリAIの学習過程には、すでに優秀なボーカル抽出機能が含まれています。従って、ボーカル抽出は必修ではありません',
                    '直接抽出するときには抽出した音源の音質が確認してからカバー曲を作れるという長所があります。この場合、"ボーカルだけが抽出されていますか？"に"はい"を選択してください',
                  ],
                },
                {
                  question:
                    '歌手グループの一人だけを学習させたい場合、その人の部分だけ切り取って学習させることもできますか',
                  answers: [
                    'はい,1つの音源から一人だけを学習させたい場合、その部分だけ切り取って学習させる必要があります',
                  ],
                },
                {
                  question: 'キー変換（設定）はどう使えばいいですか',
                  answers: [
                    '男性ボーカルと女性ボーカルは通常4~6キー差が出てます。例えば、男性モデルを使って女性曲をカバーする場合、キー設定から+4 ~ +6位あげてみてください但しキー変換の途中、音質を落とす効果が入る可能性があります。AI音声やカバーする原曲によって多少不安定な結果が出る可能性があります',
                  ],
                },
                {
                  question: 'ナレーションも学習できますか',
                  answers: [
                    'はい,できます。曲をカバーするときよりはクオリティが低い可能性はありますが学習させる音源によって自然な結果が得られることもあります',
                  ],
                },
                {
                  question: 'ヒストリータブからダウンロードができません',
                  answers: [
                    'NAVERアプリやNAVER電子メールなど、通常のインターネットブラウザ以外からの接続の場合、不具合が起こる可能性があります',
                    '基本インターネットアプリ、chrome、Safari、Firefoxなどの通常のインターネットブラウザから接続してもらうと解決駅ると思います',
                  ],
                },
              ],
            },
            {
              title: 'AIカバーTIP',
              qnas: [
                {
                  question:
                    '音源の品質はAIカバーに極めて大きい影響を及ぼします。youtube音源の場合、音源に大きい損失がありますので、melon、Bugsのような音源サイトから買った正式音源を使用してください',
                  answers: [],
                },
                {
                  question:
                    'オートチューンのような音響効果が多い場合やコーラス（バックボーカル）の強い音源はボーカルを綺麗に分離して学習しかねますので、お勧めしません',
                  answers: [],
                },
                {
                  question: '同様に複数人のボーカルの入った曲はお勧めしません',
                  answers: [],
                },
              ],
            },
            {
              title: '決済関連の質問',
              qnas: [
                {
                  question: 'アップグレード料金の計算',
                  answers: ['アップグレード料金は、二つのサブスクリプションプランの差額です。'],
                },
                {
                  question: 'サブスクリプションのキャンセル',
                  answers: [
                    '- サブスクリプションはプロファイルページからキャンセルできます',
                    '- プロファイルページは、サブスクリプションページの無料プランカードの「変更」ボタンをクリックするか、ナビゲーションバーでユーザー名をクリックすることでアクセスできます',
                  ],
                },
                {
                  question: '現在の月だけ利用する場合は？',
                  answers: [
                    '上記の方法でサブスクリプションをキャンセルした場合、その月の残り期間は引き続き利用できます。',
                  ],
                },
                {
                  question: '未使用のモデルとカバーの繰り越し',
                  answers: ['未使用のモデル/カバーは翌月に繰り越されません。毎月割り当てられた数にリセットされます'],
                },
                {
                  question: 'カード決済の問題',
                  answers: [
                    '2024年12月20日現在、国際認証を受けたカード、韓国国内のカード、及びKakaoPayがサポートされています。引き続き支払いに問題がある場合は、銀行またはカード発行者に連絡する必要があります',
                  ],
                },
                {
                  question: '返金ポリシー',
                  answers: [
                    '返金の条件は以下の通りです：',
                    '- 個別の製品は返金できません。',
                    '- その月に利用記録がないこと。',
                    '- 支払日から3週間（21日間）以内に返金リクエストを行う必要があります。',
                    '- プランに関係なく3ドルの返金手数料が発生します。',
                    '- サブスクリプションは自分でキャンセルする必要があります。サブスクリプションはプロファイルページからキャンセルできます。',
                    '- プロファイルページは、サブスクリプションページの無料プランカードの「変更」ボタンをクリックするか、ナビゲーションバーでユーザー名をクリックすることでアクセスできます。',
                  ],
                },
                {
                  question: '返金処理にかかる時間は？',
                  answers: [
                    '問い合わせ日を基準に、クレジットカードでは通常5〜8営業日かかりますが、KakaoPayの場合は少し短くなることがあります。',
                  ],
                },
              ],
            },
            {
              title: 'その他',
              qnas: [
                {
                  question: 'アカウント削除をしたいです',
                  answers: ['discordから案内しております', '利用者様本人からできるように開発中です'],
                },
                {
                  question: 'discordって何ですか',
                  answers: [
                    '多くのソリソリAIユーザー様が利用しているコミュニティです。情報共有や、他人のカバー結果の評価することもできるプラットフォームです。',
                  ],
                },
                {
                  question: '今月使用できる回数をすべて使い尽くしました。追加で音声学習やMR除去をすることはできますか',
                  answers: [
                    'プランページから個別商品を選択すると利用できます',
                    '個別商品を買うよりプランのアップグレードの方がコスパ良いです',
                  ],
                },
              ],
            },
          ],
        },
        contactTab: {
          title: '問い合わせ',
          placeholder: {
            type: '問い合わせ内容',
            email: 'e-mail(電子メール)',
            text: '内容を入力してください',
            refund:
              '払い戻しをするためには以下の条件を満たす必要があります\n\n1. 個別の製品は返金できません。\n2. その月に利用記録がないこと。\n3. 支払日から3週間（21日間）以内に返金リクエストを行う必要があります。\n4. プランに関係なく3ドルの返金手数料が発生します。\n5. サブスクリプションは自分でキャンセルする必要があります。サブスクリプションはプロファイルページからキャンセルできます。\n6. プロファイルページは、サブスクリプションページの無料プランカードの「変更」ボタンをクリックするか、ナビゲーションバーでユーザー名をクリックすることでアクセスできます。',
          },
          message: {
            deleteAccount:
              'アカウントを削除すると取り消しできません。アクティブなサブスクリプションは自動的にキャンセルされますが、モバイルサブスクリプションはお使いのアプリストアを通じてキャンセルする必要があります。',
            confirmDeleteAccount: "確認するには 'DELETE' と入力してください。",
            deleteConfirm: 'アカウント削除',
            accountDeletedMessage: 'アカウントは正常に削除されました。これよりログアウトします。',
            type: '問い合わせの内容を選択してください',
            email: '正しくないe-mailです',
            content: '内容を入力してください',
            loading: '情報を送信しました。少々お待ちください',
            success: '送信に成功しました',
            refundSuccess: '返金リクエストが正常に送信されました。メールでステータスをご確認ください。',
            fail: '送信に失敗しました。やりない押してください',
            useDiscord: '学習及びカバー関連の質問はよくある質問タブ、またはdiscordコミュニティを利用してください',
          },
          contactType: [
            '学習・カバー機能関連の質問',
            'API問い合わせ',
            '払い戻し問い合わせ',
            'アカウント削除',
            'ビジネス問い合わせ',
          ],
          submit: '登録する',
        },
        emailPreferenceTab: {
          title: 'メール設定',
          header: '特別なオファー、新機能、重要なお知らせを受け取りましょう',
          choiceLabels: {
            announcement: 'お知らせ',
            notification: '通知',
            newsletter: 'ニュースレター',
            promotion: 'プロモーション',
          },
          submit: {
            save: '保存',
          },
          modal: {
            success: '登録が完了しました',
            error: '問題が発生しました。再試行してください。',
          },
        },

        profileTab: {
          title: 'マイプロフィール',
          sections: {
            login: {
              title: 'ログイン情報',
              logout: 'ログアウト',
            },
            payment: {
              title: 'サブスクリプション情報',
              changePayment: '決済手段の変更',
              updateSubscription: '料金プランの変更',
              cancelSubscriptionChange: 'サブスクリプション変更のキャンセル',
              history: '決済履歴を見る',
              cancel: 'サブスクリプションのキャンセル',
              currentSubscription: '現在の料金プラン',
              nextPaymentDate: '次の決済日',
              currentCycle: '現在のサイクル',
              nextCreditResetDate: 'Next credit reset date',
              nextSubscriptionType: '次の料金プラン',
            },
            question: {
              title: 'お問い合わせ',
              contentPre: '決済および返金に関するその他の質問は',
              contentLink: 'お問い合わせ',
              contentPost: 'タブをご利用いただけると幸いです。',
            },
          },
          subscriptionType: {
            FREE: 'FREE',
            BASIC: 'BASIC',
            PRO: 'PRO',
            PREMIUM: 'PREMIUM',
            BASIC_YEARLY: 'BASIC (YEARLY)',
            PRO_YEARLY: 'PRO (YEARLY)',
            PREMIUM_YEARLY: 'PREMIUM (YEARLY)',
          },
        },
        paymentModal: {
          title: '決済履歴',
          date: '日付',
          info: '情報',
          amount: '金額',
        },
      },
    },
  },
});

export default i18n;
